/* eslint-disable object-curly-spacing */
/* eslint-disable quote-props */
/* eslint-disable comma-spacing */
/* eslint-disable indent */
/* eslint-disable quotes */

export const cesiumToken = process.env.REACT_APP_CESIUM_TOKEN;
export const flatlick = {
    dateTime: '2025-06-21T12:00:00Z',
    buildings: [
        {
            name: 'James Wrenn House \n (McAtee\'s Tavern)',
            path: '/models/mcatees_tavern_2.glb',
            assetId: 3382542,
            lat: 38.8895393851,
            lon: -77.4208084351,
            height: 87.0854284976,
            heading: 0,
            showLabel: true
        },
        {
            name: 'E.W. Birch\'s Blacksmith Shop',
            path: '/models/birch_shop_cleaned.glb',
            assetId: 3397297,
            lat: 38.8904175061,
            lon: -77.4215748138,
            height: 87.7869417151,
            heading: 118,
            showLabel: true
        },
        {
            name: 'E.W. Birch House',
            path: '/models/birch_house_adjusted.glb',
            assetId: 3397297,
            lat: 38.8908260923,
            lon: -77.4221910522,
            height: 88.3,
            heading: 27,
            showLabel: true
        },
        {
            name: 'Birch Barn',
            path: '/models/red_barn.glb',
            assetId: 3397297,
            lat: 38.8913379,
            lon: -77.4221139,
            height: 88.3,
            heading: -153,
            showLabel: false
        },
        {
            name: 'Wrenn House',
            path: '/models/fairmount_second_empire_red.glb',
            assetId: 3397297,
            lat: 38.8903843,
            lon: -77.4222593,
            height: 88.3,
            heading: -63,
            scale: 0.9,
            showLabel: false
        },
        // {
        //     name: 'Birch Slave Cabin',
        //     path: '/models/wooden_cabin.glb',
        //     assetId: 3407753,
        //     lat: 38.890954328,
        //     lon: -77.422079258,
        //     height: 88.3,
        //     heading: -64,
        //     scale: 0.015,
        //     showLabel: false
        // },
        {
            name: 'Birch Slave Cabin 2',
            path: '/models/wooden_cabin.glb',
            assetId: 3407753,
            lat: 38.89124846,
            lon: -77.42190439,
            height: 88.3,
            heading: -64,
            scale: 0.015,
            showLabel: false
        },
        {
            name: 'Birch Barn',
            path: '/models/wooden_cabin.glb',
            assetId: 3407753,
            lat: 38.89107611,
            lon: -77.42211537,
            height: 87,
            heading: 26,
            scale: 0.017,
            showLabel: false
        },
        {
            name: 'Wrenn Barn',
            path: '/models/barn_lowpoly.glb',
            assetId: 3407753,
            lat: 38.89033880,
            lon: -77.42252258,
            height: 88.3,
            heading: 26,
            scale: 0.5,
            showLabel: false
        },
        {
            name: 'McAtee Barn',
            path: '/models/barn_lowpoly.glb',
            assetId: 3407753,
            lat: 38.88987677,
            lon: -77.42106730,
            height: 85,
            heading: -58,
            scale: 1,
            showLabel: false
        },
        {
            name: 'Chicken Coop',
            path: '/models/chicken_coop_simplified_2.glb',
            assetId: 3407753,
            lat: 38.88939994,
            lon: -77.42070458,
            height: 86,
            heading: -96,
            scale: 1.25,
            showLabel: false
        },
        // {
        //     name: 'Wrenn House',
        // ,-77.4221699 38.8902823,-77.4223993
        //     path: '/models/wrenn_house_flatlick.glb',
        //     assetId: 3397309,
        //     lat: 38.8901266137,
        //     lon: -77.4195256911,
        //     height: 87.1869632808,
        //     heading: 116
        // },
        // { name: 'Wrenn Store Stables', path: '', assetId: 3403483, lat: 38.8904190063, lon: -77.4222106934, height: 88.3748531481, heading: 0 },
        {
            name: 'Albert Wrenn\'s Store',
            path: '/models/downs_store_brightened_more.glb',
            assetId: 3407753,
            lat: 38.8902897958,
            lon: -77.4217282627,
            height: 88.1458818179,
            heading: -62,
            showLabel: true
        }
        // {
        //     name: 'Flatlick Slave Cabin',
        //     path: '/models/wooden_cabin.glb',
        //     assetId: 3407753,
        //     lat: 38.89019180,
        //     lon: -77.41953683,
        //     height: 87,
        //     heading: 26,
        //     scale: 0.010,
        //     showLabel: false
        // }
    ],
    misc: [
        { assetId: 3397344 },
        { assetId: 3397309, name: 'Davis "Flatlick" House' },
        { assetId: 5096646 }
    ],
    initCamera: {
        lat: -77.418681,
        lon: 38.889693,
        height: 152.2,
        heading: 280,
        pitch: -40.33,
        roll: 0.00
    },
    terrainAssetId: 3383109,
    imageryAssetId: 3397217,
    fences: [
        {
            points: [
                [38.88872200,-77.42124134],
                [38.88882108,-77.42136445],
                [38.88887335,-77.42142460],
                [38.88898605,-77.42156030],
                [38.88906390,-77.42165123],
                [38.88909766,-77.42169320],
                [38.88919293,-77.42180371],
                [38.88941289,-77.42206461],
                [38.88950163,-77.42217303],
                [38.88957730,-77.42227025],
                [38.88971559,-77.42243952],
                [38.88978909,-77.42250108],
                [38.88981903,-77.42250038],
                [38.88985279,-77.42248429],
                [38.88989416,-77.42245001],
                [38.89001013,-77.42235839],
                [38.89006185,-77.42232341],
                [38.89017400,-77.42224507],
                [38.89014024,-77.42215904],
                [38.89006783,-77.42197858],
                [38.89000305,-77.42182330],
                [38.89015494,-77.42171138],
                [38.89025240,-77.42164563],
                [38.89029541,-77.42160716]
            ]
        },
        {
            points: [
                [38.8906161,-77.4223878],
                [38.8904647,-77.4224871],
                [38.8903221,-77.4225710],
                [38.8901805,-77.4222507]
            ]
        },
        {
            points: [
                [38.8904517,-77.4189184],
                [38.8906128,-77.4193269],
                [38.8907729,-77.4197494],
                [38.8909307,-77.4201313],
                [38.8910571,-77.4204628],
                [38.8908099,-77.4206391],
                [38.8906302,-77.4207776],
                [38.8903656,-77.4209721],
                [38.8901784,-77.4211105]
            ]
        },
        {
            points: [
                [38.8904963,-77.4215834],
                [38.8907631,-77.4214379],
                [38.8909111,-77.4213547],
                [38.8910767,-77.4212567],
                [38.8911812,-77.4215001],
                [38.8913162,-77.4218233],
                [38.8910549,-77.4219772],
                [38.8909416,-77.4220499],
                [38.8908121,-77.4221227],
                [38.8907446,-77.4221548],
                [38.8907130,-77.4221576],
                [38.8906934,-77.4221437],
                [38.8906770,-77.4221269],
                [38.8906542,-77.4220681],
                [38.8906052,-77.4219086],
                [38.8904898,-77.4215883]
            ]
        }
    ],
    telegraph_positions:
    [
        {
          "lat": 38.89100121316327,
          "lon": -77.42322817126835,
          "scale": 0.02,
          "heading": 26.3
        },
        {
          "lat": 38.890735300425135,
          "lon": -77.42254211484382,
          "scale": 0.02,
          "heading": 26.3
        },
        {
          "lat": 38.89050763244301,
          "lon": -77.42197151444647,
          "scale": 0.02,
          "heading": 26.3
        },
        {
          "lat": 38.89020740735697,
          "lon": -77.42120988824209,
          "scale": 0.02,
          "heading": 26.3
        },
        {
          "lat": 38.88998663033899,
          "lon": -77.42062100200162,
          "scale": 0.02,
          "heading": 26.3
        },
        {
          "lat": 38.88973001156601,
          "lon": -77.4199610705827,
          "scale": 0.02,
          "heading": 26.3
        },
        {
          "lat": 38.889459770199046,
          "lon": -77.41923612836894,
          "scale": 0.02,
          "heading": 26.3
        },
        {
          "lat": 38.88913980309128,
          "lon": -77.41845285747128,
          "scale": 0.02,
          "heading": 26.3
        },
        {
          "lat": 38.888841454084236,
          "lon": -77.41767236413001,
          "scale": 0.02,
          "heading": 26.3
        }
    ],
    bush_positions: [
        {
          "lat": 38.8910499750878,
          "lon": -77.42322886537204,
          "scale": 1.165,
          "heading": 145.61
        },
        {
          "lat": 38.89103908668871,
          "lon": -77.42319249336148,
          "scale": 0.917,
          "heading": 58.54
        },
        {
          "lat": 38.89103037596823,
          "lon": -77.42317011058576,
          "scale": 1.063,
          "heading": 180.79
        },
        {
          "lat": 38.891017309885505,
          "lon": -77.42315612135096,
          "scale": 0.916,
          "heading": 120.22
        },
        {
          "lat": 38.89100424380039,
          "lon": -77.42309456871772,
          "scale": 1.126,
          "heading": 43.09
        },
        {
          "lat": 38.89098464466818,
          "lon": -77.4230470053193,
          "scale": 1.126,
          "heading": 135.85
        },
        {
          "lat": 38.89098682234981,
          "lon": -77.42307218594199,
          "scale": 0.998,
          "heading": 94.49
        },
        {
          "lat": 38.89096069016594,
          "lon": -77.42302742039054,
          "scale": 1.074,
          "heading": 300.23
        },
        {
          "lat": 38.89094544638758,
          "lon": -77.42296586775733,
          "scale": 1.162,
          "heading": 335.94
        },
        {
          "lat": 38.89093891333871,
          "lon": -77.42293229359375,
          "scale": 0.948,
          "heading": 29.96
        },
        {
          "lat": 38.89090842576936,
          "lon": -77.42291830435892,
          "scale": 1.053,
          "heading": 6.31
        },
        {
          "lat": 38.89088229355665,
          "lon": -77.42282597540907,
          "scale": 1.0,
          "heading": 106.46
        },
        {
          "lat": 38.89087576050197,
          "lon": -77.4227672206228,
          "scale": 1.101,
          "heading": 300.36
        },
        {
          "lat": 38.89084091753353,
          "lon": -77.42269447660172,
          "scale": 0.954,
          "heading": 17.8
        },
        {
          "lat": 38.89081914066957,
          "lon": -77.42266649813206,
          "scale": 1.077,
          "heading": 168.82
        },
        {
          "lat": 38.89081914066957,
          "lon": -77.42264971105027,
          "scale": 1.162,
          "heading": 50.94
        },
        {
          "lat": 38.8908017191736,
          "lon": -77.42261333903973,
          "scale": 0.94,
          "heading": 48.25
        },
        {
          "lat": 38.89078429767336,
          "lon": -77.42258256272312,
          "scale": 1.159,
          "heading": 97.39
        },
        {
          "lat": 38.89078429767336,
          "lon": -77.42254898855954,
          "scale": 1.02,
          "heading": 87.06
        },
        {
          "lat": 38.89077340923353,
          "lon": -77.42256017994738,
          "scale": 1.036,
          "heading": 0.21
        },
        {
          "lat": 38.89060137166282,
          "lon": -77.42239230912949,
          "scale": 1.143,
          "heading": 248.5
        },
        {
          "lat": 38.89058177241946,
          "lon": -77.42240350051735,
          "scale": 1.052,
          "heading": 130.52
        },
        {
          "lat": 38.890573061642904,
          "lon": -77.42243147898701,
          "scale": 1.048,
          "heading": 323.86
        },
        {
          "lat": 38.89055781778135,
          "lon": -77.42241189405826,
          "scale": 0.946,
          "heading": 240.27
        },
        {
          "lat": 38.89050555308834,
          "lon": -77.42245106391576,
          "scale": 0.911,
          "heading": 120.07
        },
        {
          "lat": 38.89049248690907,
          "lon": -77.42247064884451,
          "scale": 1.083,
          "heading": 287.89
        },
        {
          "lat": 38.89044022216799,
          "lon": -77.42250981870203,
          "scale": 1.015,
          "heading": 78.21
        },
        {
          "lat": 38.890466354543335,
          "lon": -77.42249023377326,
          "scale": 1.163,
          "heading": 60.05
        },
        {
          "lat": 38.890392312788215,
          "lon": -77.42253220147774,
          "scale": 0.947,
          "heading": 237.32
        },
        {
          "lat": 38.89037706888787,
          "lon": -77.42254059501863,
          "scale": 1.185,
          "heading": 307.36
        },
        {
          "lat": 38.89030956014703,
          "lon": -77.42254619071257,
          "scale": 1.079,
          "heading": 10.18
        },
        {
          "lat": 38.890287783120165,
          "lon": -77.42247904238542,
          "scale": 0.963,
          "heading": 109.83
        },
        {
          "lat": 38.8902725391974,
          "lon": -77.42244546822184,
          "scale": 1.026,
          "heading": 183.95
        },
        {
          "lat": 38.890200674945966,
          "lon": -77.42227200170998,
          "scale": 1.095,
          "heading": 289.49
        },
        {
          "lat": 38.89021809658935,
          "lon": -77.42228599094481,
          "scale": 1.153,
          "heading": 282.2
        },
        {
          "lat": 38.890255117567364,
          "lon": -77.4223839155886,
          "scale": 1.163,
          "heading": 8.02
        },
        {
          "lat": 38.89023769593306,
          "lon": -77.42234474573108,
          "scale": 1.135,
          "heading": 66.13
        },
        {
          "lat": 38.890159298525795,
          "lon": -77.42221044907677,
          "scale": 1.018,
          "heading": 267.88
        },
        {
          "lat": 38.89055128469682,
          "lon": -77.4213207337419,
          "scale": 0.935,
          "heading": 89.78
        },
        {
          "lat": 38.89054257391653,
          "lon": -77.4212871595783,
          "scale": 1.155,
          "heading": 317.91
        },
        {
          "lat": 38.890533863135154,
          "lon": -77.42130674450705,
          "scale": 1.025,
          "heading": 133.08
        },
        {
          "lat": 38.890525152352716,
          "lon": -77.42122560694509,
          "scale": 1.115,
          "heading": 336.49
        },
        {
          "lat": 38.890444577564544,
          "lon": -77.42102975765752,
          "scale": 1.175,
          "heading": 221.9
        },
        {
          "lat": 38.89058830550118,
          "lon": -77.42138228637512,
          "scale": 0.945,
          "heading": 104.72
        },
        {
          "lat": 38.89058830550118,
          "lon": -77.4214074669978,
          "scale": 0.992,
          "heading": 291.97
        },
        {
          "lat": 38.889516872067865,
          "lon": -77.42219086414802,
          "scale": 1.187,
          "heading": 109.87
        },
        {
          "lat": 38.88950598343375,
          "lon": -77.42217687491319,
          "scale": 1.052,
          "heading": 245.91
        },
        {
          "lat": 38.88903559284688,
          "lon": -77.42161730552019,
          "scale": 1.161,
          "heading": 265.9
        },
        {
          "lat": 38.888857017826886,
          "lon": -77.42140466915085,
          "scale": 1.196,
          "heading": 272.49
        },
        {
          "lat": 38.888774263397096,
          "lon": -77.42113887368916,
          "scale": 1.081,
          "heading": 51.84
        },
        {
          "lat": 38.88878732989244,
          "lon": -77.42113048014826,
          "scale": 0.942,
          "heading": 9.36
        },
        {
          "lat": 38.88883524035471,
          "lon": -77.42103255550448,
          "scale": 1.126,
          "heading": 77.92
        },
        {
          "lat": 38.888830884859466,
          "lon": -77.42103815119843,
          "scale": 0.9,
          "heading": 242.06
        },
        {
          "lat": 38.88886355106723,
          "lon": -77.42072199449137,
          "scale": 1.152,
          "heading": 36.77
        },
        {
          "lat": 38.88887226205343,
          "lon": -77.42071360095048,
          "scale": 0.927,
          "heading": 289.96
        },
        {
          "lat": 38.88892670569298,
          "lon": -77.42062686769457,
          "scale": 1.104,
          "heading": 133.56
        },
        {
          "lat": 38.8889963934907,
          "lon": -77.42048417749933,
          "scale": 0.941,
          "heading": 44.13
        },
        {
          "lat": 38.889005104460615,
          "lon": -77.42046739041756,
          "scale": 1.181,
          "heading": 181.81
        },
        {
          "lat": 38.88911834697222,
          "lon": -77.42040863563129,
          "scale": 0.969,
          "heading": 341.66
        },
        {
          "lat": 38.88911616923331,
          "lon": -77.42043661410095,
          "scale": 1.074,
          "heading": 279.2
        },
        {
          "lat": 38.889105280537784,
          "lon": -77.42043941194792,
          "scale": 1.109,
          "heading": 149.8
        },
        {
          "lat": 38.889107458277024,
          "lon": -77.42041702917219,
          "scale": 1.022,
          "heading": 76.01
        },
        {
          "lat": 38.888166668710305,
          "lon": -77.42154735934606,
          "scale": 1.123,
          "heading": 287.82
        },
        {
          "lat": 38.88919456779184,
          "lon": -77.42027713682396,
          "scale": 0.907,
          "heading": 36.79
        },
        {
          "lat": 38.88919456779184,
          "lon": -77.42025475404823,
          "scale": 0.918,
          "heading": 106.18
        },
        {
          "lat": 38.88946460660894,
          "lon": -77.41980709853384,
          "scale": 1.155,
          "heading": 282.57
        },
        {
          "lat": 38.88945807342387,
          "lon": -77.41982108776867,
          "scale": 1.014,
          "heading": 16.22
        },
        {
          "lat": 38.889479850705094,
          "lon": -77.4197763222172,
          "scale": 0.936,
          "heading": 99.02
        },
        {
          "lat": 38.889512516614424,
          "lon": -77.4197539394415,
          "scale": 1.168,
          "heading": 322.57
        },
        {
          "lat": 38.88978473194131,
          "lon": -77.41915240234401,
          "scale": 1.157,
          "heading": 316.9
        },
        {
          "lat": 38.88977384334826,
          "lon": -77.41916359373187,
          "scale": 0.995,
          "heading": 16.55
        },
        {
          "lat": 38.88985006346453,
          "lon": -77.41896494659737,
          "scale": 1.023,
          "heading": 128.57
        },
        {
          "lat": 38.88986530747797,
          "lon": -77.4189369681277,
          "scale": 1.027,
          "heading": 319.43
        },
        {
          "lat": 38.889926283499015,
          "lon": -77.41885862841269,
          "scale": 1.118,
          "heading": 88.62
        },
        {
          "lat": 38.8899502383501,
          "lon": -77.41885023487178,
          "scale": 0.923,
          "heading": 253.51
        },
        {
          "lat": 38.88997419319312,
          "lon": -77.41883344778999,
          "scale": 0.97,
          "heading": 295.09
        },
        {
          "lat": 38.88990450635465,
          "lon": -77.41891178750502,
          "scale": 1.129,
          "heading": 180.9
        },
        {
          "lat": 38.88942322976001,
          "lon": -77.41905447770023,
          "scale": 0.935,
          "heading": 260.41
        },
        {
          "lat": 38.8894254074895,
          "lon": -77.41904328631237,
          "scale": 1.016,
          "heading": 311.78
        },
        {
          "lat": 38.889410163381655,
          "lon": -77.41898173367915,
          "scale": 0.968,
          "heading": 163.71
        },
        {
          "lat": 38.88940145246142,
          "lon": -77.4189621487504,
          "scale": 0.999,
          "heading": 54.22
        },
        {
          "lat": 38.88939274154012,
          "lon": -77.41895095736253,
          "scale": 1.07,
          "heading": 311.34
        },
        {
          "lat": 38.88937531969431,
          "lon": -77.41890059611715,
          "scale": 0.932,
          "heading": 230.54
        },
        {
          "lat": 38.889370964232185,
          "lon": -77.41888660688234,
          "scale": 1.053,
          "heading": 43.68
        },
        {
          "lat": 38.889370964232185,
          "lon": -77.41885862841269,
          "scale": 0.989,
          "heading": 59.33
        },
        {
          "lat": 38.88933394279337,
          "lon": -77.41883624563695,
          "scale": 1.143,
          "heading": 209.97
        },
        {
          "lat": 38.88930781000142,
          "lon": -77.41876629946283,
          "scale": 0.942,
          "heading": 303.57
        },
        {
          "lat": 38.88930781000142,
          "lon": -77.41874951238105,
          "scale": 1.099,
          "heading": 221.24
        },
        {
          "lat": 38.88929474360184,
          "lon": -77.41872433175837,
          "scale": 1.107,
          "heading": 211.44
        },
        {
          "lat": 38.889259899857855,
          "lon": -77.41865998127817,
          "scale": 1.029,
          "heading": 334.29
        },
        {
          "lat": 38.88924247797946,
          "lon": -77.41862920496155,
          "scale": 1.189,
          "heading": 212.64
        },
        {
          "lat": 38.88924247797946,
          "lon": -77.41859003510403,
          "scale": 1.011,
          "heading": 62.24
        },
        {
          "lat": 38.88924247797946,
          "lon": -77.41857324802224,
          "scale": 1.185,
          "heading": 168.22
        },
        {
          "lat": 38.88922941156786,
          "lon": -77.41854247170562,
          "scale": 1.001,
          "heading": 246.25
        },
        {
          "lat": 38.88920981194596,
          "lon": -77.41851449323599,
          "scale": 1.193,
          "heading": 248.79
        },
        {
          "lat": 38.88917279042315,
          "lon": -77.4184641319906,
          "scale": 1.091,
          "heading": 9.73
        },
        {
          "lat": 38.89042497827793,
          "lon": -77.42099058780005,
          "scale": 0.92,
          "heading": 80.69
        },
        {
          "lat": 38.89168149937953,
          "lon": -77.42090105669716,
          "scale": 1.072,
          "heading": 285.19
        },
        {
          "lat": 38.89163576849871,
          "lon": -77.42092623731985,
          "scale": 1.111,
          "heading": 206.25
        },
        {
          "lat": 38.89234568266276,
          "lon": -77.42050656027509,
          "scale": 0.935,
          "heading": 21.17
        },
        {
          "lat": 38.89106957420197,
          "lon": -77.42126197895566,
          "scale": 0.937,
          "heading": 323.89
        },
        {
          "lat": 38.89104126436866,
          "lon": -77.42126477680262,
          "scale": 0.969,
          "heading": 74.96
        },
        {
          "lat": 38.89148333201664,
          "lon": -77.42269167875479,
          "scale": 1.09,
          "heading": 48.16
        },
        {
          "lat": 38.891576971608664,
          "lon": -77.422993846227,
          "scale": 1.189,
          "heading": 162.08
        },
        {
          "lat": 38.8915878599253,
          "lon": -77.42299944192092,
          "scale": 1.163,
          "heading": 59.42
        },
        {
          "lat": 38.891788204653615,
          "lon": -77.42297426129825,
          "scale": 1.148,
          "heading": 143.07
        },
        {
          "lat": 38.89004823538406,
          "lon": -77.42179356987901,
          "scale": 0.948,
          "heading": 351.0
        },
        {
          "lat": 38.89072332238884,
          "lon": -77.41962523848113,
          "scale": 0.952,
          "heading": 293.45
        },
        {
          "lat": 38.89070590086936,
          "lon": -77.41959166431755,
          "scale": 1.079,
          "heading": 121.24
        },
        {
          "lat": 38.89051861926518,
          "lon": -77.41911043463956,
          "scale": 0.947,
          "heading": 106.96
        },
        {
          "lat": 38.89175118447463,
          "lon": -77.41886422410664,
          "scale": 0.957,
          "heading": 298.35
        },
        {
          "lat": 38.891825224813275,
          "lon": -77.4188922025763,
          "scale": 0.938,
          "heading": 224.86
        },
        {
          "lat": 38.889830464013855,
          "lon": -77.41791295613855,
          "scale": 1.189,
          "heading": 6.58
        },
        {
          "lat": 38.889808686840105,
          "lon": -77.41795212599605,
          "scale": 1.066,
          "heading": 134.42
        },
        {
          "lat": 38.889704156313215,
          "lon": -77.41782902072958,
          "scale": 0.901,
          "heading": 299.99
        },
        {
          "lat": 38.889704156313215,
          "lon": -77.41781782934174,
          "scale": 0.977,
          "heading": 170.04
        },
        {
          "lat": 38.88971286719633,
          "lon": -77.41776746809636,
          "scale": 1.198,
          "heading": 30.76
        },
        {
          "lat": 38.88963446920984,
          "lon": -77.4179241475264,
          "scale": 1.08,
          "heading": 214.31
        },
        {
          "lat": 38.88968673454378,
          "lon": -77.41791855183247,
          "scale": 1.017,
          "heading": 345.97
        },
        {
          "lat": 38.889704156313215,
          "lon": -77.41787938197497,
          "scale": 1.144,
          "heading": 114.38
        }
    ],
    woods_tree_positions: [
        {
            'lat': 38.89228595957361,
            'lon': -77.41909474057874,
            'scale': 0.938,
            'heading': 356.84731991969153
        },
        {
            'lat': 38.89235200116388,
            'lon': -77.41850791994959,
            'scale': 1.032,
            'heading': 32.52665198054033
        },
        {
            'lat': 38.8922589192349,
            'lon': -77.41921829375562,
            'scale': 0.841,
            'heading': 132.4353151596032
        },
        {
            'lat': 38.89208529040219,
            'lon': -77.41846852147118,
            'scale': 1.172,
            'heading': 84.42211989332517
        },
        {
            'lat': 38.88952400671726,
            'lon': -77.41819182639362,
            'scale': 0.981,
            'heading': 61.83064090246189
        },
        {
            'lat': 38.890435796644134,
            'lon': -77.41856877489171,
            'scale': 1.082,
            'heading': 295.20120052537874
        },
        {
            'lat': 38.89216270911624,
            'lon': -77.41849717023231,
            'scale': 0.916,
            'heading': 150.3890666969051
        },
        {
            'lat': 38.891055001066626,
            'lon': -77.41811820380956,
            'scale': 1.085,
            'heading': 207.80495436070936
        },
        {
            'lat': 38.891316422497034,
            'lon': -77.41879748864271,
            'scale': 1.117,
            'heading': 176.2412064123899
        },
        {
            'lat': 38.891430144966904,
            'lon': -77.41875753334703,
            'scale': 0.917,
            'heading': 207.57221842313882
        },
        {
            'lat': 38.88984313528446,
            'lon': -77.41841251161044,
            'scale': 1.19,
            'heading': 290.44861089821904
        },
        {
            'lat': 38.891944166142174,
            'lon': -77.41891220091199,
            'scale': 1.113,
            'heading': 66.51440997592938
        },
        {
            'lat': 38.892178672448594,
            'lon': -77.41851983793875,
            'scale': 0.897,
            'heading': 161.4918247208281
        },
        {
            'lat': 38.8900847540512,
            'lon': -77.41866112130334,
            'scale': 1.038,
            'heading': 277.1727776461857
        },
        {
            'lat': 38.89095692454843,
            'lon': -77.41846576604004,
            'scale': 1.155,
            'heading': 313.00483403637435
        },
        {
            'lat': 38.891290041988555,
            'lon': -77.41871798514464,
            'scale': 0.964,
            'heading': 231.66984414241327
        },
        {
            'lat': 38.89226375672297,
            'lon': -77.41906802490189,
            'scale': 0.886,
            'heading': 199.00689333575278
        },
        {
            'lat': 38.89006490999401,
            'lon': -77.41883613603586,
            'scale': 1.191,
            'heading': 350.651123922254
        },
        {
            'lat': 38.89005365704184,
            'lon': -77.41771684133782,
            'scale': 1.038,
            'heading': 349.06899769355806
        },
        {
            'lat': 38.890327472047474,
            'lon': -77.41843200606395,
            'scale': 0.995,
            'heading': 78.38616584236374
        },
        {
            'lat': 38.88998332058753,
            'lon': -77.41846046896096,
            'scale': 0.929,
            'heading': 116.39403858103866
        },
        {
            'lat': 38.891122250887605,
            'lon': -77.41842642305994,
            'scale': 0.882,
            'heading': 27.840668454292768
        },
        {
            'lat': 38.891781994643885,
            'lon': -77.41782792302673,
            'scale': 1.049,
            'heading': 11.277591064605277
        },
        {
            'lat': 38.892184153028566,
            'lon': -77.41788962287256,
            'scale': 1.04,
            'heading': 351.3226198026902
        },
        {
            'lat': 38.8918076744586,
            'lon': -77.41872785113952,
            'scale': 1.047,
            'heading': 266.6391754939259
        },
        {
            'lat': 38.891691712142,
            'lon': -77.41821988553674,
            'scale': 0.912,
            'heading': 127.00489016966335
        },
        {
            'lat': 38.89216275190881,
            'lon': -77.4181233760012,
            'scale': 0.97,
            'heading': 40.942840009289
        },
        {
            'lat': 38.890521598573166,
            'lon': -77.41837957068898,
            'scale': 0.811,
            'heading': 197.9595899304846
        },
        {
            'lat': 38.88955364736187,
            'lon': -77.41929718446595,
            'scale': 0.997,
            'heading': 245.87192889572427
        },
        {
            'lat': 38.89048949859816,
            'lon': -77.41810195515278,
            'scale': 0.808,
            'heading': 332.8363381551954
        },
        {
            'lat': 38.890876974525774,
            'lon': -77.41856795278358,
            'scale': 0.846,
            'heading': 112.99890314831676
        },
        {
            'lat': 38.8909530842151,
            'lon': -77.41814500184783,
            'scale': 0.908,
            'heading': 359.42250742332055
        },
        {
            'lat': 38.891901264291484,
            'lon': -77.41784560514527,
            'scale': 0.946,
            'heading': 255.53920605032343
        },
        {
            'lat': 38.89030567653204,
            'lon': -77.41812865942262,
            'scale': 1.052,
            'heading': 274.5563969283913
        },
        {
            'lat': 38.892147418101594,
            'lon': -77.41835551346767,
            'scale': 1.15,
            'heading': 100.50088998448611
        },
        {
            'lat': 38.89012303985259,
            'lon': -77.4180586763351,
            'scale': 1.158,
            'heading': 88.02035217375762
        },
        {
            'lat': 38.89053865448886,
            'lon': -77.41863643472337,
            'scale': 0.92,
            'heading': 352.0366799026296
        },
        {
            'lat': 38.89070193812945,
            'lon': -77.4179987329685,
            'scale': 0.815,
            'heading': 327.5922802622267
        },
        {
            'lat': 38.89037408783074,
            'lon': -77.41854865137414,
            'scale': 0.811,
            'heading': 177.34702647121733
        },
        {
            'lat': 38.89165226992741,
            'lon': -77.41856854232036,
            'scale': 0.916,
            'heading': 346.7488683010468
        },
        {
            'lat': 38.89174195640492,
            'lon': -77.4183464066966,
            'scale': 1.117,
            'heading': 103.10286468790302
        },
        {
            'lat': 38.892165976539424,
            'lon': -77.41786623292631,
            'scale': 1.197,
            'heading': 128.282697481175
        },
        {
            'lat': 38.88949888623152,
            'lon': -77.41926774485253,
            'scale': 1.105,
            'heading': 197.24275947890538
        },
        {
            'lat': 38.89060033452485,
            'lon': -77.41816448809219,
            'scale': 0.87,
            'heading': 130.152488860557
        },
        {
            'lat': 38.890954910659254,
            'lon': -77.41802525489292,
            'scale': 0.938,
            'heading': 27.798672564580325
        },
        {
            'lat': 38.88997788086675,
            'lon': -77.41838755013642,
            'scale': 0.837,
            'heading': 325.5541030772387
        },
        {
            'lat': 38.891749820276964,
            'lon': -77.41858722690029,
            'scale': 0.9,
            'heading': 251.29663721571796
        },
        {
            'lat': 38.888533447989694,
            'lon': -77.42105223489216,
            'scale': 0.911,
            'heading': 18.48641749308019
        },
        {
            'lat': 38.891826341366844,
            'lon': -77.41786303258854,
            'scale': 1.046,
            'heading': 63.939240424637774
        },
        {
            'lat': 38.890487454802795,
            'lon': -77.41891988729463,
            'scale': 0.932,
            'heading': 225.8794854464343
        },
        {
            'lat': 38.89024488117657,
            'lon': -77.41849227777331,
            'scale': 0.89,
            'heading': 358.44954608550466
        },
        {
            'lat': 38.892068877704105,
            'lon': -77.41828485630782,
            'scale': 0.917,
            'heading': 158.68788952053796
        },
        {
            'lat': 38.89019621516643,
            'lon': -77.41824090905247,
            'scale': 0.852,
            'heading': 137.43979433113864
        },
        {
            'lat': 38.88857722696563,
            'lon': -77.42090471104548,
            'scale': 1.067,
            'heading': 289.51151164094364
        },
        {
            'lat': 38.890752174566394,
            'lon': -77.41812410179926,
            'scale': 1.19,
            'heading': 38.9254320842089
        },
        {
            'lat': 38.89094200895558,
            'lon': -77.41856951704905,
            'scale': 1.052,
            'heading': 178.34567842659126
        },
        {
            'lat': 38.89165842367598,
            'lon': -77.41862315538496,
            'scale': 1.061,
            'heading': 232.87690038317794
        },
        {
            'lat': 38.89009653336379,
            'lon': -77.41817335271551,
            'scale': 1.028,
            'heading': 167.65864276658763
        },
        {
            'lat': 38.89023043248002,
            'lon': -77.41786282035835,
            'scale': 1.138,
            'heading': 42.37618902815009
        },
        {
            'lat': 38.892372705863885,
            'lon': -77.41904212445569,
            'scale': 1.075,
            'heading': 138.45906895081055
        },
        {
            'lat': 38.891416671001,
            'lon': -77.418583208843,
            'scale': 0.988,
            'heading': 313.11882676031286
        },
        {
            'lat': 38.89175314951733,
            'lon': -77.41785443795627,
            'scale': 0.989,
            'heading': 114.07011937818643
        },
        {
            'lat': 38.890791812851845,
            'lon': -77.41892757545902,
            'scale': 0.815,
            'heading': 45.32253921431723
        },
        {
            'lat': 38.890333153145,
            'lon': -77.41797869255441,
            'scale': 0.854,
            'heading': 262.9877293159633
        },
        {
            'lat': 38.88964342047869,
            'lon': -77.41861894684159,
            'scale': 0.854,
            'heading': 351.18885447572154
        },
        {
            'lat': 38.89227975021928,
            'lon': -77.41914729261148,
            'scale': 0.907,
            'heading': 78.45135780314595
        },
        {
            'lat': 38.891964305587656,
            'lon': -77.41845162802328,
            'scale': 0.901,
            'heading': 65.68625867436744
        },
        {
            'lat': 38.888272053278435,
            'lon': -77.42115433196065,
            'scale': 1.034,
            'heading': 295.145727897401
        },
        {
            'lat': 38.89105460107983,
            'lon': -77.41892148410376,
            'scale': 0.811,
            'heading': 146.52130897939477
        },
        {
            'lat': 38.89124127708047,
            'lon': -77.41815290121237,
            'scale': 1.021,
            'heading': 284.3403934279793
        },
        {
            'lat': 38.89052392423904,
            'lon': -77.41823639997054,
            'scale': 1.124,
            'heading': 159.89619649505275
        },
        {
            'lat': 38.891129064767384,
            'lon': -77.41809240110094,
            'scale': 0.847,
            'heading': 286.6541357123699
        },
        {
            'lat': 38.89124929049696,
            'lon': -77.41847156640769,
            'scale': 1.079,
            'heading': 342.80298632625363
        },
        {
            'lat': 38.88966442408769,
            'lon': -77.41893067298955,
            'scale': 0.891,
            'heading': 292.8290289337272
        },
        {
            'lat': 38.8917463761508,
            'lon': -77.4186256363483,
            'scale': 0.956,
            'heading': 316.9774835249578
        },
        {
            'lat': 38.890986210717884,
            'lon': -77.41846237034105,
            'scale': 0.981,
            'heading': 87.77611796578567
        },
        {
            'lat': 38.889854143275244,
            'lon': -77.41767030112278,
            'scale': 0.819,
            'heading': 17.71917809917962
        },
        {
            'lat': 38.89115857306209,
            'lon': -77.41866977291626,
            'scale': 0.92,
            'heading': 244.58615384268793
        },
        {
            'lat': 38.89077015236489,
            'lon': -77.41829379324015,
            'scale': 0.919,
            'heading': 224.89191968950377
        },
        {
            'lat': 38.890743790391404,
            'lon': -77.41881652898098,
            'scale': 1.159,
            'heading': 161.7775217644847
        },
        {
            'lat': 38.89045256538531,
            'lon': -77.41837446830723,
            'scale': 1.061,
            'heading': 246.34039967904454
        },
        {
            'lat': 38.89186617467479,
            'lon': -77.41771388063901,
            'scale': 0.81,
            'heading': 57.99954607269349
        },
        {
            'lat': 38.88999692742505,
            'lon': -77.41879873335368,
            'scale': 1.047,
            'heading': 123.61243731847705
        },
        {
            'lat': 38.8916294119448,
            'lon': -77.41804869812198,
            'scale': 0.84,
            'heading': 256.24094660961146
        },
        {
            'lat': 38.890582630157965,
            'lon': -77.41887148604177,
            'scale': 0.933,
            'heading': 90.35146052566786
        },
        {
            'lat': 38.89089454143354,
            'lon': -77.41821998218693,
            'scale': 0.827,
            'heading': 204.8895409139636
        },
        {
            'lat': 38.89238627391368,
            'lon': -77.41833111852537,
            'scale': 0.834,
            'heading': 88.42303472155857
        },
        {
            'lat': 38.88851235780621,
            'lon': -77.42114115290806,
            'scale': 0.881,
            'heading': 45.76302699918441
        },
        {
            'lat': 38.89041520875807,
            'lon': -77.41821331125576,
            'scale': 1.003,
            'heading': 184.67687900297014
        },
        {
            'lat': 38.8904288254654,
            'lon': -77.41889929340778,
            'scale': 1.108,
            'heading': 224.8943653623148
        },
        {
            'lat': 38.89173197946646,
            'lon': -77.41885497144989,
            'scale': 0.937,
            'heading': 257.7090325841798
        },
        {
            'lat': 38.89026970205674,
            'lon': -77.41864027464268,
            'scale': 0.979,
            'heading': 203.94063490772996
        },
        {
            'lat': 38.88996229252577,
            'lon': -77.418502565815,
            'scale': 1.194,
            'heading': 125.51622954778544
        },
        {
            'lat': 38.88955636145256,
            'lon': -77.41845644250384,
            'scale': 0.832,
            'heading': 146.53683501168553
        },
        {
            'lat': 38.888414832108836,
            'lon': -77.42123359672938,
            'scale': 0.857,
            'heading': 311.30193017400865
        },
        {
            'lat': 38.89014777829776,
            'lon': -77.41767542243119,
            'scale': 0.821,
            'heading': 245.3262023851346
        },
        {
            'lat': 38.890534332232924,
            'lon': -77.41823124554452,
            'scale': 1.149,
            'heading': 156.98229835102035
        },
        {
            'lat': 38.890789820538245,
            'lon': -77.41836689313187,
            'scale': 1.043,
            'heading': 284.2084372165218
        },
        {
            'lat': 38.89144581328458,
            'lon': -77.41862545853375,
            'scale': 0.904,
            'heading': 25.09124563540724
        },
        {
            'lat': 38.89170493793657,
            'lon': -77.4188888023307,
            'scale': 0.927,
            'heading': 2.463742097513588
        },
        {
            'lat': 38.89186273544775,
            'lon': -77.41832471345668,
            'scale': 1.07,
            'heading': 78.34535646598256
        },
        {
            'lat': 38.8909595890126,
            'lon': -77.41884109860106,
            'scale': 0.95,
            'heading': 266.9983715851441
        },
        {
            'lat': 38.89081258935386,
            'lon': -77.41877253866838,
            'scale': 0.917,
            'heading': 164.6457559042005
        },
        {
            'lat': 38.891961796559976,
            'lon': -77.41802186586855,
            'scale': 1.135,
            'heading': 184.07594639705474
        },
        {
            'lat': 38.89008536869292,
            'lon': -77.41827362007392,
            'scale': 1.026,
            'heading': 241.1217864912387
        },
        {
            'lat': 38.89056876144437,
            'lon': -77.41807772915904,
            'scale': 0.813,
            'heading': 142.7795224493806
        },
        {
            'lat': 38.88988147121153,
            'lon': -77.41810841548963,
            'scale': 0.967,
            'heading': 76.25485334939854
        },
        {
            'lat': 38.890512143471014,
            'lon': -77.41851750040189,
            'scale': 0.855,
            'heading': 180.0665188870733
        },
        {
            'lat': 38.88958006244864,
            'lon': -77.4186219470668,
            'scale': 1.138,
            'heading': 103.66547830418082
        },
        {
            'lat': 38.890639978300335,
            'lon': -77.41844038538744,
            'scale': 1.062,
            'heading': 357.4988753448136
        },
        {
            'lat': 38.89111267303481,
            'lon': -77.41849997640328,
            'scale': 0.852,
            'heading': 318.08857320738537
        },
        {
            'lat': 38.89132992820215,
            'lon': -77.41882480669683,
            'scale': 1.192,
            'heading': 225.5144478332941
        },
        {
            'lat': 38.8898901782888,
            'lon': -77.41852840129324,
            'scale': 0.839,
            'heading': 265.07415269242995
        },
        {
            'lat': 38.889438429087384,
            'lon': -77.41903630233494,
            'scale': 1.181,
            'heading': 158.75170231358254
        },
        {
            'lat': 38.890988973078194,
            'lon': -77.4181835845088,
            'scale': 0.881,
            'heading': 274.4999827195416
        },
        {
            'lat': 38.88825524703834,
            'lon': -77.4208166666961,
            'scale': 1.152,
            'heading': 226.42202565679258
        },
        {
            'lat': 38.89142885805094,
            'lon': -77.41820992225678,
            'scale': 1.183,
            'heading': 355.47072081526636
        },
        {
            'lat': 38.890565303937976,
            'lon': -77.41883434304353,
            'scale': 0.877,
            'heading': 351.55175654088504
        },
        {
            'lat': 38.891863921700896,
            'lon': -77.41841441365443,
            'scale': 1.047,
            'heading': 69.74559019037957
        },
        {
            'lat': 38.89183986813859,
            'lon': -77.41846510940711,
            'scale': 1.069,
            'heading': 213.3860668492445
        },
        {
            'lat': 38.89132590094415,
            'lon': -77.41837315984083,
            'scale': 1.063,
            'heading': 202.50228636499878
        },
        {
            'lat': 38.89222390000218,
            'lon': -77.4177769646635,
            'scale': 1.104,
            'heading': 77.09841319235613
        },
        {
            'lat': 38.89037713671735,
            'lon': -77.41853089387111,
            'scale': 1.183,
            'heading': 340.34372948431064
        },
        {
            'lat': 38.892112582880245,
            'lon': -77.41872857989542,
            'scale': 0.833,
            'heading': 314.0048084238955
        },
        {
            'lat': 38.88849298555026,
            'lon': -77.42126811676134,
            'scale': 0.808,
            'heading': 12.4606687994173
        },
        {
            'lat': 38.890974582357345,
            'lon': -77.41885681174789,
            'scale': 1.2,
            'heading': 49.92937321136105
        },
        {
            'lat': 38.88970223568236,
            'lon': -77.41883502862412,
            'scale': 1.121,
            'heading': 343.1888812217655
        },
        {
            'lat': 38.89082743350083,
            'lon': -77.41824317502271,
            'scale': 0.888,
            'heading': 166.557835122563
        },
        {
            'lat': 38.8884919671281,
            'lon': -77.42106494046055,
            'scale': 0.841,
            'heading': 73.9399901653592
        },
        {
            'lat': 38.88830630299463,
            'lon': -77.42145796300652,
            'scale': 0.865,
            'heading': 275.8986666488347
        },
        {
            'lat': 38.89190224380794,
            'lon': -77.41829439917424,
            'scale': 1.045,
            'heading': 43.453404621247245
        },
        {
            'lat': 38.89038286186077,
            'lon': -77.41838106998024,
            'scale': 1.149,
            'heading': 305.88792268455677
        },
        {
            'lat': 38.88870733432005,
            'lon': -77.42096284289661,
            'scale': 1.164,
            'heading': 24.84283688893191
        },
        {
            'lat': 38.89136683373861,
            'lon': -77.41821628972784,
            'scale': 0.892,
            'heading': 344.4437035671563
        },
        {
            'lat': 38.89124831560665,
            'lon': -77.41804126665849,
            'scale': 1.113,
            'heading': 133.3928306205218
        },
        {
            'lat': 38.8915395047985,
            'lon': -77.4188041963498,
            'scale': 0.865,
            'heading': 153.53152322197815
        },
        {
            'lat': 38.892401334715366,
            'lon': -77.41794475049946,
            'scale': 1.054,
            'heading': 109.07615675412032
        },
        {
            'lat': 38.890023556601776,
            'lon': -77.41804810817445,
            'scale': 0.995,
            'heading': 84.8131936545043
        },
        {
            'lat': 38.89062359695573,
            'lon': -77.41808896741846,
            'scale': 0.977,
            'heading': 234.75556395858084
        },
        {
            'lat': 38.89231491812698,
            'lon': -77.41808549500102,
            'scale': 0.932,
            'heading': 81.0294546076272
        },
        {
            'lat': 38.889863531322995,
            'lon': -77.41853965160891,
            'scale': 1.117,
            'heading': 111.28836395019007
        },
        {
            'lat': 38.88847783788866,
            'lon': -77.4209499112791,
            'scale': 1.157,
            'heading': 240.72213218900038
        },
        {
            'lat': 38.89221420745308,
            'lon': -77.41809980198865,
            'scale': 1.037,
            'heading': 125.23994754463556
        },
        {
            'lat': 38.88962297784813,
            'lon': -77.4183011410641,
            'scale': 1.185,
            'heading': 351.91210553926476
        },
        {
            'lat': 38.88845197919061,
            'lon': -77.42124194347075,
            'scale': 1.192,
            'heading': 267.85363688656577
        },
        {
            'lat': 38.89029133750937,
            'lon': -77.41852686419804,
            'scale': 0.989,
            'heading': 44.83658347366251
        },
        {
            'lat': 38.889493671902684,
            'lon': -77.41923579830059,
            'scale': 0.877,
            'heading': 352.18099331704735
        },
        {
            'lat': 38.88959218605189,
            'lon': -77.4188802165627,
            'scale': 1.155,
            'heading': 281.8994195850528
        },
        {
            'lat': 38.89105558919701,
            'lon': -77.41806305565751,
            'scale': 1.132,
            'heading': 280.44829689011726
        },
        {
            'lat': 38.89198931508037,
            'lon': -77.41855456766518,
            'scale': 0.831,
            'heading': 125.08086320861311
        },
        {
            'lat': 38.88957389938256,
            'lon': -77.41816601580874,
            'scale': 0.94,
            'heading': 306.682989344803
        },
        {
            'lat': 38.889566585438324,
            'lon': -77.41770742428528,
            'scale': 0.849,
            'heading': 130.21361732642916
        },
        {
            'lat': 38.88811761052527,
            'lon': -77.4211307943189,
            'scale': 0.821,
            'heading': 116.36923047762623
        },
        {
            'lat': 38.89044491771506,
            'lon': -77.41879371211988,
            'scale': 0.884,
            'heading': 264.7170176477436
        },
        {
            'lat': 38.88984660895346,
            'lon': -77.41771050383744,
            'scale': 1.124,
            'heading': 98.0707295440671
        },
        {
            'lat': 38.89172807564053,
            'lon': -77.41869181773431,
            'scale': 0.872,
            'heading': 257.1437560457605
        },
        {
            'lat': 38.891575955971504,
            'lon': -77.41804994383101,
            'scale': 0.946,
            'heading': 84.78039383117772
        },
        {
            'lat': 38.891659170948635,
            'lon': -77.41857783471008,
            'scale': 0.955,
            'heading': 67.31849346327165
        },
        {
            'lat': 38.89079507655518,
            'lon': -77.4185505254019,
            'scale': 1.016,
            'heading': 32.35508590329517
        },
        {
            'lat': 38.88997801018263,
            'lon': -77.4185009937343,
            'scale': 0.827,
            'heading': 322.66118483764853
        },
        {
            'lat': 38.89239710503824,
            'lon': -77.41769002488404,
            'scale': 1.055,
            'heading': 301.8438633143998
        },
        {
            'lat': 38.88961691063889,
            'lon': -77.41845344926747,
            'scale': 1.144,
            'heading': 210.72022532401263
        },
        {
            'lat': 38.89226713351725,
            'lon': -77.41809995442645,
            'scale': 0.862,
            'heading': 103.47306401801934
        },
        {
            'lat': 38.88952906033218,
            'lon': -77.41917195353851,
            'scale': 1.164,
            'heading': 6.565884764577086
        },
        {
            'lat': 38.89057681456463,
            'lon': -77.41820214477517,
            'scale': 1.132,
            'heading': 338.50345945642215
        },
        {
            'lat': 38.890656992038146,
            'lon': -77.41865371566014,
            'scale': 0.918,
            'heading': 269.33021626309005
        },
        {
            'lat': 38.89219867586643,
            'lon': -77.4180505415514,
            'scale': 0.857,
            'heading': 265.0445871099402
        },
        {
            'lat': 38.89221511337797,
            'lon': -77.4177718020829,
            'scale': 0.949,
            'heading': 225.42816830508136
        },
        {
            'lat': 38.89184351366727,
            'lon': -77.41889904361759,
            'scale': 1.055,
            'heading': 321.6926634829689
        },
        {
            'lat': 38.89173937917708,
            'lon': -77.41890231398544,
            'scale': 1.032,
            'heading': 14.98339553427229
        },
        {
            'lat': 38.89073293176403,
            'lon': -77.41798599130841,
            'scale': 1.116,
            'heading': 345.15637497181444
        },
        {
            'lat': 38.89207272109697,
            'lon': -77.41887726030545,
            'scale': 0.859,
            'heading': 234.03166748013325
        },
        {
            'lat': 38.89135556102822,
            'lon': -77.41853343131761,
            'scale': 0.933,
            'heading': 223.81171405971295
        },
        {
            'lat': 38.88852406399338,
            'lon': -77.42128043946836,
            'scale': 1.193,
            'heading': 346.11215224964207
        },
        {
            'lat': 38.891715214735655,
            'lon': -77.418495246817,
            'scale': 0.892,
            'heading': 353.79423523622546
        },
        {
            'lat': 38.889482980426884,
            'lon': -77.41910236954392,
            'scale': 1.084,
            'heading': 42.99843046011662
        },
        {
            'lat': 38.89069684958448,
            'lon': -77.41811870530063,
            'scale': 1.122,
            'heading': 74.73379202594693
        },
        {
            'lat': 38.892340614694156,
            'lon': -77.41865635214718,
            'scale': 0.995,
            'heading': 283.15808629797493
        },
        {
            'lat': 38.89057574835749,
            'lon': -77.41826970422878,
            'scale': 1.039,
            'heading': 95.04193059644511
        },
        {
            'lat': 38.891142030343474,
            'lon': -77.41871239824474,
            'scale': 0.939,
            'heading': 307.0068313686328
        },
        {
            'lat': 38.89235712570621,
            'lon': -77.41838305517729,
            'scale': 1.147,
            'heading': 240.1005016850392
        },
        {
            'lat': 38.891485700714945,
            'lon': -77.41877830139725,
            'scale': 0.821,
            'heading': 38.115021007718546
        },
        {
            'lat': 38.890081849806435,
            'lon': -77.41772387135835,
            'scale': 1.027,
            'heading': 91.17704121868773
        },
        {
            'lat': 38.890121539450725,
            'lon': -77.41812395906389,
            'scale': 0.957,
            'heading': 242.90155706096414
        },
        {
            'lat': 38.8912914533044,
            'lon': -77.41880536706452,
            'scale': 0.984,
            'heading': 253.11431102658074
        },
        {
            'lat': 38.89080907637219,
            'lon': -77.4182016760162,
            'scale': 1.133,
            'heading': 222.6293435209914
        },
        {
            'lat': 38.89205360750394,
            'lon': -77.4178044524033,
            'scale': 1.165,
            'heading': 310.9032147958247
        },
        {
            'lat': 38.890814925794714,
            'lon': -77.41894263115584,
            'scale': 1.023,
            'heading': 257.2196006425585
        },
        {
            'lat': 38.89226612839265,
            'lon': -77.41912010475234,
            'scale': 1.119,
            'heading': 60.87165309818251
        },
        {
            'lat': 38.890634835541306,
            'lon': -77.41875047523462,
            'scale': 1.019,
            'heading': 355.8795995114919
        },
        {
            'lat': 38.89094829781503,
            'lon': -77.41830319480506,
            'scale': 0.825,
            'heading': 44.934548036477246
        },
        {
            'lat': 38.889960024018364,
            'lon': -77.41785789689322,
            'scale': 1.097,
            'heading': 63.157768877843516
        },
        {
            'lat': 38.891158066829696,
            'lon': -77.41853240119629,
            'scale': 1.117,
            'heading': 280.5394704504098
        },
        {
            'lat': 38.89086423008752,
            'lon': -77.41884884954224,
            'scale': 1.161,
            'heading': 2.037255873394588
        },
        {
            'lat': 38.8904975660425,
            'lon': -77.41858698399218,
            'scale': 1.163,
            'heading': 93.17519431939031
        },
        {
            'lat': 38.89213284429767,
            'lon': -77.4188785504403,
            'scale': 1.0,
            'heading': 281.3581272110381
        },
        {
            'lat': 38.89144858057094,
            'lon': -77.41883772215357,
            'scale': 1.143,
            'heading': 316.0407641210292
        },
        {
            'lat': 38.89038989723263,
            'lon': -77.41829848542488,
            'scale': 1.001,
            'heading': 6.539533921853522
        },
        {
            'lat': 38.889966753766366,
            'lon': -77.4183490533824,
            'scale': 0.801,
            'heading': 271.8649364540475
        },
        {
            'lat': 38.892165788358845,
            'lon': -77.41792998212306,
            'scale': 0.947,
            'heading': 43.543031571221604
        },
        {
            'lat': 38.89234522525289,
            'lon': -77.418602102957,
            'scale': 1.199,
            'heading': 302.8736616039198
        },
        {
            'lat': 38.89112900428444,
            'lon': -77.4180732017145,
            'scale': 0.819,
            'heading': 95.51810223861847
        },
        {
            'lat': 38.890491034085414,
            'lon': -77.41876659188615,
            'scale': 1.195,
            'heading': 194.75944754055155
        },
        {
            'lat': 38.89002974951477,
            'lon': -77.41773007522784,
            'scale': 1.008,
            'heading': 335.6707864093949
        },
        {
            'lat': 38.892036215649135,
            'lon': -77.41866773117283,
            'scale': 1.036,
            'heading': 359.49452683455786
        },
        {
            'lat': 38.89212646637341,
            'lon': -77.4185794415141,
            'scale': 1.075,
            'heading': 261.78764045888585
        },
        {
            'lat': 38.89100059925622,
            'lon': -77.41882115151262,
            'scale': 0.998,
            'heading': 83.76675711803179
        },
        {
            'lat': 38.89090654853462,
            'lon': -77.41897963489558,
            'scale': 1.138,
            'heading': 331.887424323075
        },
        {
            'lat': 38.89075489672785,
            'lon': -77.41895305387241,
            'scale': 0.887,
            'heading': 217.02724000234014
        },
        {
            'lat': 38.88954222245047,
            'lon': -77.41917882729837,
            'scale': 0.829,
            'heading': 232.98820018311199
        },
        {
            'lat': 38.89194572846769,
            'lon': -77.4180417965996,
            'scale': 1.028,
            'heading': 118.8171777109925
        },
        {
            'lat': 38.89079735440779,
            'lon': -77.41856803529602,
            'scale': 0.959,
            'heading': 93.77127566021498
        },
        {
            'lat': 38.8919841092473,
            'lon': -77.41822434465003,
            'scale': 1.097,
            'heading': 319.87148857390605
        },
        {
            'lat': 38.89003660892752,
            'lon': -77.41824048951186,
            'scale': 1.059,
            'heading': 65.12439244084149
        },
        {
            'lat': 38.888173700639356,
            'lon': -77.42153179692176,
            'scale': 1.062,
            'heading': 126.68419439247135
        },
        {
            'lat': 38.891202697922594,
            'lon': -77.41843737556454,
            'scale': 1.06,
            'heading': 1.7501401641972425
        },
        {
            'lat': 38.8910850862855,
            'lon': -77.41872979850069,
            'scale': 1.047,
            'heading': 89.97843676657176
        },
        {
            'lat': 38.89195140215602,
            'lon': -77.4178888921683,
            'scale': 1.046,
            'heading': 212.22089100614866
        },
        {
            'lat': 38.89003396643953,
            'lon': -77.41770993736104,
            'scale': 1.025,
            'heading': 288.67976756680696
        },
        {
            'lat': 38.89116152283494,
            'lon': -77.41844291132945,
            'scale': 0.921,
            'heading': 24.07922576485884
        },
        {
            'lat': 38.89121366870939,
            'lon': -77.41869881654877,
            'scale': 1.161,
            'heading': 301.2350493679738
        },
        {
            'lat': 38.889543532051526,
            'lon': -77.41830722761848,
            'scale': 0.874,
            'heading': 253.44183842102285
        },
        {
            'lat': 38.89103304865342,
            'lon': -77.41806804179626,
            'scale': 0.873,
            'heading': 233.9063800103309
        },
        {
            'lat': 38.891729985945766,
            'lon': -77.41826168388492,
            'scale': 1.058,
            'heading': 322.0771774093913
        },
        {
            'lat': 38.88991399315702,
            'lon': -77.41880223636655,
            'scale': 1.127,
            'heading': 144.6128289637912
        },
        {
            'lat': 38.890564220138465,
            'lon': -77.41889907374107,
            'scale': 1.145,
            'heading': 343.02840971759383
        },
        {
            'lat': 38.89135221899152,
            'lon': -77.4183428789285,
            'scale': 0.915,
            'heading': 211.33670892998774
        },
        {
            'lat': 38.89012766240765,
            'lon': -77.41881832406415,
            'scale': 1.007,
            'heading': 68.89668828228363
        },
        {
            'lat': 38.888691346010056,
            'lon': -77.42092694171374,
            'scale': 0.982,
            'heading': 322.9267115312236
        },
        {
            'lat': 38.89072627473918,
            'lon': -77.41863445748446,
            'scale': 0.841,
            'heading': 97.21130893087336
        },
        {
            'lat': 38.8911215997836,
            'lon': -77.41855810431844,
            'scale': 0.942,
            'heading': 89.48611405977086
        },
        {
            'lat': 38.89213617195869,
            'lon': -77.41784414208787,
            'scale': 1.171,
            'heading': 34.889165530671356
        },
        {
            'lat': 38.88822879086799,
            'lon': -77.42129443228507,
            'scale': 1.032,
            'heading': 197.2794969858236
        },
        {
            'lat': 38.892165874163986,
            'lon': -77.4191196244057,
            'scale': 0.932,
            'heading': 259.86956056876585
        },
        {
            'lat': 38.89178326622738,
            'lon': -77.41819749315609,
            'scale': 0.829,
            'heading': 102.50695055607729
        },
        {
            'lat': 38.89221049574867,
            'lon': -77.41832958795023,
            'scale': 1.134,
            'heading': 20.42842301521763
        },
        {
            'lat': 38.88836279477069,
            'lon': -77.42119316214425,
            'scale': 0.867,
            'heading': 305.3393555488399
        },
        {
            'lat': 38.89233236105567,
            'lon': -77.41817414622386,
            'scale': 1.129,
            'heading': 252.17178903135212
        },
        {
            'lat': 38.89160370742049,
            'lon': -77.41820331669581,
            'scale': 1.112,
            'heading': 302.33271195694476
        },
        {
            'lat': 38.89107029035301,
            'lon': -77.41878411759906,
            'scale': 1.12,
            'heading': 161.4606616553605
        },
        {
            'lat': 38.89043368076355,
            'lon': -77.41834836051714,
            'scale': 1.015,
            'heading': 340.70875467416664
        },
        {
            'lat': 38.89231077026471,
            'lon': -77.41772351927997,
            'scale': 1.146,
            'heading': 73.4215661133368
        },
        {
            'lat': 38.89153310693169,
            'lon': -77.41842913632878,
            'scale': 0.879,
            'heading': 93.15861111971478
        },
        {
            'lat': 38.891282907071066,
            'lon': -77.41809121999106,
            'scale': 1.019,
            'heading': 87.48443424912361
        },
        {
            'lat': 38.890871938703285,
            'lon': -77.41810925556851,
            'scale': 0.971,
            'heading': 63.52373134807075
        },
        {
            'lat': 38.89192528612131,
            'lon': -77.41802067274398,
            'scale': 0.96,
            'heading': 325.9838077743001
        },
        {
            'lat': 38.89214212415021,
            'lon': -77.4186308615902,
            'scale': 1.141,
            'heading': 40.6527188654284
        },
        {
            'lat': 38.88872240449327,
            'lon': -77.42094888996711,
            'scale': 0.808,
            'heading': 211.66972361463013
        },
        {
            'lat': 38.88840611793614,
            'lon': -77.42114960940216,
            'scale': 0.971,
            'heading': 146.3638448223638
        },
        {
            'lat': 38.890218620846326,
            'lon': -77.4176577495938,
            'scale': 1.085,
            'heading': 343.7757507300807
        },
        {
            'lat': 38.89160400968127,
            'lon': -77.41799074413582,
            'scale': 1.012,
            'heading': 321.8906236612217
        },
        {
            'lat': 38.89083611981508,
            'lon': -77.41895565518558,
            'scale': 0.963,
            'heading': 141.7054824420187
        },
        {
            'lat': 38.889599948750195,
            'lon': -77.4188139345948,
            'scale': 0.865,
            'heading': 67.10505984614042
        },
        {
            'lat': 38.891239717568666,
            'lon': -77.41829982159796,
            'scale': 1.024,
            'heading': 262.79721263884056
        },
        {
            'lat': 38.891880148381034,
            'lon': -77.41857280760372,
            'scale': 1.165,
            'heading': 56.67909092196349
        },
        {
            'lat': 38.89218402005718,
            'lon': -77.4180673516658,
            'scale': 0.835,
            'heading': 143.9733148026212
        },
        {
            'lat': 38.890808921077465,
            'lon': -77.41841561296526,
            'scale': 0.897,
            'heading': 176.35168511121503
        },
        {
            'lat': 38.89136673909072,
            'lon': -77.41819841558907,
            'scale': 0.961,
            'heading': 216.5092373060314
        },
        {
            'lat': 38.89224307149896,
            'lon': -77.41912765642066,
            'scale': 0.95,
            'heading': 326.32207977629196
        },
        {
            'lat': 38.89020156074486,
            'lon': -77.41885148993553,
            'scale': 0.971,
            'heading': 43.41685010784989
        },
        {
            'lat': 38.890627570939095,
            'lon': -77.41841593920915,
            'scale': 1.171,
            'heading': 89.42625629522185
        },
        {
            'lat': 38.89128107307265,
            'lon': -77.41896277891227,
            'scale': 0.909,
            'heading': 253.74272104987307
        },
        {
            'lat': 38.88956917848001,
            'lon': -77.41921801844651,
            'scale': 1.045,
            'heading': 143.88624867504913
        },
        {
            'lat': 38.88996379795697,
            'lon': -77.4182050642962,
            'scale': 0.814,
            'heading': 100.15699624052195
        },
        {
            'lat': 38.88825371963799,
            'lon': -77.42130609315365,
            'scale': 0.835,
            'heading': 192.00012121386587
        },
        {
            'lat': 38.89013664951405,
            'lon': -77.41824582887571,
            'scale': 1.101,
            'heading': 352.0187969414026
        },
        {
            'lat': 38.89056743486078,
            'lon': -77.41851541361406,
            'scale': 1.002,
            'heading': 215.1160294581184
        },
        {
            'lat': 38.89220293543203,
            'lon': -77.4185965116092,
            'scale': 1.146,
            'heading': 193.99990016002909
        },
        {
            'lat': 38.89183785228897,
            'lon': -77.41856101529712,
            'scale': 1.093,
            'heading': 203.9456538910779
        },
        {
            'lat': 38.88855381386133,
            'lon': -77.42116266264118,
            'scale': 1.043,
            'heading': 73.02101424851045
        },
        {
            'lat': 38.889534910851125,
            'lon': -77.41819900956256,
            'scale': 0.835,
            'heading': 258.84315936371746
        },
        {
            'lat': 38.89170563883876,
            'lon': -77.41885000786415,
            'scale': 0.863,
            'heading': 201.27052680033776
        },
        {
            'lat': 38.88966340183369,
            'lon': -77.41844169648077,
            'scale': 0.981,
            'heading': 226.55706590604188
        },
        {
            'lat': 38.88983767067439,
            'lon': -77.41812253393272,
            'scale': 0.978,
            'heading': 164.97921643907253
        },
        {
            'lat': 38.890763075670804,
            'lon': -77.41817253704791,
            'scale': 0.89,
            'heading': 51.02237581153745
        },
        {
            'lat': 38.891193578308304,
            'lon': -77.41873809551927,
            'scale': 0.831,
            'heading': 138.49529356615898
        },
        {
            'lat': 38.89180477729878,
            'lon': -77.41775174930287,
            'scale': 0.995,
            'heading': 3.9389272140565534
        },
        {
            'lat': 38.888722489066275,
            'lon': -77.42097081030214,
            'scale': 0.804,
            'heading': 357.0552285950935
        },
        {
            'lat': 38.88988874514233,
            'lon': -77.41836609192059,
            'scale': 1.026,
            'heading': 168.8925797272466
        },
        {
            'lat': 38.8906778742255,
            'lon': -77.41883744770946,
            'scale': 0.956,
            'heading': 316.62154043003903
        },
        {
            'lat': 38.8914245287953,
            'lon': -77.41884713213855,
            'scale': 1.089,
            'heading': 302.190619034379
        },
        {
            'lat': 38.891987979024265,
            'lon': -77.41811675842057,
            'scale': 0.954,
            'heading': 164.42603963434135
        },
        {
            'lat': 38.89219327709548,
            'lon': -77.41784191249465,
            'scale': 1.102,
            'heading': 36.9145782016748
        },
        {
            'lat': 38.89225905852565,
            'lon': -77.41859860679945,
            'scale': 1.156,
            'heading': 190.2253513646236
        },
        {
            'lat': 38.89010779691911,
            'lon': -77.41814486371804,
            'scale': 0.988,
            'heading': 238.6263734069534
        },
        {
            'lat': 38.890085052901576,
            'lon': -77.41816272692644,
            'scale': 1.198,
            'heading': 208.14897958814322
        },
        {
            'lat': 38.89006555699016,
            'lon': -77.41816755668117,
            'scale': 0.826,
            'heading': 105.91941191768517
        },
        {
            'lat': 38.89211034150066,
            'lon': -77.41804371473538,
            'scale': 0.986,
            'heading': 9.97981020655903
        },
        {
            'lat': 38.890491703978256,
            'lon': -77.41867256502972,
            'scale': 0.967,
            'heading': 307.94787501079907
        },
        {
            'lat': 38.8901407915138,
            'lon': -77.41823153695756,
            'scale': 1.15,
            'heading': 31.920208377002453
        },
        {
            'lat': 38.89094310097989,
            'lon': -77.41828340741199,
            'scale': 1.171,
            'heading': 345.4461185744247
        },
        {
            'lat': 38.89062688386109,
            'lon': -77.41895743695618,
            'scale': 1.19,
            'heading': 225.40428257748573
        },
        {
            'lat': 38.892184687456925,
            'lon': -77.41907146359185,
            'scale': 0.91,
            'heading': 155.2286065158327
        },
        {
            'lat': 38.88809996830452,
            'lon': -77.42113182508432,
            'scale': 0.998,
            'heading': 325.4074623215749
        },
        {
            'lat': 38.89217124871525,
            'lon': -77.4180683115618,
            'scale': 0.955,
            'heading': 227.87095116399598
        },
        {
            'lat': 38.89064079101581,
            'lon': -77.41803119276081,
            'scale': 0.834,
            'heading': 285.9942094526661
        },
        {
            'lat': 38.89029486360488,
            'lon': -77.41875949888666,
            'scale': 1.04,
            'heading': 198.81369464930654
        },
        {
            'lat': 38.891987472468735,
            'lon': -77.41846482896526,
            'scale': 1.076,
            'heading': 299.3680259224116
        },
        {
            'lat': 38.892230811753365,
            'lon': -77.41919865054128,
            'scale': 1.064,
            'heading': 226.30707375906843
        },
        {
            'lat': 38.89008317794394,
            'lon': -77.41786289805684,
            'scale': 0.921,
            'heading': 264.33357687337934
        },
        {
            'lat': 38.890514435862634,
            'lon': -77.41837528044069,
            'scale': 1.101,
            'heading': 88.1502579618356
        },
        {
            'lat': 38.89048688671681,
            'lon': -77.41811920291171,
            'scale': 1.166,
            'heading': 339.72910774576815
        },
        {
            'lat': 38.8912769571831,
            'lon': -77.41818904576202,
            'scale': 1.174,
            'heading': 174.9157995528295
        },
        {
            'lat': 38.89235526290759,
            'lon': -77.41923713717871,
            'scale': 0.965,
            'heading': 167.33834101452535
        },
        {
            'lat': 38.891254575513805,
            'lon': -77.41851686921223,
            'scale': 1.125,
            'heading': 258.43579488309206
        },
        {
            'lat': 38.89050091853937,
            'lon': -77.41847201815087,
            'scale': 0.907,
            'heading': 253.3910480971829
        },
        {
            'lat': 38.889531703752674,
            'lon': -77.4179369358996,
            'scale': 0.889,
            'heading': 318.9174623399452
        },
        {
            'lat': 38.89207834172933,
            'lon': -77.41897238970591,
            'scale': 1.164,
            'heading': 280.78344298174756
        },
        {
            'lat': 38.89216517287443,
            'lon': -77.41819561341552,
            'scale': 1.121,
            'heading': 11.168869052466253
        },
        {
            'lat': 38.89181980994028,
            'lon': -77.41839198616364,
            'scale': 0.967,
            'heading': 136.76431904811972
        },
        {
            'lat': 38.89131370778064,
            'lon': -77.4189209138754,
            'scale': 0.922,
            'heading': 144.83045887533237
        },
        {
            'lat': 38.89229091131409,
            'lon': -77.41823259501491,
            'scale': 1.033,
            'heading': 56.8726258095563
        },
        {
            'lat': 38.89221675849629,
            'lon': -77.41786323737125,
            'scale': 1.109,
            'heading': 22.893543070113175
        },
        {
            'lat': 38.8923634033973,
            'lon': -77.4184154317471,
            'scale': 1.059,
            'heading': 113.09373064969071
        },
        {
            'lat': 38.891965101830294,
            'lon': -77.41802014954816,
            'scale': 0.898,
            'heading': 309.8535778764279
        },
        {
            'lat': 38.8895227735413,
            'lon': -77.41918825854094,
            'scale': 0.867,
            'heading': 185.29904284333338
        },
        {
            'lat': 38.88995248695379,
            'lon': -77.41869198037064,
            'scale': 1.093,
            'heading': 281.2153559849078
        },
        {
            'lat': 38.89117969055766,
            'lon': -77.41839094405078,
            'scale': 1.109,
            'heading': 269.83764485890134
        },
        {
            'lat': 38.891254655380116,
            'lon': -77.41827555633567,
            'scale': 1.179,
            'heading': 15.58805236162232
        },
        {
            'lat': 38.89143841063466,
            'lon': -77.41821272409516,
            'scale': 1.046,
            'heading': 283.51583559040233
        },
        {
            'lat': 38.89203906915651,
            'lon': -77.41886545261372,
            'scale': 1.094,
            'heading': 238.51129611284284
        },
        {
            'lat': 38.88997383530144,
            'lon': -77.41856799519267,
            'scale': 0.909,
            'heading': 177.2246165111415
        },
        {
            'lat': 38.89128693174816,
            'lon': -77.41876616144698,
            'scale': 0.857,
            'heading': 51.08778195542724
        },
        {
            'lat': 38.89194091107877,
            'lon': -77.41813189056123,
            'scale': 1.025,
            'heading': 305.1107451347816
        },
        {
            'lat': 38.890908484436736,
            'lon': -77.41818636316266,
            'scale': 1.189,
            'heading': 104.50863949201275
        },
        {
            'lat': 38.89125334812695,
            'lon': -77.41892091301747,
            'scale': 1.063,
            'heading': 42.87084555608706
        },
        {
            'lat': 38.88952159781859,
            'lon': -77.4189749523396,
            'scale': 0.886,
            'heading': 247.01526864099978
        },
        {
            'lat': 38.889573609597505,
            'lon': -77.41790110395686,
            'scale': 1.193,
            'heading': 191.83587374964463
        },
        {
            'lat': 38.89133969200867,
            'lon': -77.4187990817393,
            'scale': 1.02,
            'heading': 176.21042749032912
        },
        {
            'lat': 38.890516653121786,
            'lon': -77.41830246610783,
            'scale': 1.14,
            'heading': 271.6711784449778
        },
        {
            'lat': 38.88956874808732,
            'lon': -77.41840889277908,
            'scale': 1.106,
            'heading': 254.96269508814873
        },
        {
            'lat': 38.89210775103498,
            'lon': -77.41778155014482,
            'scale': 0.861,
            'heading': 57.57685008716799
        },
        {
            'lat': 38.89105923407065,
            'lon': -77.41820480917492,
            'scale': 0.88,
            'heading': 317.8983125950593
        },
        {
            'lat': 38.889603498708745,
            'lon': -77.41853330563485,
            'scale': 0.924,
            'heading': 357.6065900227884
        },
        {
            'lat': 38.891762697525,
            'lon': -77.41843482177833,
            'scale': 0.806,
            'heading': 21.495747222329303
        },
        {
            'lat': 38.890359521881585,
            'lon': -77.4183992705532,
            'scale': 1.197,
            'heading': 141.2222418768456
        },
        {
            'lat': 38.88864901573615,
            'lon': -77.42106346778698,
            'scale': 0.985,
            'heading': 4.992000461699249
        },
        {
            'lat': 38.89217389578244,
            'lon': -77.41794260132014,
            'scale': 0.955,
            'heading': 132.4538663159057
        },
        {
            'lat': 38.89228463597456,
            'lon': -77.41879736063721,
            'scale': 0.921,
            'heading': 327.61739174990925
        },
        {
            'lat': 38.89146617078409,
            'lon': -77.41866594892205,
            'scale': 0.928,
            'heading': 269.06008184005407
        },
        {
            'lat': 38.89237102395107,
            'lon': -77.41778269222502,
            'scale': 1.03,
            'heading': 306.5949731099957
        },
        {
            'lat': 38.89219383139542,
            'lon': -77.4186504705261,
            'scale': 0.809,
            'heading': 43.5083373593653
        },
        {
            'lat': 38.88993015503765,
            'lon': -77.41879327378473,
            'scale': 1.037,
            'heading': 211.59997943933385
        },
        {
            'lat': 38.89050812841763,
            'lon': -77.41812316015415,
            'scale': 1.188,
            'heading': 329.1091004415543
        },
        {
            'lat': 38.89109413854229,
            'lon': -77.41874575205549,
            'scale': 1.13,
            'heading': 24.46444355311919
        },
        {
            'lat': 38.89088029546769,
            'lon': -77.41810886422223,
            'scale': 1.013,
            'heading': 185.97156401285633
        },
        {
            'lat': 38.89223904998563,
            'lon': -77.41824081608732,
            'scale': 1.132,
            'heading': 294.6810117492478
        },
        {
            'lat': 38.89199414307868,
            'lon': -77.41827944963582,
            'scale': 0.92,
            'heading': 103.6754387880813
        },
        {
            'lat': 38.89219482329533,
            'lon': -77.41824468516661,
            'scale': 1.136,
            'heading': 191.16729431659658
        },
        {
            'lat': 38.89208377763822,
            'lon': -77.41872523567064,
            'scale': 0.988,
            'heading': 191.2912285076175
        },
        {
            'lat': 38.89151422242114,
            'lon': -77.41872322927352,
            'scale': 0.802,
            'heading': 121.47768840005018
        },
        {
            'lat': 38.891773869605956,
            'lon': -77.41787225180961,
            'scale': 0.976,
            'heading': 42.3210170896831
        },
        {
            'lat': 38.89180810294622,
            'lon': -77.4187162066036,
            'scale': 1.036,
            'heading': 197.29756636042947
        },
        {
            'lat': 38.89029103580335,
            'lon': -77.41841118243849,
            'scale': 0.992,
            'heading': 151.74963743169076
        },
        {
            'lat': 38.89102242657753,
            'lon': -77.41859628870723,
            'scale': 1.144,
            'heading': 222.7041767422666
        },
        {
            'lat': 38.88985897690155,
            'lon': -77.4181659338642,
            'scale': 1.16,
            'heading': 7.849229284121071
        },
        {
            'lat': 38.89213981022729,
            'lon': -77.41864594193089,
            'scale': 1.009,
            'heading': 225.312312915342
        },
        {
            'lat': 38.889968306690356,
            'lon': -77.41768646501377,
            'scale': 1.166,
            'heading': 236.87054218217938
        },
        {
            'lat': 38.890367449461785,
            'lon': -77.41823036583048,
            'scale': 0.858,
            'heading': 113.51962240127976
        },
        {
            'lat': 38.89013603441558,
            'lon': -77.41772099802077,
            'scale': 0.883,
            'heading': 341.5305442139113
        },
        {
            'lat': 38.89011523292396,
            'lon': -77.41771108631188,
            'scale': 1.177,
            'heading': 165.45079419413483
        },
        {
            'lat': 38.88997729483695,
            'lon': -77.41817792202667,
            'scale': 0.87,
            'heading': 316.5046167294278
        },
        {
            'lat': 38.890084732792744,
            'lon': -77.41769815847769,
            'scale': 1.182,
            'heading': 261.17653580075086
        },
        {
            'lat': 38.891611796050306,
            'lon': -77.41858456063893,
            'scale': 0.821,
            'heading': 36.0215896609683
        },
        {
            'lat': 38.892157961407946,
            'lon': -77.41773153727564,
            'scale': 0.863,
            'heading': 217.95893946436976
        },
        {
            'lat': 38.88829767911219,
            'lon': -77.42117642488775,
            'scale': 1.072,
            'heading': 197.49752420475437
        },
        {
            'lat': 38.8920055202265,
            'lon': -77.41768464684803,
            'scale': 1.098,
            'heading': 340.0352811890807
        },
        {
            'lat': 38.890222966957076,
            'lon': -77.41789322496754,
            'scale': 0.843,
            'heading': 30.604682090458528
        },
        {
            'lat': 38.89156850115062,
            'lon': -77.41821646724475,
            'scale': 0.807,
            'heading': 89.25472853137626
        },
        {
            'lat': 38.89208635417964,
            'lon': -77.41796233635613,
            'scale': 1.187,
            'heading': 41.97689455373202
        },
        {
            'lat': 38.890388263361444,
            'lon': -77.41846085885278,
            'scale': 0.803,
            'heading': 323.5407377433687
        },
        {
            'lat': 38.88845848640143,
            'lon': -77.42096182719511,
            'scale': 1.164,
            'heading': 166.75576043177048
        },
        {
            'lat': 38.889588906237236,
            'lon': -77.4185046867943,
            'scale': 0.998,
            'heading': 234.72185823983966
        },
        {
            'lat': 38.88840571726737,
            'lon': -77.4209450028216,
            'scale': 1.152,
            'heading': 179.4627892332313
        },
        {
            'lat': 38.890455569896744,
            'lon': -77.41865461975473,
            'scale': 0.967,
            'heading': 282.66637882751326
        },
        {
            'lat': 38.8919218936802,
            'lon': -77.41827709785888,
            'scale': 0.958,
            'heading': 164.41442072724345
        },
        {
            'lat': 38.892154724747975,
            'lon': -77.41882950455947,
            'scale': 1.067,
            'heading': 108.72107269474628
        },
        {
            'lat': 38.888373184751394,
            'lon': -77.42098134734829,
            'scale': 0.991,
            'heading': 80.98988940148195
        },
        {
            'lat': 38.89059312597525,
            'lon': -77.41846252816624,
            'scale': 0.848,
            'heading': 101.43896689205677
        },
        {
            'lat': 38.88980437931879,
            'lon': -77.41827450542472,
            'scale': 1.182,
            'heading': 29.522470600888376
        },
        {
            'lat': 38.89127769846235,
            'lon': -77.41885157440551,
            'scale': 1.185,
            'heading': 234.10770983771715
        },
        {
            'lat': 38.89136986159501,
            'lon': -77.41820248875018,
            'scale': 1.048,
            'heading': 209.37415556330663
        },
        {
            'lat': 38.89038089024521,
            'lon': -77.41825493004298,
            'scale': 1.047,
            'heading': 132.10102189852927
        },
        {
            'lat': 38.888462773364715,
            'lon': -77.4213707583651,
            'scale': 1.055,
            'heading': 222.7259393440912
        },
        {
            'lat': 38.8904661460002,
            'lon': -77.41833023479789,
            'scale': 0.988,
            'heading': 97.2141651627031
        },
        {
            'lat': 38.89047733042116,
            'lon': -77.41824862826164,
            'scale': 0.822,
            'heading': 236.6782674858993
        },
        {
            'lat': 38.89021549174675,
            'lon': -77.4177961225083,
            'scale': 0.931,
            'heading': 12.087550501850473
        },
        {
            'lat': 38.890041815164615,
            'lon': -77.41779242511572,
            'scale': 1.2,
            'heading': 247.2009946346539
        },
        {
            'lat': 38.88964699865285,
            'lon': -77.41886318733825,
            'scale': 1.184,
            'heading': 58.547382775856754
        },
        {
            'lat': 38.89205048715232,
            'lon': -77.41829688540034,
            'scale': 1.139,
            'heading': 203.05885604509717
        },
        {
            'lat': 38.89183199529725,
            'lon': -77.41812273027881,
            'scale': 1.084,
            'heading': 15.396425706702832
        },
        {
            'lat': 38.88987316512069,
            'lon': -77.41836525369877,
            'scale': 0.814,
            'heading': 20.193808061434957
        },
        {
            'lat': 38.88978772429173,
            'lon': -77.41812821014317,
            'scale': 1.132,
            'heading': 72.94523763199726
        },
        {
            'lat': 38.889484156025354,
            'lon': -77.41893831428207,
            'scale': 1.173,
            'heading': 235.40883627171863
        },
        {
            'lat': 38.892057655390076,
            'lon': -77.41884852464737,
            'scale': 0.919,
            'heading': 300.4622344862838
        },
        {
            'lat': 38.89186197019418,
            'lon': -77.41829599779771,
            'scale': 0.889,
            'heading': 262.76121803212686
        },
        {
            'lat': 38.89213216465622,
            'lon': -77.41888923899538,
            'scale': 0.978,
            'heading': 331.1213927900644
        },
        {
            'lat': 38.89216268514911,
            'lon': -77.41793295721119,
            'scale': 1.086,
            'heading': 107.52911980011912
        },
        {
            'lat': 38.890025730839284,
            'lon': -77.41793984501301,
            'scale': 0.802,
            'heading': 182.84383510628493
        },
        {
            'lat': 38.891817321803174,
            'lon': -77.41780872706066,
            'scale': 1.152,
            'heading': 355.61051091903704
        },
        {
            'lat': 38.88947702622668,
            'lon': -77.41890099507421,
            'scale': 0.853,
            'heading': 282.6767263438387
        },
        {
            'lat': 38.89023063273897,
            'lon': -77.41766002532985,
            'scale': 1.057,
            'heading': 301.4338224674356
        },
        {
            'lat': 38.891911153539816,
            'lon': -77.4179892516133,
            'scale': 0.852,
            'heading': 141.109702712784
        },
        {
            'lat': 38.891346272950386,
            'lon': -77.41828005667588,
            'scale': 0.908,
            'heading': 168.99226371776908
        },
        {
            'lat': 38.8922954075943,
            'lon': -77.41918127018417,
            'scale': 0.828,
            'heading': 78.8194731451944
        },
        {
            'lat': 38.89226990959518,
            'lon': -77.41786523810187,
            'scale': 0.986,
            'heading': 148.5247236587614
        },
        {
            'lat': 38.89004163499176,
            'lon': -77.41798036961056,
            'scale': 1.122,
            'heading': 26.267020386275767
        },
        {
            'lat': 38.88963808735653,
            'lon': -77.41844869670676,
            'scale': 0.862,
            'heading': 297.53351439731165
        },
        {
            'lat': 38.88995881789935,
            'lon': -77.41835678160159,
            'scale': 0.865,
            'heading': 8.433540203964732
        },
        {
            'lat': 38.888177799682104,
            'lon': -77.42099666054273,
            'scale': 0.809,
            'heading': 305.6290039837521
        },
        {
            'lat': 38.89213460144574,
            'lon': -77.4182053164518,
            'scale': 0.854,
            'heading': 74.33900572391147
        },
        {
            'lat': 38.88826179862362,
            'lon': -77.42142070956331,
            'scale': 0.928,
            'heading': 68.91494819781965
        },
        {
            'lat': 38.88810058107657,
            'lon': -77.42128549455848,
            'scale': 1.039,
            'heading': 153.79589703029248
        },
        {
            'lat': 38.890744016820136,
            'lon': -77.41849329506385,
            'scale': 1.16,
            'heading': 37.960461139770494
        },
        {
            'lat': 38.89232799905493,
            'lon': -77.41905139022094,
            'scale': 1.009,
            'heading': 119.9643841233338
        },
        {
            'lat': 38.89185641648339,
            'lon': -77.41894715006471,
            'scale': 1.175,
            'heading': 204.812449760745
        },
        {
            'lat': 38.89130398727166,
            'lon': -77.4186289782719,
            'scale': 1.143,
            'heading': 331.9340747051248
        },
        {
            'lat': 38.89107836237823,
            'lon': -77.418726253885,
            'scale': 0.995,
            'heading': 309.1667224357203
        },
        {
            'lat': 38.89072155400133,
            'lon': -77.41836881405281,
            'scale': 1.161,
            'heading': 169.50512695777408
        },
        {
            'lat': 38.89000934054095,
            'lon': -77.41856823459531,
            'scale': 1.125,
            'heading': 100.86384487915942
        },
        {
            'lat': 38.890187166389076,
            'lon': -77.41879314573649,
            'scale': 0.867,
            'heading': 206.0444766291067
        },
        {
            'lat': 38.890523817148015,
            'lon': -77.41822062223952,
            'scale': 1.144,
            'heading': 255.61087794638843
        },
        {
            'lat': 38.890120655890534,
            'lon': -77.41827560002187,
            'scale': 1.04,
            'heading': 243.03949304574962
        },
        {
            'lat': 38.89030865911096,
            'lon': -77.41837358679506,
            'scale': 0.918,
            'heading': 88.11138767269388
        },
        {
            'lat': 38.89172625113018,
            'lon': -77.41801626887063,
            'scale': 0.894,
            'heading': 92.12577977299834
        },
        {
            'lat': 38.89231894804745,
            'lon': -77.4188070731673,
            'scale': 0.802,
            'heading': 125.99866046355487
        },
        {
            'lat': 38.89074808826915,
            'lon': -77.41862130188248,
            'scale': 0.903,
            'heading': 292.0058115423609
        },
        {
            'lat': 38.89224990434017,
            'lon': -77.41800189695988,
            'scale': 1.123,
            'heading': 345.62630324966483
        },
        {
            'lat': 38.89052190700445,
            'lon': -77.4182314658295,
            'scale': 0.928,
            'heading': 271.0632342873246
        },
        {
            'lat': 38.891780935904194,
            'lon': -77.41780201241966,
            'scale': 0.916,
            'heading': 242.9921903437953
        },
        {
            'lat': 38.88828866787576,
            'lon': -77.42083712978872,
            'scale': 1.142,
            'heading': 273.19212539378157
        },
        {
            'lat': 38.891612532635826,
            'lon': -77.41851403847024,
            'scale': 0.998,
            'heading': 243.13456337540515
        },
        {
            'lat': 38.89082283943415,
            'lon': -77.41810655353349,
            'scale': 0.915,
            'heading': 241.4226405358594
        },
        {
            'lat': 38.89118468460558,
            'lon': -77.41850939334229,
            'scale': 0.879,
            'heading': 173.33406329325106
        },
        {
            'lat': 38.89138912456477,
            'lon': -77.41819898545938,
            'scale': 1.112,
            'heading': 203.74109819792633
        },
        {
            'lat': 38.88849409517847,
            'lon': -77.42138237859749,
            'scale': 1.187,
            'heading': 224.7603848021865
        },
        {
            'lat': 38.8899997190212,
            'lon': -77.41805027345796,
            'scale': 1.176,
            'heading': 56.04320882018075
        },
        {
            'lat': 38.89139200048027,
            'lon': -77.41843633448954,
            'scale': 0.939,
            'heading': 118.5490104677321
        },
        {
            'lat': 38.89005641182478,
            'lon': -77.41847145689424,
            'scale': 0.966,
            'heading': 158.7974165023502
        },
        {
            'lat': 38.89063410032013,
            'lon': -77.41891828481157,
            'scale': 0.986,
            'heading': 141.56074243150056
        },
        {
            'lat': 38.89188773341112,
            'lon': -77.41796872641272,
            'scale': 1.186,
            'heading': 251.12229133602398
        },
        {
            'lat': 38.888102712076744,
            'lon': -77.42149947196242,
            'scale': 1.187,
            'heading': 124.38162972945972
        },
        {
            'lat': 38.89191999994522,
            'lon': -77.41800778270071,
            'scale': 1.027,
            'heading': 174.07884542350146
        },
        {
            'lat': 38.89151962317943,
            'lon': -77.41862587428449,
            'scale': 1.027,
            'heading': 75.85247943228975
        },
        {
            'lat': 38.88847280398157,
            'lon': -77.42094693055444,
            'scale': 1.063,
            'heading': 312.9295952916141
        },
        {
            'lat': 38.88836443430833,
            'lon': -77.42114041556434,
            'scale': 1.186,
            'heading': 14.000401500641484
        },
        {
            'lat': 38.89238015537804,
            'lon': -77.41869600047191,
            'scale': 0.908,
            'heading': 33.71620864113083
        },
        {
            'lat': 38.888200467239365,
            'lon': -77.4214034685689,
            'scale': 0.921,
            'heading': 123.071988885806
        },
        {
            'lat': 38.889579786438226,
            'lon': -77.4187651389337,
            'scale': 0.888,
            'heading': 84.09116940111019
        },
        {
            'lat': 38.88843873359708,
            'lon': -77.42091961769059,
            'scale': 0.851,
            'heading': 315.49012640976736
        },
        {
            'lat': 38.888330947016435,
            'lon': -77.42112288443386,
            'scale': 1.029,
            'heading': 162.78976914163502
        },
        {
            'lat': 38.89010606863232,
            'lon': -77.4180351883328,
            'scale': 0.913,
            'heading': 8.925501366474734
        },
        {
            'lat': 38.88987495211326,
            'lon': -77.41823056681784,
            'scale': 1.11,
            'heading': 308.7359194268025
        },
        {
            'lat': 38.890272771661685,
            'lon': -77.41827220934526,
            'scale': 1.199,
            'heading': 112.1206307585969
        },
        {
            'lat': 38.89192000255163,
            'lon': -77.4178207314836,
            'scale': 1.043,
            'heading': 94.33559997302237
        },
        {
            'lat': 38.888599713811075,
            'lon': -77.4210057505302,
            'scale': 0.893,
            'heading': 337.61722000422014
        },
        {
            'lat': 38.88837566329945,
            'lon': -77.42089399691523,
            'scale': 0.841,
            'heading': 326.82736657193016
        },
        {
            'lat': 38.89140276930286,
            'lon': -77.41814015408879,
            'scale': 0.825,
            'heading': 194.82976773340715
        },
        {
            'lat': 38.89165429847574,
            'lon': -77.41843595003111,
            'scale': 0.999,
            'heading': 123.91057627892526
        },
        {
            'lat': 38.889893645301875,
            'lon': -77.4188182362532,
            'scale': 1.188,
            'heading': 229.73558105424615
        },
        {
            'lat': 38.88814101453852,
            'lon': -77.42093482372346,
            'scale': 0.998,
            'heading': 336.25032271124127
        },
        {
            'lat': 38.891994827685,
            'lon': -77.41845167399033,
            'scale': 1.082,
            'heading': 233.59848627889232
        },
        {
            'lat': 38.89183025317143,
            'lon': -77.4181096325084,
            'scale': 0.888,
            'heading': 310.6980344202218
        },
        {
            'lat': 38.89032018690501,
            'lon': -77.4182139601489,
            'scale': 0.993,
            'heading': 297.9776118047211
        },
        {
            'lat': 38.88995880178368,
            'lon': -77.41774072958782,
            'scale': 0.867,
            'heading': 225.94349079204864
        },
        {
            'lat': 38.889653480777184,
            'lon': -77.41883102741352,
            'scale': 1.087,
            'heading': 240.19597767546492
        },
        {
            'lat': 38.89216765143245,
            'lon': -77.41882467180771,
            'scale': 0.838,
            'heading': 280.8860837396342
        },
        {
            'lat': 38.89118284733959,
            'lon': -77.41821132270563,
            'scale': 0.803,
            'heading': 199.02390549834274
        },
        {
            'lat': 38.88981860657648,
            'lon': -77.41850062617203,
            'scale': 1.044,
            'heading': 203.9737028459341
        },
        {
            'lat': 38.89109332393023,
            'lon': -77.41872020428106,
            'scale': 1.057,
            'heading': 149.43460861507123
        },
        {
            'lat': 38.89049479413668,
            'lon': -77.41892043093361,
            'scale': 1.131,
            'heading': 141.70160186472654
        },
        {
            'lat': 38.89218285351634,
            'lon': -77.4192113592494,
            'scale': 0.87,
            'heading': 222.99597395117348
        },
        {
            'lat': 38.889902036968586,
            'lon': -77.41765909485933,
            'scale': 0.844,
            'heading': 254.06039324664786
        },
        {
            'lat': 38.888213125141554,
            'lon': -77.42123775515455,
            'scale': 1.177,
            'heading': 54.06656890029903
        },
        {
            'lat': 38.89208356482109,
            'lon': -77.41840028882494,
            'scale': 0.924,
            'heading': 64.09837998935879
        },
        {
            'lat': 38.88985283450572,
            'lon': -77.41859454174289,
            'scale': 1.183,
            'heading': 95.03488634257083
        },
        {
            'lat': 38.89025683792509,
            'lon': -77.41792479938789,
            'scale': 0.884,
            'heading': 83.95158234648218
        },
        {
            'lat': 38.88964173657295,
            'lon': -77.41885914896463,
            'scale': 0.907,
            'heading': 230.4120226265561
        },
        {
            'lat': 38.88985077910133,
            'lon': -77.41863414681248,
            'scale': 0.925,
            'heading': 33.55244361212178
        },
        {
            'lat': 38.88852093562773,
            'lon': -77.42123244410443,
            'scale': 1.166,
            'heading': 216.8006439303178
        },
        {
            'lat': 38.891362981669765,
            'lon': -77.41825527425672,
            'scale': 0.808,
            'heading': 21.032400930678513
        },
        {
            'lat': 38.890878500919534,
            'lon': -77.41873812359366,
            'scale': 0.89,
            'heading': 17.816034302359963
        },
        {
            'lat': 38.890480385938716,
            'lon': -77.41861376751228,
            'scale': 1.151,
            'heading': 112.99993270144914
        },
        {
            'lat': 38.892392475624774,
            'lon': -77.41833313751748,
            'scale': 1.019,
            'heading': 314.903680740008
        },
        {
            'lat': 38.89236937046442,
            'lon': -77.41906157511224,
            'scale': 0.914,
            'heading': 4.62293488758621
        },
        {
            'lat': 38.888181045466084,
            'lon': -77.42131750686029,
            'scale': 0.837,
            'heading': 301.5323165096528
        },
        {
            'lat': 38.890888406570085,
            'lon': -77.41833080293391,
            'scale': 1.079,
            'heading': 32.699190815497914
        },
        {
            'lat': 38.89213987219082,
            'lon': -77.4184424381247,
            'scale': 1.063,
            'heading': 89.43083937184221
        },
        {
            'lat': 38.892126011786715,
            'lon': -77.41883872053835,
            'scale': 1.033,
            'heading': 158.6713770170531
        },
        {
            'lat': 38.892069356395474,
            'lon': -77.41902750910269,
            'scale': 1.136,
            'heading': 115.5693839527532
        },
        {
            'lat': 38.892185392648926,
            'lon': -77.41801240834766,
            'scale': 1.031,
            'heading': 104.86309530442792
        },
        {
            'lat': 38.891637150565714,
            'lon': -77.41796326789925,
            'scale': 0.861,
            'heading': 344.9576023566144
        },
        {
            'lat': 38.89008222741888,
            'lon': -77.41769423916621,
            'scale': 0.82,
            'heading': 287.1338637357565
        },
        {
            'lat': 38.89213684985967,
            'lon': -77.41803615853377,
            'scale': 1.164,
            'heading': 295.93132721317227
        },
        {
            'lat': 38.889829141018424,
            'lon': -77.41831514645146,
            'scale': 0.971,
            'heading': 101.55863551129353
        },
        {
            'lat': 38.89228478788961,
            'lon': -77.41817374901147,
            'scale': 0.993,
            'heading': 7.335447447697785
        },
        {
            'lat': 38.89197858698641,
            'lon': -77.41892519629162,
            'scale': 1.033,
            'heading': 22.53938099149453
        },
        {
            'lat': 38.890136217990424,
            'lon': -77.41796149313026,
            'scale': 0.808,
            'heading': 91.16580211318076
        },
        {
            'lat': 38.891050021848336,
            'lon': -77.4189555854762,
            'scale': 1.124,
            'heading': 64.04865618532509
        },
        {
            'lat': 38.89139542596781,
            'lon': -77.41830595510841,
            'scale': 1.023,
            'heading': 247.6584459100885
        },
        {
            'lat': 38.88956071806009,
            'lon': -77.41788457517171,
            'scale': 1.02,
            'heading': 290.15125733475486
        },
        {
            'lat': 38.89011494995958,
            'lon': -77.4187512011399,
            'scale': 0.915,
            'heading': 150.39873499425914
        },
        {
            'lat': 38.88997310365584,
            'lon': -77.41803991172307,
            'scale': 0.921,
            'heading': 169.6380911993174
        },
        {
            'lat': 38.88985254871222,
            'lon': -77.41878950551403,
            'scale': 0.973,
            'heading': 148.8249116068819
        },
        {
            'lat': 38.890274820137414,
            'lon': -77.41847205238373,
            'scale': 0.833,
            'heading': 63.15568343626869
        },
        {
            'lat': 38.889562075414744,
            'lon': -77.41790719955054,
            'scale': 0.94,
            'heading': 134.20456356438234
        },
        {
            'lat': 38.889576378733175,
            'lon': -77.41850315217162,
            'scale': 0.834,
            'heading': 258.7121328281325
        },
        {
            'lat': 38.89006789277416,
            'lon': -77.41833260340678,
            'scale': 1.109,
            'heading': 149.7155727400581
        },
        {
            'lat': 38.89199258911719,
            'lon': -77.41773252502533,
            'scale': 0.9,
            'heading': 210.68507874809725
        },
        {
            'lat': 38.891999656005844,
            'lon': -77.41773691650508,
            'scale': 1.133,
            'heading': 349.1657895604997
        },
        {
            'lat': 38.89122663491736,
            'lon': -77.41879699418477,
            'scale': 0.928,
            'heading': 350.3785467342856
        },
        {
            'lat': 38.890989770172105,
            'lon': -77.41899615961601,
            'scale': 0.865,
            'heading': 344.2409829666266
        },
        {
            'lat': 38.8906261534751,
            'lon': -77.41814644901227,
            'scale': 0.953,
            'heading': 152.30105301145522
        },
        {
            'lat': 38.8900425840452,
            'lon': -77.41788257324873,
            'scale': 1.052,
            'heading': 140.3543581062337
        },
        {
            'lat': 38.89100243694643,
            'lon': -77.41878180981239,
            'scale': 0.924,
            'heading': 252.30551925610453
        },
        {
            'lat': 38.8918261667584,
            'lon': -77.41884352157896,
            'scale': 1.186,
            'heading': 334.9179632025329
        },
        {
            'lat': 38.88964468181217,
            'lon': -77.41865694000838,
            'scale': 0.874,
            'heading': 34.53465720891739
        },
        {
            'lat': 38.892256500932355,
            'lon': -77.41901473628032,
            'scale': 1.084,
            'heading': 137.6484538365475
        },
        {
            'lat': 38.89134759056346,
            'lon': -77.41864662393799,
            'scale': 1.181,
            'heading': 55.61706773526517
        },
        {
            'lat': 38.892262517993366,
            'lon': -77.41826032418601,
            'scale': 1.13,
            'heading': 99.0888768274115
        },
        {
            'lat': 38.88956243715123,
            'lon': -77.41897539511962,
            'scale': 1.103,
            'heading': 50.94089531027906
        },
        {
            'lat': 38.89137972045959,
            'lon': -77.41848306593637,
            'scale': 1.058,
            'heading': 139.19191356048023
        },
        {
            'lat': 38.88808484367502,
            'lon': -77.42132905685193,
            'scale': 0.972,
            'heading': 9.471721795408099
        },
        {
            'lat': 38.8901529623219,
            'lon': -77.41864921735929,
            'scale': 0.944,
            'heading': 227.84513223275013
        },
        {
            'lat': 38.8913218667566,
            'lon': -77.41888410868974,
            'scale': 1.173,
            'heading': 51.837693948217996
        },
        {
            'lat': 38.89078176587887,
            'lon': -77.418184754551,
            'scale': 0.825,
            'heading': 317.6365371161236
        },
        {
            'lat': 38.88955111720798,
            'lon': -77.41868311683879,
            'scale': 1.052,
            'heading': 338.7825709620795
        },
        {
            'lat': 38.89181475095753,
            'lon': -77.41847811037078,
            'scale': 1.113,
            'heading': 155.20819984824692
        },
        {
            'lat': 38.89124564717066,
            'lon': -77.41862643752644,
            'scale': 0.952,
            'heading': 353.47611717905426
        },
        {
            'lat': 38.890001422030224,
            'lon': -77.41790593827912,
            'scale': 1.13,
            'heading': 325.076355286459
        },
        {
            'lat': 38.88812646110895,
            'lon': -77.42120896084396,
            'scale': 0.956,
            'heading': 346.57583068376334
        },
        {
            'lat': 38.891815354984544,
            'lon': -77.41858597095361,
            'scale': 0.937,
            'heading': 248.5862397446038
        },
        {
            'lat': 38.89046573635294,
            'lon': -77.41847645170516,
            'scale': 0.928,
            'heading': 140.6670162346888
        },
        {
            'lat': 38.88827851447506,
            'lon': -77.42118629501816,
            'scale': 0.96,
            'heading': 288.6828059425426
        },
        {
            'lat': 38.89170511776311,
            'lon': -77.41837012195887,
            'scale': 0.976,
            'heading': 48.08064042596665
        },
        {
            'lat': 38.8922151023168,
            'lon': -77.41814290715693,
            'scale': 0.864,
            'heading': 276.32923725674976
        },
        {
            'lat': 38.89227178236557,
            'lon': -77.41796747394092,
            'scale': 0.945,
            'heading': 9.14374048657692
        },
        {
            'lat': 38.888738895806966,
            'lon': -77.42091415151161,
            'scale': 0.83,
            'heading': 219.69711757278574
        },
        {
            'lat': 38.89005931057578,
            'lon': -77.4179792176376,
            'scale': 0.971,
            'heading': 290.5125938680051
        },
        {
            'lat': 38.89154502362329,
            'lon': -77.41834234425475,
            'scale': 1.111,
            'heading': 92.41331598747685
        },
        {
            'lat': 38.89184627752217,
            'lon': -77.41866087530246,
            'scale': 0.83,
            'heading': 5.573092603989016
        },
        {
            'lat': 38.8915730712455,
            'lon': -77.41847276672324,
            'scale': 0.999,
            'heading': 166.32640462466375
        },
        {
            'lat': 38.889998877093554,
            'lon': -77.41852656200967,
            'scale': 1.186,
            'heading': 89.05748035449403
        },
        {
            'lat': 38.888335263944114,
            'lon': -77.42105286138361,
            'scale': 1.147,
            'heading': 187.18720056501056
        },
        {
            'lat': 38.892036197393715,
            'lon': -77.41867595939352,
            'scale': 1.014,
            'heading': 294.3039909547409
        },
        {
            'lat': 38.89136979156886,
            'lon': -77.41841380373076,
            'scale': 0.933,
            'heading': 258.64605960416924
        },
        {
            'lat': 38.888514296243414,
            'lon': -77.421164664214,
            'scale': 1.19,
            'heading': 337.6619367137657
        },
        {
            'lat': 38.89093530572398,
            'lon': -77.41865556795607,
            'scale': 1.022,
            'heading': 285.27498997026754
        },
        {
            'lat': 38.89155382109366,
            'lon': -77.41842762204472,
            'scale': 0.821,
            'heading': 187.51428431539338
        },
        {
            'lat': 38.89110037280146,
            'lon': -77.41868585334305,
            'scale': 1.187,
            'heading': 64.01030003393086
        },
        {
            'lat': 38.892016471943315,
            'lon': -77.41875848092727,
            'scale': 1.005,
            'heading': 255.45489330948718
        },
        {
            'lat': 38.89044370480584,
            'lon': -77.41839270547736,
            'scale': 1.066,
            'heading': 150.55585627593004
        },
        {
            'lat': 38.89041059643176,
            'lon': -77.41866130774469,
            'scale': 1.013,
            'heading': 299.0954670868119
        },
        {
            'lat': 38.89223234774112,
            'lon': -77.41895177069144,
            'scale': 1.091,
            'heading': 135.77071934188123
        },
        {
            'lat': 38.89227447814846,
            'lon': -77.4185817180288,
            'scale': 0.834,
            'heading': 213.8426171963107
        },
        {
            'lat': 38.89009832127836,
            'lon': -77.41808304306123,
            'scale': 0.89,
            'heading': 159.17677492195776
        },
        {
            'lat': 38.892336825915464,
            'lon': -77.41769494310212,
            'scale': 0.889,
            'heading': 125.89783326877362
        },
        {
            'lat': 38.88992271394852,
            'lon': -77.41786026599586,
            'scale': 1.122,
            'heading': 181.06114785542917
        },
        {
            'lat': 38.89011591737813,
            'lon': -77.41872330462803,
            'scale': 1.027,
            'heading': 298.927760519236
        },
        {
            'lat': 38.892142156397476,
            'lon': -77.41788725852523,
            'scale': 0.901,
            'heading': 19.43109657562146
        },
        {
            'lat': 38.892350518851345,
            'lon': -77.41868161812651,
            'scale': 0.819,
            'heading': 92.52582797714348
        },
        {
            'lat': 38.89028030308509,
            'lon': -77.41823934842103,
            'scale': 0.925,
            'heading': 287.99584782017655
        },
        {
            'lat': 38.89125703124942,
            'lon': -77.41876660161043,
            'scale': 0.944,
            'heading': 154.14241989225224
        },
        {
            'lat': 38.88824135014276,
            'lon': -77.42084060222327,
            'scale': 1.099,
            'heading': 166.6714699237834
        },
        {
            'lat': 38.89100615032125,
            'lon': -77.41867481180338,
            'scale': 0.961,
            'heading': 336.913842864734
        },
        {
            'lat': 38.88838687331817,
            'lon': -77.42138861391433,
            'scale': 0.964,
            'heading': 175.45834762573395
        },
        {
            'lat': 38.89019840820258,
            'lon': -77.41847138039935,
            'scale': 1.014,
            'heading': 194.0650627928306
        },
        {
            'lat': 38.889445555514314,
            'lon': -77.41909520122266,
            'scale': 1.164,
            'heading': 245.23111183504562
        },
        {
            'lat': 38.8922185250883,
            'lon': -77.41834826848556,
            'scale': 1.14,
            'heading': 234.40650105741219
        },
        {
            'lat': 38.89009124437528,
            'lon': -77.41849224461463,
            'scale': 1.062,
            'heading': 225.68019869467702
        },
        {
            'lat': 38.891731884727236,
            'lon': -77.41883725580493,
            'scale': 0.878,
            'heading': 74.26704850738145
        },
        {
            'lat': 38.889935826291364,
            'lon': -77.41806964827114,
            'scale': 1.025,
            'heading': 109.95856997013259
        },
        {
            'lat': 38.891016763043815,
            'lon': -77.41861742625933,
            'scale': 0.895,
            'heading': 2.886103478478468
        },
        {
            'lat': 38.89224150295695,
            'lon': -77.41809420324724,
            'scale': 0.887,
            'heading': 98.64961626564546
        },
        {
            'lat': 38.89100533378457,
            'lon': -77.41868979345531,
            'scale': 1.115,
            'heading': 110.45219497097706
        },
        {
            'lat': 38.89159348822161,
            'lon': -77.41806736129315,
            'scale': 1.19,
            'heading': 240.11492551005804
        },
        {
            'lat': 38.88980720240105,
            'lon': -77.4180828428002,
            'scale': 0.954,
            'heading': 258.6359263399934
        },
        {
            'lat': 38.88809429403587,
            'lon': -77.42086830497931,
            'scale': 1.005,
            'heading': 12.043567860236394
        },
        {
            'lat': 38.8919607338778,
            'lon': -77.41889169431316,
            'scale': 0.88,
            'heading': 48.68560688392084
        },
        {
            'lat': 38.890052820530705,
            'lon': -77.41787830402926,
            'scale': 0.814,
            'heading': 89.41904817633475
        },
        {
            'lat': 38.89078469985232,
            'lon': -77.418675493009,
            'scale': 0.884,
            'heading': 216.56426654605315
        },
        {
            'lat': 38.89018720699656,
            'lon': -77.41872379972163,
            'scale': 1.11,
            'heading': 335.90781948888696
        },
        {
            'lat': 38.890480040320334,
            'lon': -77.4188150771937,
            'scale': 0.827,
            'heading': 319.32730062941295
        },
        {
            'lat': 38.89132283900743,
            'lon': -77.41889406699437,
            'scale': 1.056,
            'heading': 278.1523510400881
        },
        {
            'lat': 38.888282507933816,
            'lon': -77.42122847886682,
            'scale': 1.145,
            'heading': 5.730054912401394
        },
        {
            'lat': 38.889981927800825,
            'lon': -77.41846972724402,
            'scale': 1.182,
            'heading': 334.87452203271437
        },
        {
            'lat': 38.89223869795025,
            'lon': -77.4190914193285,
            'scale': 0.872,
            'heading': 247.91779280606622
        },
        {
            'lat': 38.89065421950593,
            'lon': -77.41802012118039,
            'scale': 1.076,
            'heading': 307.77916550115236
        },
        {
            'lat': 38.8899956259896,
            'lon': -77.41801916923612,
            'scale': 1.189,
            'heading': 200.17299424258337
        },
        {
            'lat': 38.89195105702835,
            'lon': -77.41797874226783,
            'scale': 0.889,
            'heading': 170.272971537613
        },
        {
            'lat': 38.89147214124891,
            'lon': -77.41838778196785,
            'scale': 0.907,
            'heading': 326.0433486337604
        },
        {
            'lat': 38.88844831885012,
            'lon': -77.42136505050539,
            'scale': 0.974,
            'heading': 220.85869773898978
        },
        {
            'lat': 38.89230399223761,
            'lon': -77.41780088406284,
            'scale': 0.919,
            'heading': 263.605638771264
        },
        {
            'lat': 38.89184151582217,
            'lon': -77.41853594454811,
            'scale': 1.035,
            'heading': 31.511156132581863
        },
        {
            'lat': 38.891398491302205,
            'lon': -77.41848372309872,
            'scale': 0.849,
            'heading': 62.296305807253404
        },
        {
            'lat': 38.89206869765249,
            'lon': -77.41807488116198,
            'scale': 0.837,
            'heading': 61.021830532252494
        },
        {
            'lat': 38.89219246383989,
            'lon': -77.41879329611915,
            'scale': 1.123,
            'heading': 58.6709681931723
        },
        {
            'lat': 38.89172268476533,
            'lon': -77.41834028754383,
            'scale': 0.942,
            'heading': 156.62930768026172
        },
        {
            'lat': 38.89053974050898,
            'lon': -77.41853972538131,
            'scale': 0.851,
            'heading': 278.2506081163054
        },
        {
            'lat': 38.89069541092618,
            'lon': -77.41895806921771,
            'scale': 0.945,
            'heading': 141.21860472215275
        },
        {
            'lat': 38.891072206330364,
            'lon': -77.41866913347884,
            'scale': 1.121,
            'heading': 332.6920446718561
        },
        {
            'lat': 38.89051392088256,
            'lon': -77.41893027752252,
            'scale': 0.929,
            'heading': 9.629308937756388
        },
        {
            'lat': 38.890962409415295,
            'lon': -77.4185311181735,
            'scale': 1.196,
            'heading': 45.292200476957106
        },
        {
            'lat': 38.89017254406745,
            'lon': -77.41789243993526,
            'scale': 0.957,
            'heading': 42.89801772510416
        },
        {
            'lat': 38.89045477301118,
            'lon': -77.41808944529576,
            'scale': 0.91,
            'heading': 253.20341513232248
        },
        {
            'lat': 38.8920206543201,
            'lon': -77.41850389198196,
            'scale': 0.854,
            'heading': 30.999430094418365
        },
        {
            'lat': 38.891124352252014,
            'lon': -77.41835894636966,
            'scale': 0.858,
            'heading': 71.27372724769548
        },
        {
            'lat': 38.88986900284017,
            'lon': -77.41830271407498,
            'scale': 0.937,
            'heading': 216.6299513263102
        },
        {
            'lat': 38.88954915577965,
            'lon': -77.41855884472642,
            'scale': 1.075,
            'heading': 98.52787266445661
        },
        {
            'lat': 38.890713916277804,
            'lon': -77.41890325519431,
            'scale': 1.062,
            'heading': 351.4022494452851
        },
        {
            'lat': 38.890793868229615,
            'lon': -77.4185539140472,
            'scale': 0.919,
            'heading': 184.52098249833162
        },
        {
            'lat': 38.89163245435143,
            'lon': -77.41873010407808,
            'scale': 1.094,
            'heading': 158.98342203159743
        },
        {
            'lat': 38.89068652178686,
            'lon': -77.4184462875764,
            'scale': 0.963,
            'heading': 170.64921011734342
        },
        {
            'lat': 38.89137547626992,
            'lon': -77.41822113179055,
            'scale': 0.929,
            'heading': 105.88685543869975
        },
        {
            'lat': 38.89001023167448,
            'lon': -77.41841050026275,
            'scale': 1.189,
            'heading': 122.59927948765164
        },
        {
            'lat': 38.891515431713266,
            'lon': -77.4185105147338,
            'scale': 0.911,
            'heading': 255.17309875780265
        },
        {
            'lat': 38.88847209978715,
            'lon': -77.42125726747727,
            'scale': 1.137,
            'heading': 55.530573020240894
        },
        {
            'lat': 38.89189850956258,
            'lon': -77.41839484899147,
            'scale': 1.032,
            'heading': 237.0945075197586
        },
        {
            'lat': 38.889485334979156,
            'lon': -77.41878049082001,
            'scale': 0.971,
            'heading': 58.94074200428022
        },
        {
            'lat': 38.89237370924682,
            'lon': -77.4177798834644,
            'scale': 0.976,
            'heading': 174.9533487930212
        },
        {
            'lat': 38.89068916099627,
            'lon': -77.41819575813271,
            'scale': 1.135,
            'heading': 359.766091705495
        },
        {
            'lat': 38.89235682068009,
            'lon': -77.41878951131571,
            'scale': 0.906,
            'heading': 318.6756827166898
        },
        {
            'lat': 38.89176876781302,
            'lon': -77.4187391760765,
            'scale': 1.034,
            'heading': 4.185585480431135
        },
        {
            'lat': 38.89212880068794,
            'lon': -77.41798079701594,
            'scale': 0.961,
            'heading': 35.51406246297532
        },
        {
            'lat': 38.888326726316876,
            'lon': -77.42093712069872,
            'scale': 1.097,
            'heading': 199.2613983252193
        },
        {
            'lat': 38.89182184695743,
            'lon': -77.4189723088924,
            'scale': 0.835,
            'heading': 309.88165299496296
        },
        {
            'lat': 38.88831496963722,
            'lon': -77.42114096846906,
            'scale': 0.938,
            'heading': 295.18656161600836
        },
        {
            'lat': 38.89191595216567,
            'lon': -77.41849719356848,
            'scale': 1.183,
            'heading': 76.67861292990173
        },
        {
            'lat': 38.88955022229639,
            'lon': -77.41767970835866,
            'scale': 1.155,
            'heading': 267.2711802750416
        },
        {
            'lat': 38.89213040103691,
            'lon': -77.41776786343964,
            'scale': 1.154,
            'heading': 198.80509020514864
        },
        {
            'lat': 38.890323240301626,
            'lon': -77.41819818043729,
            'scale': 1.108,
            'heading': 196.76837634027257
        },
        {
            'lat': 38.89068068887638,
            'lon': -77.41864336914995,
            'scale': 0.932,
            'heading': 204.30723084820931
        },
        {
            'lat': 38.890882930469516,
            'lon': -77.4189918286449,
            'scale': 0.937,
            'heading': 353.6566424057814
        },
        {
            'lat': 38.8882159942636,
            'lon': -77.42101616712178,
            'scale': 1.16,
            'heading': 48.39869700859092
        },
        {
            'lat': 38.89215427219241,
            'lon': -77.41866070483113,
            'scale': 0.93,
            'heading': 86.44070112715487
        },
        {
            'lat': 38.89138434254063,
            'lon': -77.41844103017738,
            'scale': 0.873,
            'heading': 167.57259849405915
        },
        {
            'lat': 38.891995581381714,
            'lon': -77.41774088031416,
            'scale': 1.165,
            'heading': 147.432824480723
        },
        {
            'lat': 38.88821307619419,
            'lon': -77.42133325504216,
            'scale': 0.83,
            'heading': 331.6050868356405
        },
        {
            'lat': 38.891939159974314,
            'lon': -77.4181352110884,
            'scale': 0.824,
            'heading': 246.4531707147467
        },
        {
            'lat': 38.89166142331271,
            'lon': -77.41873453714376,
            'scale': 0.964,
            'heading': 314.23680324379876
        },
        {
            'lat': 38.890814133549306,
            'lon': -77.41871100240922,
            'scale': 0.949,
            'heading': 138.49864351259538
        },
        {
            'lat': 38.890001713005056,
            'lon': -77.41849661318167,
            'scale': 1.149,
            'heading': 326.48702624631574
        },
        {
            'lat': 38.889958956774684,
            'lon': -77.4188051309425,
            'scale': 0.913,
            'heading': 41.84387167349041
        },
        {
            'lat': 38.89092139078729,
            'lon': -77.4181476817844,
            'scale': 1.199,
            'heading': 152.64191464065564
        },
        {
            'lat': 38.891811846099564,
            'lon': -77.41894159028416,
            'scale': 1.014,
            'heading': 227.66576792780782
        },
        {
            'lat': 38.892028914216944,
            'lon': -77.4188584087151,
            'scale': 0.998,
            'heading': 221.73020402462734
        },
        {
            'lat': 38.88833446591193,
            'lon': -77.42116022000607,
            'scale': 0.996,
            'heading': 208.3368987429743
        },
        {
            'lat': 38.89016458174022,
            'lon': -77.41784647112362,
            'scale': 1.162,
            'heading': 91.33474990545643
        },
        {
            'lat': 38.891454535617946,
            'lon': -77.4185780622177,
            'scale': 1.15,
            'heading': 259.40757963318214
        },
        {
            'lat': 38.890263768364704,
            'lon': -77.41807265086534,
            'scale': 1.117,
            'heading': 28.149956829740518
        },
        {
            'lat': 38.89161509481641,
            'lon': -77.418625182595,
            'scale': 1.178,
            'heading': 243.3271008428521
        },
        {
            'lat': 38.89022868315404,
            'lon': -77.4183582743597,
            'scale': 1.043,
            'heading': 319.6895924704227
        },
        {
            'lat': 38.891863017213666,
            'lon': -77.41807417116314,
            'scale': 0.863,
            'heading': 309.0781783257189
        },
        {
            'lat': 38.89009102914283,
            'lon': -77.4187365215202,
            'scale': 1.139,
            'heading': 236.79868165130515
        },
        {
            'lat': 38.89162169900188,
            'lon': -77.4187566208397,
            'scale': 0.864,
            'heading': 221.3340105286791
        },
        {
            'lat': 38.89120348142299,
            'lon': -77.4186383782583,
            'scale': 0.925,
            'heading': 106.53651827360521
        },
        {
            'lat': 38.89148663986312,
            'lon': -77.41822734821103,
            'scale': 0.903,
            'heading': 216.42626240350003
        },
        {
            'lat': 38.89002171134363,
            'lon': -77.41829315053762,
            'scale': 0.95,
            'heading': 310.3990414964895
        },
        {
            'lat': 38.888114236215344,
            'lon': -77.42101020823385,
            'scale': 0.991,
            'heading': 314.7459241589467
        },
        {
            'lat': 38.88820263316253,
            'lon': -77.42147943249941,
            'scale': 1.159,
            'heading': 251.7826596625025
        },
        {
            'lat': 38.89085376023301,
            'lon': -77.41831486643883,
            'scale': 0.822,
            'heading': 166.35361767042946
        },
        {
            'lat': 38.89197293504574,
            'lon': -77.41895686177547,
            'scale': 1.127,
            'heading': 59.274392386965665
        },
        {
            'lat': 38.891371584955166,
            'lon': -77.418816822771,
            'scale': 1.038,
            'heading': 159.70211896864117
        },
        {
            'lat': 38.89014895884647,
            'lon': -77.41833237663789,
            'scale': 1.171,
            'heading': 228.97529715844755
        },
        {
            'lat': 38.891837079435014,
            'lon': -77.41861162757861,
            'scale': 1.086,
            'heading': 221.23472216083496
        },
        {
            'lat': 38.89011348909828,
            'lon': -77.41782557716712,
            'scale': 0.988,
            'heading': 13.623226387286834
        },
        {
            'lat': 38.890695613495815,
            'lon': -77.41837655256776,
            'scale': 1.136,
            'heading': 179.24041044314612
        },
        {
            'lat': 38.89218331138065,
            'lon': -77.4180915355339,
            'scale': 0.993,
            'heading': 237.13096225049526
        },
        {
            'lat': 38.89125182781233,
            'lon': -77.41893836975918,
            'scale': 1.159,
            'heading': 180.1459871773856
        },
        {
            'lat': 38.889607519331015,
            'lon': -77.41822591786494,
            'scale': 1.134,
            'heading': 281.4201545546617
        },
        {
            'lat': 38.89131885092983,
            'lon': -77.41815242055844,
            'scale': 0.858,
            'heading': 116.30580684250768
        },
        {
            'lat': 38.89158849180706,
            'lon': -77.41866647022444,
            'scale': 0.821,
            'heading': 62.1777023554521
        },
        {
            'lat': 38.89049876182262,
            'lon': -77.41843363683878,
            'scale': 1.181,
            'heading': 320.5826341776145
        },
        {
            'lat': 38.89141911362301,
            'lon': -77.41814356810946,
            'scale': 0.874,
            'heading': 277.6056235172801
        },
        {
            'lat': 38.88866740235344,
            'lon': -77.42090645229241,
            'scale': 1.144,
            'heading': 243.10820511706726
        },
        {
            'lat': 38.89026366808732,
            'lon': -77.41882295179155,
            'scale': 0.963,
            'heading': 8.68887796162868
        },
        {
            'lat': 38.89140149135912,
            'lon': -77.41859102423962,
            'scale': 0.953,
            'heading': 238.0765510536037
        },
        {
            'lat': 38.89095880656465,
            'lon': -77.41811904697649,
            'scale': 1.032,
            'heading': 312.70708301046716
        },
        {
            'lat': 38.89150129414536,
            'lon': -77.41859331395632,
            'scale': 0.827,
            'heading': 39.37302346424965
        },
        {
            'lat': 38.892293353740016,
            'lon': -77.41914992520127,
            'scale': 1.167,
            'heading': 174.12355451261985
        },
        {
            'lat': 38.89195760552685,
            'lon': -77.41881355338435,
            'scale': 0.931,
            'heading': 100.1166508023857
        },
        {
            'lat': 38.889841982110426,
            'lon': -77.41841010823971,
            'scale': 0.995,
            'heading': 172.85926926279913
        },
        {
            'lat': 38.890246368919286,
            'lon': -77.41862893124244,
            'scale': 0.865,
            'heading': 218.0703252774818
        },
        {
            'lat': 38.890915763691055,
            'lon': -77.41894171220025,
            'scale': 0.886,
            'heading': 338.17009707683656
        },
        {
            'lat': 38.891946637018535,
            'lon': -77.4184420562235,
            'scale': 0.836,
            'heading': 316.34461961885563
        },
        {
            'lat': 38.892010366666874,
            'lon': -77.41885620035197,
            'scale': 1.037,
            'heading': 243.86488872965535
        },
        {
            'lat': 38.89209873571393,
            'lon': -77.41890407454764,
            'scale': 1.184,
            'heading': 281.3708641487018
        },
        {
            'lat': 38.88824984095784,
            'lon': -77.42118543921977,
            'scale': 0.863,
            'heading': 224.1922499183391
        },
        {
            'lat': 38.89181772807658,
            'lon': -77.4186123847743,
            'scale': 1.192,
            'heading': 97.76768160631978
        },
        {
            'lat': 38.89224222458739,
            'lon': -77.41873823661376,
            'scale': 1.061,
            'heading': 300.1955171326173
        },
        {
            'lat': 38.89052781055725,
            'lon': -77.41831824880427,
            'scale': 1.066,
            'heading': 213.4526785846784
        },
        {
            'lat': 38.89115932062289,
            'lon': -77.41846177464289,
            'scale': 1.113,
            'heading': 271.02463903727323
        },
        {
            'lat': 38.890336862213275,
            'lon': -77.41833064546209,
            'scale': 1.054,
            'heading': 16.400107418470846
        },
        {
            'lat': 38.891026167450455,
            'lon': -77.4180944418727,
            'scale': 0.873,
            'heading': 97.41944847441005
        },
        {
            'lat': 38.89200749408265,
            'lon': -77.41854634443571,
            'scale': 1.056,
            'heading': 165.9178136790066
        },
        {
            'lat': 38.89043096880839,
            'lon': -77.41862550969458,
            'scale': 1.014,
            'heading': 283.1892553303571
        },
        {
            'lat': 38.88979899738132,
            'lon': -77.41839573658642,
            'scale': 0.943,
            'heading': 155.24242484747245
        },
        {
            'lat': 38.89114856902114,
            'lon': -77.4183009801176,
            'scale': 1.126,
            'heading': 255.03240055093215
        },
        {
            'lat': 38.890628764934064,
            'lon': -77.41889737557683,
            'scale': 0.877,
            'heading': 50.62014101862998
        },
        {
            'lat': 38.892157273886134,
            'lon': -77.41790259196881,
            'scale': 0.817,
            'heading': 144.4015740581309
        },
        {
            'lat': 38.89036313275645,
            'lon': -77.41845306586136,
            'scale': 0.87,
            'heading': 189.0186352332127
        },
        {
            'lat': 38.892165773715476,
            'lon': -77.41774803584585,
            'scale': 1.037,
            'heading': 37.36607182267891
        },
        {
            'lat': 38.890297203791405,
            'lon': -77.41813454193645,
            'scale': 0.895,
            'heading': 247.2830867051014
        },
        {
            'lat': 38.891947344272054,
            'lon': -77.41770250967008,
            'scale': 1.088,
            'heading': 68.0210531084164
        },
        {
            'lat': 38.89103284741513,
            'lon': -77.4183011496359,
            'scale': 0.847,
            'heading': 183.25017117789704
        },
        {
            'lat': 38.89071034993942,
            'lon': -77.418336364328,
            'scale': 0.955,
            'heading': 233.7196564639792
        },
        {
            'lat': 38.89198532540022,
            'lon': -77.41855426357004,
            'scale': 1.036,
            'heading': 344.2045770689275
        },
        {
            'lat': 38.89047855665072,
            'lon': -77.41808187478532,
            'scale': 1.175,
            'heading': 4.5985504874099625
        },
        {
            'lat': 38.89002177874013,
            'lon': -77.41881454726955,
            'scale': 1.18,
            'heading': 107.82673824646527
        },
        {
            'lat': 38.8908819772321,
            'lon': -77.41853657712446,
            'scale': 0.853,
            'heading': 291.22894733157193
        },
        {
            'lat': 38.890497233484346,
            'lon': -77.41875848269365,
            'scale': 0.831,
            'heading': 240.60490381073447
        },
        {
            'lat': 38.888443849076374,
            'lon': -77.42091353871284,
            'scale': 0.987,
            'heading': 232.5815382920476
        },
        {
            'lat': 38.888664176159836,
            'lon': -77.42093329718101,
            'scale': 1.067,
            'heading': 149.6794778758735
        },
        {
            'lat': 38.89071496519742,
            'lon': -77.4179810172378,
            'scale': 0.815,
            'heading': 226.04371058085567
        },
        {
            'lat': 38.89236871761267,
            'lon': -77.41908054360619,
            'scale': 0.936,
            'heading': 358.76154039404923
        },
        {
            'lat': 38.89097350154666,
            'lon': -77.41894957885613,
            'scale': 1.104,
            'heading': 46.51343774550372
        },
        {
            'lat': 38.88854619549021,
            'lon': -77.42107577339175,
            'scale': 1.132,
            'heading': 262.3422714476843
        },
        {
            'lat': 38.8921387435898,
            'lon': -77.41807941576266,
            'scale': 1.043,
            'heading': 49.4275613799101
        },
        {
            'lat': 38.890892303638935,
            'lon': -77.41873171917632,
            'scale': 1.142,
            'heading': 329.4804193359778
        },
        {
            'lat': 38.892070252455746,
            'lon': -77.41823816546851,
            'scale': 1.117,
            'heading': 276.06251774967296
        },
        {
            'lat': 38.89212638272333,
            'lon': -77.41870586584926,
            'scale': 0.93,
            'heading': 254.15144080341685
        },
        {
            'lat': 38.890651920334726,
            'lon': -77.41854204402935,
            'scale': 1.089,
            'heading': 253.5353348974627
        },
        {
            'lat': 38.8914475595791,
            'lon': -77.41864461903855,
            'scale': 0.896,
            'heading': 45.33822786218042
        },
        {
            'lat': 38.89201667724229,
            'lon': -77.41896289665088,
            'scale': 1.183,
            'heading': 57.91167056406569
        },
        {
            'lat': 38.89038488013681,
            'lon': -77.41840202352071,
            'scale': 0.856,
            'heading': 282.9497777520866
        },
        {
            'lat': 38.8914857103995,
            'lon': -77.41811936225695,
            'scale': 1.147,
            'heading': 346.48520722886775
        },
        {
            'lat': 38.891175372795004,
            'lon': -77.41814867472723,
            'scale': 0.816,
            'heading': 31.070476832423495
        },
        {
            'lat': 38.891855123748414,
            'lon': -77.41839958113589,
            'scale': 1.056,
            'heading': 248.5359247304819
        },
        {
            'lat': 38.890992830224164,
            'lon': -77.4187056477977,
            'scale': 0.944,
            'heading': 77.99535961624971
        },
        {
            'lat': 38.889955819944994,
            'lon': -77.4181432013103,
            'scale': 1.067,
            'heading': 354.4637768879821
        },
        {
            'lat': 38.89226665014599,
            'lon': -77.4180546368685,
            'scale': 1.156,
            'heading': 77.4299736206223
        },
        {
            'lat': 38.89237066960844,
            'lon': -77.41906256645555,
            'scale': 1.13,
            'heading': 56.25169382762672
        },
        {
            'lat': 38.88830675011149,
            'lon': -77.42119605209194,
            'scale': 1.014,
            'heading': 133.20831750697056
        },
        {
            'lat': 38.89026191183227,
            'lon': -77.41802953716108,
            'scale': 1.038,
            'heading': 304.0288869635736
        },
        {
            'lat': 38.89005326862497,
            'lon': -77.41804119163426,
            'scale': 1.19,
            'heading': 26.853706111040857
        },
        {
            'lat': 38.89157950752703,
            'lon': -77.41892557136752,
            'scale': 1.146,
            'heading': 117.15788098699481
        },
        {
            'lat': 38.891004113751166,
            'lon': -77.41824638217051,
            'scale': 1.109,
            'heading': 337.4578552410725
        },
        {
            'lat': 38.892036089700035,
            'lon': -77.41805986021255,
            'scale': 1.051,
            'heading': 35.9039029995887
        },
        {
            'lat': 38.88987843703965,
            'lon': -77.41853879669645,
            'scale': 0.989,
            'heading': 99.09763884903548
        },
        {
            'lat': 38.89009941569198,
            'lon': -77.4188141992051,
            'scale': 0.871,
            'heading': 89.75594612837831
        },
        {
            'lat': 38.890282115152246,
            'lon': -77.41862436589365,
            'scale': 0.986,
            'heading': 198.46942272904195
        },
        {
            'lat': 38.89180384748637,
            'lon': -77.41801505559069,
            'scale': 1.006,
            'heading': 41.72371497673473
        },
        {
            'lat': 38.89193648407683,
            'lon': -77.41836238884773,
            'scale': 1.151,
            'heading': 45.123503121213695
        },
        {
            'lat': 38.8919520642063,
            'lon': -77.41868765949334,
            'scale': 0.837,
            'heading': 343.644064609508
        },
        {
            'lat': 38.88983481871884,
            'lon': -77.41854896426952,
            'scale': 0.905,
            'heading': 15.905038726197848
        },
        {
            'lat': 38.89045733895196,
            'lon': -77.41869780983612,
            'scale': 1.114,
            'heading': 77.11382535392204
        },
        {
            'lat': 38.88812691502296,
            'lon': -77.42135230407472,
            'scale': 1.128,
            'heading': 129.38412430337152
        },
        {
            'lat': 38.89180383077996,
            'lon': -77.41820400095932,
            'scale': 0.983,
            'heading': 237.73660108317674
        },
        {
            'lat': 38.889486242077815,
            'lon': -77.41899885513835,
            'scale': 0.953,
            'heading': 170.97253295186547
        },
        {
            'lat': 38.89202612860626,
            'lon': -77.41882656388984,
            'scale': 0.995,
            'heading': 14.40429672496332
        },
        {
            'lat': 38.8919261384061,
            'lon': -77.41824724398889,
            'scale': 1.124,
            'heading': 180.1690731464843
        },
        {
            'lat': 38.889871179163414,
            'lon': -77.41848082411151,
            'scale': 0.867,
            'heading': 308.1030014550465
        },
        {
            'lat': 38.891682426984964,
            'lon': -77.41864989965536,
            'scale': 0.949,
            'heading': 104.849321299467
        },
        {
            'lat': 38.89187167428364,
            'lon': -77.41879033657271,
            'scale': 0.881,
            'heading': 4.256472099847879
        },
        {
            'lat': 38.891078566157645,
            'lon': -77.41843055593047,
            'scale': 0.871,
            'heading': 207.26797062560058
        },
        {
            'lat': 38.89075235209148,
            'lon': -77.41876090097071,
            'scale': 0.88,
            'heading': 218.12525810040282
        },
        {
            'lat': 38.891683412266026,
            'lon': -77.41817718484506,
            'scale': 1.004,
            'heading': 150.30612893789012
        },
        {
            'lat': 38.89204494279896,
            'lon': -77.41839716641051,
            'scale': 0.957,
            'heading': 280.4822893036427
        },
        {
            'lat': 38.89201723025748,
            'lon': -77.4176941816965,
            'scale': 1.118,
            'heading': 282.3296421246663
        },
        {
            'lat': 38.892228779751726,
            'lon': -77.41778308753001,
            'scale': 1.024,
            'heading': 345.4769968391142
        },
        {
            'lat': 38.891027548940365,
            'lon': -77.41815822169836,
            'scale': 1.013,
            'heading': 51.030733953214224
        },
        {
            'lat': 38.890123911682615,
            'lon': -77.41778228096022,
            'scale': 1.187,
            'heading': 91.25762960067807
        },
        {
            'lat': 38.89197279010135,
            'lon': -77.41799578886469,
            'scale': 1.165,
            'heading': 256.77308269149535
        },
        {
            'lat': 38.88990567761807,
            'lon': -77.41791004362118,
            'scale': 0.951,
            'heading': 150.0554492140719
        },
        {
            'lat': 38.889955409853926,
            'lon': -77.41772398365293,
            'scale': 0.809,
            'heading': 88.45388390956556
        },
        {
            'lat': 38.89090886473708,
            'lon': -77.4187002980491,
            'scale': 0.861,
            'heading': 23.07833054293721
        },
        {
            'lat': 38.89113501068466,
            'lon': -77.41889162942527,
            'scale': 1.143,
            'heading': 58.65842744405766
        },
        {
            'lat': 38.88959109876377,
            'lon': -77.4182181431324,
            'scale': 0.812,
            'heading': 185.70178178510503
        },
        {
            'lat': 38.89056743604915,
            'lon': -77.4181080861522,
            'scale': 1.037,
            'heading': 286.2605918381272
        },
        {
            'lat': 38.89188321060952,
            'lon': -77.41797384345098,
            'scale': 0.962,
            'heading': 67.6650609340552
        },
        {
            'lat': 38.889821843451934,
            'lon': -77.4183573610222,
            'scale': 1.027,
            'heading': 122.16306379382002
        },
        {
            'lat': 38.89141711402875,
            'lon': -77.41888908529191,
            'scale': 0.975,
            'heading': 250.49762135807097
        },
        {
            'lat': 38.89238721395106,
            'lon': -77.41779753977715,
            'scale': 0.922,
            'heading': 211.16174512975996
        },
        {
            'lat': 38.88954637117563,
            'lon': -77.41822680352976,
            'scale': 1.141,
            'heading': 302.4581225846517
        },
        {
            'lat': 38.8903688523887,
            'lon': -77.41877953665949,
            'scale': 1.142,
            'heading': 69.8065725622391
        },
        {
            'lat': 38.8923794300427,
            'lon': -77.41845706439472,
            'scale': 0.811,
            'heading': 241.74445083662684
        },
        {
            'lat': 38.89099240241011,
            'lon': -77.41844230798014,
            'scale': 1.006,
            'heading': 51.37690611455691
        },
        {
            'lat': 38.89012156524889,
            'lon': -77.41861101454526,
            'scale': 1.003,
            'heading': 341.0191925324803
        },
        {
            'lat': 38.892151966935714,
            'lon': -77.41811158059984,
            'scale': 0.915,
            'heading': 205.70592617437603
        },
        {
            'lat': 38.89045990827036,
            'lon': -77.41827085239825,
            'scale': 0.966,
            'heading': 39.1343734137284
        },
        {
            'lat': 38.890082362844886,
            'lon': -77.41842174172525,
            'scale': 1.09,
            'heading': 27.21796103351234
        },
        {
            'lat': 38.88989555635892,
            'lon': -77.41768319027354,
            'scale': 1.005,
            'heading': 263.78646913568326
        },
        {
            'lat': 38.89124404592634,
            'lon': -77.41817300544997,
            'scale': 1.139,
            'heading': 198.26306325322915
        },
        {
            'lat': 38.890032078796686,
            'lon': -77.41885227966687,
            'scale': 1.071,
            'heading': 123.33608684258066
        },
        {
            'lat': 38.890889963344236,
            'lon': -77.41814457756789,
            'scale': 0.818,
            'heading': 110.30723123348314
        },
        {
            'lat': 38.891448443918016,
            'lon': -77.41854208990705,
            'scale': 0.896,
            'heading': 45.11361056379706
        },
        {
            'lat': 38.89229460715641,
            'lon': -77.41781015671457,
            'scale': 1.161,
            'heading': 332.02813224804527
        },
        {
            'lat': 38.891951085030314,
            'lon': -77.41773759945315,
            'scale': 0.801,
            'heading': 192.31588397215717
        },
        {
            'lat': 38.89204258798164,
            'lon': -77.41838135362106,
            'scale': 0.918,
            'heading': 12.094475310054369
        },
        {
            'lat': 38.88993631242019,
            'lon': -77.41873460197436,
            'scale': 0.985,
            'heading': 324.0788327035959
        },
        {
            'lat': 38.89172832325119,
            'lon': -77.41806460135095,
            'scale': 0.802,
            'heading': 185.09657221486566
        },
        {
            'lat': 38.89216550291783,
            'lon': -77.41831082545744,
            'scale': 1.185,
            'heading': 295.42296623781215
        },
        {
            'lat': 38.88996590986636,
            'lon': -77.41821443334896,
            'scale': 0.966,
            'heading': 233.41499063234016
        },
        {
            'lat': 38.89179274665199,
            'lon': -77.41880454903828,
            'scale': 0.902,
            'heading': 24.502003269802437
        },
        {
            'lat': 38.8904019363708,
            'lon': -77.41867487088592,
            'scale': 0.814,
            'heading': 153.37230041386587
        },
        {
            'lat': 38.89128393847472,
            'lon': -77.41883621728174,
            'scale': 0.838,
            'heading': 284.2400130053983
        },
        {
            'lat': 38.89112411796145,
            'lon': -77.41875251410755,
            'scale': 0.921,
            'heading': 259.2196519012503
        },
        {
            'lat': 38.892220060569876,
            'lon': -77.41789659199395,
            'scale': 0.898,
            'heading': 15.897066901305802
        },
        {
            'lat': 38.890579204303705,
            'lon': -77.41894562737532,
            'scale': 1.189,
            'heading': 256.490031120469
        },
        {
            'lat': 38.88966889645505,
            'lon': -77.41884499424033,
            'scale': 0.812,
            'heading': 307.70043364064963
        },
        {
            'lat': 38.88830045836953,
            'lon': -77.42131353103771,
            'scale': 0.93,
            'heading': 22.29571556754951
        },
        {
            'lat': 38.891319921050346,
            'lon': -77.4189426715448,
            'scale': 0.904,
            'heading': 55.84529009009317
        },
        {
            'lat': 38.892377980771045,
            'lon': -77.41835684004253,
            'scale': 1.194,
            'heading': 142.59085789433288
        },
        {
            'lat': 38.889600332671606,
            'lon': -77.41820173925454,
            'scale': 1.078,
            'heading': 12.861875261170423
        },
        {
            'lat': 38.890147185972026,
            'lon': -77.41795190120573,
            'scale': 0.813,
            'heading': 260.0747892833915
        },
        {
            'lat': 38.891632248705534,
            'lon': -77.41878646899667,
            'scale': 1.021,
            'heading': 199.53948176017877
        },
        {
            'lat': 38.89225332855099,
            'lon': -77.41854752518806,
            'scale': 1.002,
            'heading': 102.714533329907
        },
        {
            'lat': 38.89044731964438,
            'lon': -77.41820537891566,
            'scale': 0.808,
            'heading': 95.10529223362589
        },
        {
            'lat': 38.88983924809566,
            'lon': -77.41771864778244,
            'scale': 0.892,
            'heading': 200.1664190885696
        },
        {
            'lat': 38.89176698899535,
            'lon': -77.4185764426213,
            'scale': 0.816,
            'heading': 278.399152695952
        },
        {
            'lat': 38.89023085653983,
            'lon': -77.41818278139476,
            'scale': 0.967,
            'heading': 207.04298000876523
        },
        {
            'lat': 38.89170640330139,
            'lon': -77.41833437593424,
            'scale': 1.166,
            'heading': 169.22569084319062
        },
        {
            'lat': 38.889961843240016,
            'lon': -77.41796655762741,
            'scale': 0.988,
            'heading': 216.01570122545974
        },
        {
            'lat': 38.89003065579609,
            'lon': -77.41859560500978,
            'scale': 0.986,
            'heading': 281.3821569682007
        },
        {
            'lat': 38.88862212714114,
            'lon': -77.42093414589421,
            'scale': 1.037,
            'heading': 54.78297500641842
        },
        {
            'lat': 38.89196610907768,
            'lon': -77.41832974762511,
            'scale': 1.118,
            'heading': 247.8999931562693
        },
        {
            'lat': 38.89018833939568,
            'lon': -77.41875309126065,
            'scale': 0.983,
            'heading': 168.24348900345197
        },
        {
            'lat': 38.892223764048474,
            'lon': -77.41851055614738,
            'scale': 1.078,
            'heading': 7.131672325134559
        },
        {
            'lat': 38.89007801298766,
            'lon': -77.41875812046091,
            'scale': 1.119,
            'heading': 117.0455969429504
        },
        {
            'lat': 38.89097585252245,
            'lon': -77.41847780656063,
            'scale': 1.078,
            'heading': 313.47541428452143
        },
        {
            'lat': 38.8903970631249,
            'lon': -77.4185241807835,
            'scale': 0.856,
            'heading': 63.5568468326001
        },
        {
            'lat': 38.89128767866826,
            'lon': -77.41809554777419,
            'scale': 1.165,
            'heading': 34.657875627817
        },
        {
            'lat': 38.88837007054022,
            'lon': -77.42136522653118,
            'scale': 1.061,
            'heading': 359.52434222975955
        },
        {
            'lat': 38.889544574956254,
            'lon': -77.41891600017425,
            'scale': 1.071,
            'heading': 248.28739764108082
        },
        {
            'lat': 38.891063739169915,
            'lon': -77.4187026394222,
            'scale': 1.078,
            'heading': 0.1364029256153243
        },
        {
            'lat': 38.890053904773744,
            'lon': -77.41831363118408,
            'scale': 0.937,
            'heading': 25.288623772875912
        },
        {
            'lat': 38.88992245094786,
            'lon': -77.41864109415458,
            'scale': 0.805,
            'heading': 160.26369982502976
        },
        {
            'lat': 38.89183358359046,
            'lon': -77.4179684179789,
            'scale': 1.102,
            'heading': 180.9989299463193
        },
        {
            'lat': 38.89003464701177,
            'lon': -77.41767838870352,
            'scale': 1.07,
            'heading': 329.9176428553694
        },
        {
            'lat': 38.890132477341844,
            'lon': -77.41810238718911,
            'scale': 0.886,
            'heading': 153.55408263560702
        },
        {
            'lat': 38.890937002332215,
            'lon': -77.41862709213356,
            'scale': 0.958,
            'heading': 136.23327788210017
        },
        {
            'lat': 38.89200817826542,
            'lon': -77.41851056982354,
            'scale': 0.893,
            'heading': 217.22816957281077
        },
        {
            'lat': 38.8920549527112,
            'lon': -77.41818032470474,
            'scale': 1.115,
            'heading': 210.2121774391397
        },
        {
            'lat': 38.891368407305826,
            'lon': -77.41827474083891,
            'scale': 1.087,
            'heading': 268.92504548861945
        },
        {
            'lat': 38.89099142313316,
            'lon': -77.4186457469662,
            'scale': 0.967,
            'heading': 304.1633142902479
        },
        {
            'lat': 38.89200588417391,
            'lon': -77.41886870417449,
            'scale': 0.839,
            'heading': 248.42673243903403
        },
        {
            'lat': 38.89095891767222,
            'lon': -77.41846867067726,
            'scale': 0.996,
            'heading': 320.8097092927755
        },
        {
            'lat': 38.89077637868353,
            'lon': -77.41815777162583,
            'scale': 1.093,
            'heading': 200.97740639740042
        },
        {
            'lat': 38.89195183407873,
            'lon': -77.41787901085964,
            'scale': 0.826,
            'heading': 55.26259033303186
        },
        {
            'lat': 38.89026296047007,
            'lon': -77.41867945832888,
            'scale': 1.129,
            'heading': 171.94133211691448
        },
        {
            'lat': 38.889554957832175,
            'lon': -77.4178823810883,
            'scale': 1.055,
            'heading': 317.37305127394285
        },
        {
            'lat': 38.889556888569125,
            'lon': -77.41837295968467,
            'scale': 0.935,
            'heading': 58.69132884318849
        },
        {
            'lat': 38.89099052147758,
            'lon': -77.41839303199754,
            'scale': 1.065,
            'heading': 265.3257257206454
        },
        {
            'lat': 38.88849513008244,
            'lon': -77.42125254786684,
            'scale': 0.826,
            'heading': 224.51346891201158
        },
        {
            'lat': 38.889928260222135,
            'lon': -77.41774775622822,
            'scale': 0.885,
            'heading': 322.7280832690519
        },
        {
            'lat': 38.89098177299925,
            'lon': -77.418329302348,
            'scale': 1.191,
            'heading': 79.07137144422356
        },
        {
            'lat': 38.89091480613804,
            'lon': -77.41832898229997,
            'scale': 1.135,
            'heading': 163.50712388112655
        },
        {
            'lat': 38.89237375912991,
            'lon': -77.41817194602703,
            'scale': 1.063,
            'heading': 28.824909645100945
        },
        {
            'lat': 38.89056856622973,
            'lon': -77.4182912779748,
            'scale': 0.92,
            'heading': 9.337318714081984
        },
        {
            'lat': 38.88987852014794,
            'lon': -77.41848244282313,
            'scale': 1.141,
            'heading': 5.015718134128124
        },
        {
            'lat': 38.89217578012006,
            'lon': -77.4191014417879,
            'scale': 0.829,
            'heading': 337.1418371169643
        },
        {
            'lat': 38.89221394744622,
            'lon': -77.41872380819962,
            'scale': 1.14,
            'heading': 116.30682820703095
        },
        {
            'lat': 38.89144008088297,
            'lon': -77.41822407972495,
            'scale': 0.955,
            'heading': 350.67551230656113
        },
        {
            'lat': 38.89097299491978,
            'lon': -77.41842299659034,
            'scale': 0.889,
            'heading': 36.47017644480352
        },
        {
            'lat': 38.8885685709356,
            'lon': -77.42104252016573,
            'scale': 1.056,
            'heading': 223.72727671739486
        },
        {
            'lat': 38.89237271291937,
            'lon': -77.41831125635572,
            'scale': 1.16,
            'heading': 125.34979146963788
        },
        {
            'lat': 38.892395057647704,
            'lon': -77.4189519131666,
            'scale': 1.186,
            'heading': 88.46352795872099
        },
        {
            'lat': 38.89033674810178,
            'lon': -77.4187415245265,
            'scale': 1.105,
            'heading': 106.4347603274838
        },
        {
            'lat': 38.890721425724955,
            'lon': -77.41849925519303,
            'scale': 0.948,
            'heading': 193.00143512600434
        },
        {
            'lat': 38.89156416491056,
            'lon': -77.41878022026775,
            'scale': 1.186,
            'heading': 99.69052059393842
        },
        {
            'lat': 38.89099626142792,
            'lon': -77.41814190374895,
            'scale': 0.826,
            'heading': 278.8869077941404
        },
        {
            'lat': 38.892115253123464,
            'lon': -77.41866089171556,
            'scale': 0.935,
            'heading': 324.03783179093085
        },
        {
            'lat': 38.88832725320672,
            'lon': -77.42104086833174,
            'scale': 0.968,
            'heading': 281.2106777696054
        },
        {
            'lat': 38.89205261026212,
            'lon': -77.41849436132883,
            'scale': 1.116,
            'heading': 320.0269661463122
        },
        {
            'lat': 38.890819996134525,
            'lon': -77.41859513196039,
            'scale': 1.157,
            'heading': 212.0219359172056
        },
        {
            'lat': 38.88849472701073,
            'lon': -77.42119303206596,
            'scale': 1.168,
            'heading': 11.258255631382553
        },
        {
            'lat': 38.892055786957975,
            'lon': -77.41864945260707,
            'scale': 1.171,
            'heading': 23.293581643559634
        },
        {
            'lat': 38.8922464826092,
            'lon': -77.41805333203297,
            'scale': 1.193,
            'heading': 306.37188137108785
        },
        {
            'lat': 38.89151906070055,
            'lon': -77.41867811090057,
            'scale': 1.143,
            'heading': 296.9551399744854
        },
        {
            'lat': 38.888320037792816,
            'lon': -77.42143975683712,
            'scale': 0.837,
            'heading': 350.34922276003977
        },
        {
            'lat': 38.89130319398273,
            'lon': -77.41808456661514,
            'scale': 0.877,
            'heading': 263.0538678883961
        },
        {
            'lat': 38.89177593503195,
            'lon': -77.41805177950349,
            'scale': 1.134,
            'heading': 61.20534453933815
        },
        {
            'lat': 38.891974457206246,
            'lon': -77.41871353509495,
            'scale': 1.12,
            'heading': 246.7590511387207
        },
        {
            'lat': 38.89144712437691,
            'lon': -77.41890453110527,
            'scale': 0.997,
            'heading': 180.44001430562923
        },
        {
            'lat': 38.88967012861261,
            'lon': -77.41850365773182,
            'scale': 1.108,
            'heading': 6.527297500389677
        },
        {
            'lat': 38.89087007838662,
            'lon': -77.41861193596644,
            'scale': 1.04,
            'heading': 183.0894099190537
        },
        {
            'lat': 38.892073710199696,
            'lon': -77.41842334275943,
            'scale': 1.092,
            'heading': 170.4110815834002
        },
        {
            'lat': 38.8907180173617,
            'lon': -77.41893071530833,
            'scale': 0.856,
            'heading': 352.3868633449055
        },
        {
            'lat': 38.88953600572339,
            'lon': -77.41864325690143,
            'scale': 1.078,
            'heading': 70.56653082173635
        },
        {
            'lat': 38.891859083348336,
            'lon': -77.41823247482627,
            'scale': 0.877,
            'heading': 161.54779953073654
        },
        {
            'lat': 38.8903164226024,
            'lon': -77.41829591463468,
            'scale': 1.039,
            'heading': 301.28467256369095
        },
        {
            'lat': 38.89149893551632,
            'lon': -77.41870613959016,
            'scale': 0.905,
            'heading': 58.35423679160696
        },
        {
            'lat': 38.88808662313329,
            'lon': -77.42125585225754,
            'scale': 1.039,
            'heading': 145.28516937030997
        },
        {
            'lat': 38.89194041465494,
            'lon': -77.41892691424313,
            'scale': 1.158,
            'heading': 118.50387582628878
        },
        {
            'lat': 38.89038363363038,
            'lon': -77.4183223209031,
            'scale': 1.004,
            'heading': 33.21903744638287
        },
        {
            'lat': 38.891170633299645,
            'lon': -77.41834999248,
            'scale': 1.177,
            'heading': 156.81729637062224
        },
        {
            'lat': 38.88859817375775,
            'lon': -77.42111381531411,
            'scale': 1.181,
            'heading': 100.93853800143647
        },
        {
            'lat': 38.88983715388662,
            'lon': -77.41872916701098,
            'scale': 1.183,
            'heading': 289.8552298642311
        },
        {
            'lat': 38.89126519444045,
            'lon': -77.41839674568506,
            'scale': 1.104,
            'heading': 127.20171850584481
        },
        {
            'lat': 38.89219590282111,
            'lon': -77.41861131613713,
            'scale': 0.956,
            'heading': 82.33850339961316
        },
        {
            'lat': 38.89124411840109,
            'lon': -77.4189376734146,
            'scale': 0.915,
            'heading': 94.34446964981124
        },
        {
            'lat': 38.89020127623351,
            'lon': -77.41839655656013,
            'scale': 0.941,
            'heading': 235.90833723721624
        },
        {
            'lat': 38.892371987718526,
            'lon': -77.4188742050955,
            'scale': 1.025,
            'heading': 163.1022774394363
        },
        {
            'lat': 38.89215265314139,
            'lon': -77.41853246372371,
            'scale': 0.852,
            'heading': 82.47036882413418
        },
        {
            'lat': 38.89179510953224,
            'lon': -77.4187769795507,
            'scale': 1.014,
            'heading': 282.66347060501045
        },
        {
            'lat': 38.890684202004124,
            'lon': -77.4185333729309,
            'scale': 0.82,
            'heading': 311.2817417054783
        },
        {
            'lat': 38.892084615099364,
            'lon': -77.41829061639628,
            'scale': 1.122,
            'heading': 296.110897322349
        },
        {
            'lat': 38.89201514069623,
            'lon': -77.4187005869934,
            'scale': 0.863,
            'heading': 348.44900023992756
        },
        {
            'lat': 38.8916743406958,
            'lon': -77.41872202841843,
            'scale': 0.998,
            'heading': 296.8254112780043
        },
        {
            'lat': 38.89044170395694,
            'lon': -77.41876161816353,
            'scale': 0.916,
            'heading': 98.5398367641862
        },
        {
            'lat': 38.891730912207805,
            'lon': -77.4183307668676,
            'scale': 1.012,
            'heading': 321.7730377735968
        },
        {
            'lat': 38.89187555248053,
            'lon': -77.41850628687504,
            'scale': 0.818,
            'heading': 167.58676373201436
        },
        {
            'lat': 38.88967139068691,
            'lon': -77.41868367041329,
            'scale': 0.899,
            'heading': 22.162723292637047
        },
        {
            'lat': 38.891558274946405,
            'lon': -77.41890249339376,
            'scale': 1.161,
            'heading': 84.08049039550116
        },
        {
            'lat': 38.89060737609116,
            'lon': -77.41821980765863,
            'scale': 1.029,
            'heading': 162.8973182423146
        },
        {
            'lat': 38.89163314335581,
            'lon': -77.41837004594404,
            'scale': 0.979,
            'heading': 229.4542270854889
        },
        {
            'lat': 38.89056226251913,
            'lon': -77.41806263997847,
            'scale': 1.082,
            'heading': 147.83012778546504
        },
        {
            'lat': 38.88830098342655,
            'lon': -77.42122685962522,
            'scale': 1.045,
            'heading': 135.35714169040847
        },
        {
            'lat': 38.89193061805483,
            'lon': -77.4185029271539,
            'scale': 0.83,
            'heading': 237.1628352731102
        },
        {
            'lat': 38.88818143823728,
            'lon': -77.42091481184015,
            'scale': 1.129,
            'heading': 246.23090261850098
        },
        {
            'lat': 38.89218044171404,
            'lon': -77.41814301813764,
            'scale': 0.863,
            'heading': 147.65759260019854
        },
        {
            'lat': 38.890459023134326,
            'lon': -77.41820114246882,
            'scale': 1.058,
            'heading': 199.69609642542818
        },
        {
            'lat': 38.89023619088969,
            'lon': -77.41845724249218,
            'scale': 0.975,
            'heading': 345.54264082524435
        },
        {
            'lat': 38.89049383299771,
            'lon': -77.41880128707461,
            'scale': 0.96,
            'heading': 274.1581705931074
        },
        {
            'lat': 38.8910189060461,
            'lon': -77.4188265250156,
            'scale': 1.026,
            'heading': 143.9922609000092
        },
        {
            'lat': 38.89141298856786,
            'lon': -77.41856543778285,
            'scale': 0.818,
            'heading': 105.15539035629361
        },
        {
            'lat': 38.89002115771137,
            'lon': -77.41823449293453,
            'scale': 1.026,
            'heading': 39.373472789712125
        },
        {
            'lat': 38.89050777498314,
            'lon': -77.41865707239688,
            'scale': 1.187,
            'heading': 325.89414957984377
        },
        {
            'lat': 38.888597356190175,
            'lon': -77.42116586819894,
            'scale': 1.104,
            'heading': 353.321547930833
        },
        {
            'lat': 38.89215325774113,
            'lon': -77.41863470093286,
            'scale': 0.976,
            'heading': 144.5823346365249
        },
        {
            'lat': 38.89224462319835,
            'lon': -77.41861398570019,
            'scale': 0.801,
            'heading': 63.45405936807177
        },
        {
            'lat': 38.89050344592488,
            'lon': -77.41881240025967,
            'scale': 1.152,
            'heading': 112.45894809042984
        },
        {
            'lat': 38.89027891513895,
            'lon': -77.4188782274152,
            'scale': 1.104,
            'heading': 281.8738677373105
        },
        {
            'lat': 38.88850506306629,
            'lon': -77.42095899172298,
            'scale': 0.847,
            'heading': 118.84741758215283
        },
        {
            'lat': 38.89021343023428,
            'lon': -77.41831419712888,
            'scale': 1.032,
            'heading': 207.09552176087342
        },
        {
            'lat': 38.89143238188491,
            'lon': -77.41890775072734,
            'scale': 0.913,
            'heading': 290.83523429114047
        },
        {
            'lat': 38.891623721650184,
            'lon': -77.4183748902877,
            'scale': 0.999,
            'heading': 128.1946066941606
        },
        {
            'lat': 38.890802500793136,
            'lon': -77.41888740721684,
            'scale': 1.078,
            'heading': 244.19543352681865
        },
        {
            'lat': 38.89015929825859,
            'lon': -77.41833090500899,
            'scale': 1.193,
            'heading': 256.03492461863203
        },
        {
            'lat': 38.89155423627564,
            'lon': -77.41893065842754,
            'scale': 0.886,
            'heading': 286.00580106005157
        },
        {
            'lat': 38.89065765521931,
            'lon': -77.41814701944179,
            'scale': 1.128,
            'heading': 38.527959094309296
        },
        {
            'lat': 38.890431541343865,
            'lon': -77.41858434656976,
            'scale': 1.126,
            'heading': 284.36597329244006
        },
        {
            'lat': 38.89126455603112,
            'lon': -77.41816932049123,
            'scale': 1.146,
            'heading': 130.69738038449438
        },
        {
            'lat': 38.88988880467655,
            'lon': -77.4185224126327,
            'scale': 1.015,
            'heading': 238.26134698195824
        },
        {
            'lat': 38.891758500357135,
            'lon': -77.41835697956533,
            'scale': 1.15,
            'heading': 168.75768231141808
        },
        {
            'lat': 38.890396583756576,
            'lon': -77.41868676611148,
            'scale': 0.826,
            'heading': 105.16387663344764
        },
        {
            'lat': 38.89185282999744,
            'lon': -77.41792655820706,
            'scale': 1.121,
            'heading': 73.86204386724951
        },
        {
            'lat': 38.89136135877954,
            'lon': -77.41867979580311,
            'scale': 1.028,
            'heading': 103.83017881964864
        },
        {
            'lat': 38.89029017876899,
            'lon': -77.41874561085977,
            'scale': 0.839,
            'heading': 339.84065090734595
        },
        {
            'lat': 38.890295671933586,
            'lon': -77.41883631803027,
            'scale': 1.043,
            'heading': 278.85131091822524
        },
        {
            'lat': 38.89011982401576,
            'lon': -77.4183982116414,
            'scale': 1.042,
            'heading': 26.27177984692592
        },
        {
            'lat': 38.89101526681922,
            'lon': -77.41887672260033,
            'scale': 0.887,
            'heading': 358.89308461848015
        },
        {
            'lat': 38.88843328936877,
            'lon': -77.42122171175353,
            'scale': 1.045,
            'heading': 41.73720662418677
        },
        {
            'lat': 38.892183099464056,
            'lon': -77.41848490851145,
            'scale': 0.945,
            'heading': 121.31466864488945
        },
        {
            'lat': 38.892293404648164,
            'lon': -77.4188958727398,
            'scale': 1.109,
            'heading': 13.271428427135778
        },
        {
            'lat': 38.88998766838556,
            'lon': -77.41872320721181,
            'scale': 0.819,
            'heading': 62.901936309506134
        },
        {
            'lat': 38.89226871809226,
            'lon': -77.41823866129072,
            'scale': 1.121,
            'heading': 78.58207339132272
        },
        {
            'lat': 38.89121728346573,
            'lon': -77.41875318977232,
            'scale': 1.115,
            'heading': 169.86633847300746
        },
        {
            'lat': 38.89096164552174,
            'lon': -77.41825181645663,
            'scale': 0.816,
            'heading': 322.7736672511868
        },
        {
            'lat': 38.88964626007913,
            'lon': -77.41781230367619,
            'scale': 1.017,
            'heading': 14.916544060145412
        },
        {
            'lat': 38.890397572020056,
            'lon': -77.41869100318665,
            'scale': 1.187,
            'heading': 210.70207592842743
        },
        {
            'lat': 38.89196176922841,
            'lon': -77.41774497731188,
            'scale': 0.875,
            'heading': 134.35660283444258
        },
        {
            'lat': 38.89114392777483,
            'lon': -77.41896299607917,
            'scale': 1.185,
            'heading': 116.5967797543063
        },
        {
            'lat': 38.88953508272827,
            'lon': -77.41885241607001,
            'scale': 1.052,
            'heading': 263.2761862927475
        },
        {
            'lat': 38.88960279126686,
            'lon': -77.41891141021993,
            'scale': 0.874,
            'heading': 115.75109518981519
        },
        {
            'lat': 38.89106977356527,
            'lon': -77.41894544070473,
            'scale': 0.94,
            'heading': 259.97691973153684
        },
        {
            'lat': 38.89120665382294,
            'lon': -77.41853914679743,
            'scale': 0.871,
            'heading': 138.31136765675458
        },
        {
            'lat': 38.89239651817465,
            'lon': -77.41780928097556,
            'scale': 0.884,
            'heading': 224.64081367193327
        },
        {
            'lat': 38.88871301890744,
            'lon': -77.42091317321088,
            'scale': 1.057,
            'heading': 102.94823104953436
        },
        {
            'lat': 38.8915376298468,
            'lon': -77.41850282683085,
            'scale': 0.877,
            'heading': 212.57611940452082
        },
        {
            'lat': 38.88853162404304,
            'lon': -77.42097136555579,
            'scale': 1.061,
            'heading': 211.17017463842805
        },
        {
            'lat': 38.88989812852554,
            'lon': -77.4179721201601,
            'scale': 1.06,
            'heading': 109.10055684383919
        },
        {
            'lat': 38.89218086957577,
            'lon': -77.41902826343883,
            'scale': 0.935,
            'heading': 238.58688635320618
        },
        {
            'lat': 38.891988370481954,
            'lon': -77.41813969905984,
            'scale': 1.179,
            'heading': 150.42244640587805
        },
        {
            'lat': 38.89173030640539,
            'lon': -77.41798411415941,
            'scale': 0.954,
            'heading': 328.91952963101005
        },
        {
            'lat': 38.889815604231046,
            'lon': -77.41804622836133,
            'scale': 1.048,
            'heading': 176.30886101170313
        },
        {
            'lat': 38.88848019213821,
            'lon': -77.42129396770775,
            'scale': 1.048,
            'heading': 15.500392368635367
        },
        {
            'lat': 38.891423047893504,
            'lon': -77.41857369854435,
            'scale': 0.816,
            'heading': 17.05501691479043
        },
        {
            'lat': 38.88834568680603,
            'lon': -77.4213819491094,
            'scale': 0.998,
            'heading': 317.1076208307616
        },
        {
            'lat': 38.89163599710179,
            'lon': -77.41889537131163,
            'scale': 1.01,
            'heading': 71.01006778049918
        },
        {
            'lat': 38.889535086829,
            'lon': -77.41905787563067,
            'scale': 1.046,
            'heading': 325.1927878337251
        },
        {
            'lat': 38.89026194234055,
            'lon': -77.41824464453445,
            'scale': 1.158,
            'heading': 143.0818412169544
        },
        {
            'lat': 38.89107929428395,
            'lon': -77.41871038302786,
            'scale': 0.92,
            'heading': 68.67171591813857
        },
        {
            'lat': 38.8910030545229,
            'lon': -77.41869337748518,
            'scale': 1.176,
            'heading': 149.06376088434288
        },
        {
            'lat': 38.8919461798072,
            'lon': -77.41770952911392,
            'scale': 1.017,
            'heading': 163.60902808187652
        },
        {
            'lat': 38.89237844708196,
            'lon': -77.41886526527558,
            'scale': 0.828,
            'heading': 274.94810745687454
        },
        {
            'lat': 38.89113040735962,
            'lon': -77.41841046729174,
            'scale': 1.074,
            'heading': 184.34509384557452
        },
        {
            'lat': 38.888548088861825,
            'lon': -77.42131843847417,
            'scale': 0.989,
            'heading': 138.46968239534806
        },
        {
            'lat': 38.89145273387657,
            'lon': -77.41837974910612,
            'scale': 0.856,
            'heading': 276.9163615911966
        },
        {
            'lat': 38.89092766458591,
            'lon': -77.41854151245283,
            'scale': 1.118,
            'heading': 79.62539847003566
        },
        {
            'lat': 38.89054587811046,
            'lon': -77.41842403718866,
            'scale': 0.837,
            'heading': 5.0795102429276495
        },
        {
            'lat': 38.89168088957385,
            'lon': -77.4179207525343,
            'scale': 0.813,
            'heading': 265.0604863656329
        },
        {
            'lat': 38.89150821816677,
            'lon': -77.41854287893854,
            'scale': 1.013,
            'heading': 56.6067595269181
        },
        {
            'lat': 38.89035215369252,
            'lon': -77.41814580910265,
            'scale': 0.845,
            'heading': 30.305296419753596
        },
        {
            'lat': 38.89108917928911,
            'lon': -77.4186213922769,
            'scale': 0.948,
            'heading': 19.455277792729774
        },
        {
            'lat': 38.89001195426761,
            'lon': -77.4186033259142,
            'scale': 0.975,
            'heading': 161.5913211692802
        },
        {
            'lat': 38.89205613936116,
            'lon': -77.41871930619608,
            'scale': 0.892,
            'heading': 302.42252780743775
        },
        {
            'lat': 38.89182821865436,
            'lon': -77.41841725496737,
            'scale': 0.991,
            'heading': 169.72948998791503
        },
        {
            'lat': 38.891070319005884,
            'lon': -77.41897508486144,
            'scale': 0.979,
            'heading': 171.8807131182743
        },
        {
            'lat': 38.89174018391548,
            'lon': -77.41879322453983,
            'scale': 0.954,
            'heading': 298.1386512012495
        },
        {
            'lat': 38.89210505574454,
            'lon': -77.41803584889394,
            'scale': 1.0,
            'heading': 226.475767450128
        },
        {
            'lat': 38.89222530482421,
            'lon': -77.41887206757661,
            'scale': 1.104,
            'heading': 172.94842457535697
        },
        {
            'lat': 38.8881324191045,
            'lon': -77.42132555911456,
            'scale': 0.915,
            'heading': 188.83321688686277
        },
        {
            'lat': 38.890780642495336,
            'lon': -77.41821143370471,
            'scale': 0.867,
            'heading': 70.24308559864947
        },
        {
            'lat': 38.892180033670456,
            'lon': -77.41800575832313,
            'scale': 0.88,
            'heading': 317.43375851676376
        },
        {
            'lat': 38.891638715039306,
            'lon': -77.41787529748593,
            'scale': 1.116,
            'heading': 183.08897374890554
        },
        {
            'lat': 38.89215015589671,
            'lon': -77.41824392117587,
            'scale': 1.142,
            'heading': 182.50580466264415
        },
        {
            'lat': 38.892308823921965,
            'lon': -77.41792666581071,
            'scale': 1.082,
            'heading': 244.7620739310684
        },
        {
            'lat': 38.888271025919835,
            'lon': -77.42148316510524,
            'scale': 0.933,
            'heading': 169.1331088843877
        },
        {
            'lat': 38.89200211377286,
            'lon': -77.41769424798049,
            'scale': 0.989,
            'heading': 343.3151345236823
        },
        {
            'lat': 38.89136055746373,
            'lon': -77.41837835665548,
            'scale': 1.163,
            'heading': 314.61264519763216
        },
        {
            'lat': 38.891626847966705,
            'lon': -77.41811943481017,
            'scale': 1.084,
            'heading': 48.89542619601106
        },
        {
            'lat': 38.890218066584076,
            'lon': -77.4186652385662,
            'scale': 0.863,
            'heading': 197.65337874418663
        },
        {
            'lat': 38.89205831053407,
            'lon': -77.4183773000921,
            'scale': 0.822,
            'heading': 52.65746484205989
        },
        {
            'lat': 38.89035533941651,
            'lon': -77.41875405151501,
            'scale': 1.048,
            'heading': 108.37647620486223
        },
        {
            'lat': 38.89046988629565,
            'lon': -77.41877971848852,
            'scale': 0.816,
            'heading': 252.98222597655476
        },
        {
            'lat': 38.889608615786706,
            'lon': -77.41891698061836,
            'scale': 0.951,
            'heading': 130.52396368072783
        },
        {
            'lat': 38.891000076930624,
            'lon': -77.41826164364824,
            'scale': 0.872,
            'heading': 283.2484507826663
        },
        {
            'lat': 38.890144229531096,
            'lon': -77.41882772047504,
            'scale': 1.132,
            'heading': 173.39635426406343
        },
        {
            'lat': 38.8922527524406,
            'lon': -77.41859390308024,
            'scale': 0.962,
            'heading': 120.09435089599368
        },
        {
            'lat': 38.89154520201472,
            'lon': -77.41840569689873,
            'scale': 0.991,
            'heading': 275.52876011701204
        },
        {
            'lat': 38.89074967193433,
            'lon': -77.41805826179197,
            'scale': 1.149,
            'heading': 146.4962644309501
        },
        {
            'lat': 38.89113277243787,
            'lon': -77.41804945396473,
            'scale': 1.139,
            'heading': 286.25695176746484
        },
        {
            'lat': 38.8919805110949,
            'lon': -77.41892546748733,
            'scale': 0.856,
            'heading': 87.11871083067423
        },
        {
            'lat': 38.89105385570705,
            'lon': -77.41873054286833,
            'scale': 0.84,
            'heading': 91.39206861925528
        },
        {
            'lat': 38.89087082963093,
            'lon': -77.41894573774852,
            'scale': 1.047,
            'heading': 206.1367839254347
        },
        {
            'lat': 38.892221950807674,
            'lon': -77.41841108351764,
            'scale': 0.948,
            'heading': 53.452922250041354
        },
        {
            'lat': 38.89050345715153,
            'lon': -77.41882381487044,
            'scale': 0.969,
            'heading': 175.14930799251374
        },
        {
            'lat': 38.89000882990734,
            'lon': -77.41820991707826,
            'scale': 1.155,
            'heading': 245.32349966595123
        },
        {
            'lat': 38.889866405766746,
            'lon': -77.4179726752528,
            'scale': 0.924,
            'heading': 221.26648773468557
        },
        {
            'lat': 38.890814578141,
            'lon': -77.418409030477,
            'scale': 1.076,
            'heading': 146.11265181872278
        },
        {
            'lat': 38.892382233491325,
            'lon': -77.41920338755175,
            'scale': 1.057,
            'heading': 69.87239005327683
        },
        {
            'lat': 38.89074499965046,
            'lon': -77.41817682316709,
            'scale': 1.044,
            'heading': 261.7106080191586
        },
        {
            'lat': 38.891591676796146,
            'lon': -77.41843742522641,
            'scale': 1.086,
            'heading': 186.01020708003765
        },
        {
            'lat': 38.890435264509705,
            'lon': -77.41865741989706,
            'scale': 0.992,
            'heading': 27.896592848454866
        },
        {
            'lat': 38.891238654530504,
            'lon': -77.4189525166925,
            'scale': 1.138,
            'heading': 169.6575266259683
        },
        {
            'lat': 38.88824984578128,
            'lon': -77.4211358695933,
            'scale': 1.132,
            'heading': 46.995449416585586
        },
        {
            'lat': 38.88830054191209,
            'lon': -77.42125690780118,
            'scale': 0.837,
            'heading': 103.02936070998739
        },
        {
            'lat': 38.88956194516081,
            'lon': -77.41839963161613,
            'scale': 1.098,
            'heading': 107.19562812374703
        },
        {
            'lat': 38.89237711660996,
            'lon': -77.4185530528088,
            'scale': 1.042,
            'heading': 65.17733263195687
        },
        {
            'lat': 38.89161065676664,
            'lon': -77.41868505641166,
            'scale': 1.173,
            'heading': 104.94544848886068
        },
        {
            'lat': 38.892186409280875,
            'lon': -77.418604367499,
            'scale': 1.196,
            'heading': 318.41502383489785
        },
        {
            'lat': 38.89229981526709,
            'lon': -77.41848557210386,
            'scale': 1.09,
            'heading': 103.4332455266393
        },
        {
            'lat': 38.89201743892147,
            'lon': -77.4178505340386,
            'scale': 0.958,
            'heading': 98.67294740976102
        },
        {
            'lat': 38.89233125563814,
            'lon': -77.41914402153647,
            'scale': 0.876,
            'heading': 149.1151367483862
        },
        {
            'lat': 38.89022435875132,
            'lon': -77.4180611412118,
            'scale': 1.126,
            'heading': 177.44778455546302
        },
        {
            'lat': 38.89166198649129,
            'lon': -77.41817333176769,
            'scale': 0.89,
            'heading': 160.58238432653116
        },
        {
            'lat': 38.88964794085664,
            'lon': -77.41847707632937,
            'scale': 1.06,
            'heading': 108.46434769956568
        },
        {
            'lat': 38.888096270971985,
            'lon': -77.42085180745214,
            'scale': 0.9,
            'heading': 264.00323489856953
        },
        {
            'lat': 38.891773266233656,
            'lon': -77.41807995193213,
            'scale': 0.872,
            'heading': 58.784788186195
        },
        {
            'lat': 38.890064088290245,
            'lon': -77.41858941551538,
            'scale': 0.884,
            'heading': 248.27368152594465
        },
        {
            'lat': 38.89185139129084,
            'lon': -77.41788727365582,
            'scale': 1.175,
            'heading': 304.97794460042786
        },
        {
            'lat': 38.89203393385953,
            'lon': -77.4182835843856,
            'scale': 1.058,
            'heading': 305.46076205211983
        },
        {
            'lat': 38.891209281618806,
            'lon': -77.41834426140116,
            'scale': 1.096,
            'heading': 84.88480315078989
        },
        {
            'lat': 38.89218814510553,
            'lon': -77.4186624053663,
            'scale': 1.091,
            'heading': 298.135079393884
        },
        {
            'lat': 38.891530526595496,
            'lon': -77.41866931223656,
            'scale': 0.97,
            'heading': 301.30719595325706
        },
        {
            'lat': 38.89225411744935,
            'lon': -77.41786731119319,
            'scale': 1.087,
            'heading': 304.07944847434834
        },
        {
            'lat': 38.89132121398815,
            'lon': -77.41825887413894,
            'scale': 0.925,
            'heading': 16.691246516830542
        },
        {
            'lat': 38.89138601591205,
            'lon': -77.41835482622386,
            'scale': 0.953,
            'heading': 106.91759927654854
        },
        {
            'lat': 38.8914238697987,
            'lon': -77.41821768874897,
            'scale': 0.81,
            'heading': 254.32503822930946
        },
        {
            'lat': 38.889588280650806,
            'lon': -77.41767074604181,
            'scale': 1.087,
            'heading': 245.64344478542165
        },
        {
            'lat': 38.89075791096248,
            'lon': -77.41803259664454,
            'scale': 0.865,
            'heading': 125.37440636113071
        },
        {
            'lat': 38.890073773284875,
            'lon': -77.41883561276386,
            'scale': 0.871,
            'heading': 223.18896276535827
        },
        {
            'lat': 38.892292686010656,
            'lon': -77.41844867205707,
            'scale': 0.859,
            'heading': 99.81521013157881
        },
        {
            'lat': 38.89221249095757,
            'lon': -77.41846828929552,
            'scale': 0.973,
            'heading': 321.8585361424526
        },
        {
            'lat': 38.890856459038154,
            'lon': -77.41840476440329,
            'scale': 1.178,
            'heading': 142.19154647573336
        },
        {
            'lat': 38.890301160100435,
            'lon': -77.41857172223641,
            'scale': 0.903,
            'heading': 111.3534080976215
        },
        {
            'lat': 38.890020241245345,
            'lon': -77.41867550548511,
            'scale': 1.103,
            'heading': 229.09269039474904
        },
        {
            'lat': 38.89163114590513,
            'lon': -77.41812356515682,
            'scale': 0.993,
            'heading': 156.07643806890835
        },
        {
            'lat': 38.89171731966094,
            'lon': -77.41791862413346,
            'scale': 1.037,
            'heading': 252.98858836995805
        },
        {
            'lat': 38.89112423608019,
            'lon': -77.4184780771668,
            'scale': 1.078,
            'heading': 25.706389796341064
        },
        {
            'lat': 38.890715186374045,
            'lon': -77.41880844419227,
            'scale': 1.067,
            'heading': 7.625147831687404
        },
        {
            'lat': 38.89228130437068,
            'lon': -77.41924606697955,
            'scale': 1.153,
            'heading': 187.54454171515826
        },
        {
            'lat': 38.888417988173146,
            'lon': -77.42134983891069,
            'scale': 1.056,
            'heading': 233.58513555810873
        },
        {
            'lat': 38.89229894244561,
            'lon': -77.41849926101476,
            'scale': 1.003,
            'heading': 100.12995488177442
        },
        {
            'lat': 38.89070982827972,
            'lon': -77.4180780504775,
            'scale': 0.978,
            'heading': 108.47022450346108
        },
        {
            'lat': 38.89209167636959,
            'lon': -77.41817629426961,
            'scale': 0.838,
            'heading': 245.84482954608873
        },
        {
            'lat': 38.89178729897028,
            'lon': -77.4183967179531,
            'scale': 0.998,
            'heading': 127.4482266336126
        },
        {
            'lat': 38.890062098386736,
            'lon': -77.41854095564831,
            'scale': 0.932,
            'heading': 44.091458166692505
        },
        {
            'lat': 38.8920473310935,
            'lon': -77.41824301464435,
            'scale': 1.06,
            'heading': 177.79360945496498
        },
        {
            'lat': 38.891169816537804,
            'lon': -77.41872311704763,
            'scale': 0.984,
            'heading': 236.8478632582649
        },
        {
            'lat': 38.8884279730493,
            'lon': -77.42094033340832,
            'scale': 0.815,
            'heading': 303.5747596799505
        },
        {
            'lat': 38.89129308312474,
            'lon': -77.4189497363307,
            'scale': 1.08,
            'heading': 19.587821680599742
        },
        {
            'lat': 38.891965442062165,
            'lon': -77.41796011674427,
            'scale': 0.94,
            'heading': 222.0187687313573
        },
        {
            'lat': 38.89134078651089,
            'lon': -77.41814815528957,
            'scale': 0.942,
            'heading': 97.29644638228021
        },
        {
            'lat': 38.890523834807105,
            'lon': -77.41843967270455,
            'scale': 0.848,
            'heading': 209.08794834962407
        },
        {
            'lat': 38.890464089785155,
            'lon': -77.41825255729557,
            'scale': 0.858,
            'heading': 245.08864809041836
        },
        {
            'lat': 38.89026051010913,
            'lon': -77.41804113079243,
            'scale': 0.89,
            'heading': 162.67824002503215
        },
        {
            'lat': 38.89196752094134,
            'lon': -77.41854280458178,
            'scale': 0.861,
            'heading': 268.02226707207416
        },
        {
            'lat': 38.89231247244809,
            'lon': -77.41885147230916,
            'scale': 1.067,
            'heading': 6.5033728053472695
        },
        {
            'lat': 38.89071240943231,
            'lon': -77.41803301609018,
            'scale': 0.839,
            'heading': 310.67098476900975
        },
        {
            'lat': 38.890241778439,
            'lon': -77.41855229636131,
            'scale': 0.946,
            'heading': 308.9646509251583
        },
        {
            'lat': 38.8917478321507,
            'lon': -77.41822602234912,
            'scale': 1.16,
            'heading': 283.65060408393566
        },
        {
            'lat': 38.89057038787316,
            'lon': -77.41832591003,
            'scale': 1.174,
            'heading': 228.75372177962774
        },
        {
            'lat': 38.891787750968994,
            'lon': -77.4179049960902,
            'scale': 1.074,
            'heading': 16.311178659622758
        },
        {
            'lat': 38.89136778268446,
            'lon': -77.41890191195944,
            'scale': 1.146,
            'heading': 95.51963080318795
        },
        {
            'lat': 38.8923938855612,
            'lon': -77.41816024221501,
            'scale': 1.128,
            'heading': 121.50056756409174
        },
        {
            'lat': 38.89222511185851,
            'lon': -77.41806124781625,
            'scale': 1.098,
            'heading': 288.4170528039572
        },
        {
            'lat': 38.88970805263069,
            'lon': -77.41887334135876,
            'scale': 1.186,
            'heading': 306.9502337134325
        },
        {
            'lat': 38.88868882262875,
            'lon': -77.42101793448612,
            'scale': 0.92,
            'heading': 283.38503062897485
        },
        {
            'lat': 38.88841330962333,
            'lon': -77.4213895842163,
            'scale': 0.883,
            'heading': 83.20505780092634
        },
        {
            'lat': 38.89227743886016,
            'lon': -77.41824445287355,
            'scale': 1.175,
            'heading': 248.57920688410152
        },
        {
            'lat': 38.88843277424313,
            'lon': -77.42101954400573,
            'scale': 0.984,
            'heading': 225.56338747180146
        },
        {
            'lat': 38.888525722410655,
            'lon': -77.42123305939981,
            'scale': 1.116,
            'heading': 133.58316460574818
        },
        {
            'lat': 38.89098937229973,
            'lon': -77.4183945439676,
            'scale': 0.993,
            'heading': 71.59636390309035
        },
        {
            'lat': 38.89063332171766,
            'lon': -77.41829945406091,
            'scale': 1.075,
            'heading': 173.8612370425977
        },
        {
            'lat': 38.89007597568842,
            'lon': -77.41765723091213,
            'scale': 1.116,
            'heading': 96.0395712412756
        },
        {
            'lat': 38.89140231169924,
            'lon': -77.41841657942877,
            'scale': 1.133,
            'heading': 327.053804465652
        },
        {
            'lat': 38.88952133176419,
            'lon': -77.41897921399831,
            'scale': 0.913,
            'heading': 169.48044751496863
        },
        {
            'lat': 38.88869874546125,
            'lon': -77.42095826818232,
            'scale': 1.032,
            'heading': 312.71886385736394
        },
        {
            'lat': 38.89061375457964,
            'lon': -77.41825016143498,
            'scale': 1.051,
            'heading': 149.05381772205968
        },
        {
            'lat': 38.888734951470056,
            'lon': -77.4209576942004,
            'scale': 0.919,
            'heading': 282.81225080183935
        },
        {
            'lat': 38.89063790640611,
            'lon': -77.41840280787063,
            'scale': 0.906,
            'heading': 151.8876463347143
        },
        {
            'lat': 38.89211538052141,
            'lon': -77.41817827968924,
            'scale': 0.909,
            'heading': 178.94735028611504
        },
        {
            'lat': 38.88996910514663,
            'lon': -77.41787705324042,
            'scale': 0.81,
            'heading': 283.51897570945033
        },
        {
            'lat': 38.89067440086995,
            'lon': -77.41895096641858,
            'scale': 0.848,
            'heading': 231.4125757885521
        },
        {
            'lat': 38.89134707264739,
            'lon': -77.41835576147491,
            'scale': 1.196,
            'heading': 29.22594203949594
        },
        {
            'lat': 38.889825098213755,
            'lon': -77.41835751905745,
            'scale': 1.134,
            'heading': 354.9177997393694
        },
        {
            'lat': 38.892392687728275,
            'lon': -77.41865899323061,
            'scale': 0.849,
            'heading': 27.140822526332705
        },
        {
            'lat': 38.8906989275567,
            'lon': -77.41855716434536,
            'scale': 1.033,
            'heading': 69.20127277122523
        },
        {
            'lat': 38.88980996705568,
            'lon': -77.41810737870834,
            'scale': 0.907,
            'heading': 262.99253595730534
        },
        {
            'lat': 38.88999246499283,
            'lon': -77.41830237930158,
            'scale': 1.117,
            'heading': 204.99798407002527
        },
        {
            'lat': 38.89202444161574,
            'lon': -77.418760696478,
            'scale': 0.829,
            'heading': 36.9910705477931
        },
        {
            'lat': 38.89021279535417,
            'lon': -77.4188089138277,
            'scale': 0.843,
            'heading': 89.08937519363339
        },
        {
            'lat': 38.8917661400481,
            'lon': -77.41773369365795,
            'scale': 1.119,
            'heading': 248.17654272071115
        },
        {
            'lat': 38.88987013070827,
            'lon': -77.41812426395795,
            'scale': 0.866,
            'heading': 352.4052260404626
        },
        {
            'lat': 38.8906253258734,
            'lon': -77.41880745667713,
            'scale': 0.946,
            'heading': 213.20354329645627
        },
        {
            'lat': 38.89153873674503,
            'lon': -77.41846894043599,
            'scale': 0.883,
            'heading': 325.18305183344205
        },
        {
            'lat': 38.88992729093992,
            'lon': -77.41866573005042,
            'scale': 0.926,
            'heading': 125.12575976272699
        },
        {
            'lat': 38.889563318169046,
            'lon': -77.4181877798672,
            'scale': 1.086,
            'heading': 124.13492077845432
        },
        {
            'lat': 38.8885169484447,
            'lon': -77.42119925131288,
            'scale': 0.953,
            'heading': 149.7755618840881
        },
        {
            'lat': 38.891682160834605,
            'lon': -77.41872051076982,
            'scale': 0.821,
            'heading': 250.14732058162124
        },
        {
            'lat': 38.8908251839631,
            'lon': -77.41894011208244,
            'scale': 0.961,
            'heading': 125.22261360138755
        },
        {
            'lat': 38.89054782474952,
            'lon': -77.41862248620636,
            'scale': 0.81,
            'heading': 306.7770760794083
        },
        {
            'lat': 38.890596494298414,
            'lon': -77.41807709487283,
            'scale': 1.187,
            'heading': 164.51797269960355
        },
        {
            'lat': 38.8912268853329,
            'lon': -77.41868655341801,
            'scale': 0.932,
            'heading': 326.4109012223728
        },
        {
            'lat': 38.88840823231885,
            'lon': -77.42140245292377,
            'scale': 1.06,
            'heading': 344.041853639307
        },
        {
            'lat': 38.89046576576223,
            'lon': -77.41868201939171,
            'scale': 1.033,
            'heading': 305.08580300735565
        },
        {
            'lat': 38.89103072727885,
            'lon': -77.41834522517314,
            'scale': 0.885,
            'heading': 122.05623511582795
        },
        {
            'lat': 38.889878004429505,
            'lon': -77.41830078935297,
            'scale': 0.858,
            'heading': 24.46672686652486
        },
        {
            'lat': 38.8919764062667,
            'lon': -77.41809339217681,
            'scale': 1.034,
            'heading': 221.29058410278566
        },
        {
            'lat': 38.89213998867842,
            'lon': -77.4186296862518,
            'scale': 0.878,
            'heading': 50.61188112727361
        },
        {
            'lat': 38.890202937546945,
            'lon': -77.41798890500907,
            'scale': 1.022,
            'heading': 246.12231678972762
        },
        {
            'lat': 38.89019429165457,
            'lon': -77.41774261161191,
            'scale': 0.816,
            'heading': 29.145293184359918
        },
        {
            'lat': 38.89016492826583,
            'lon': -77.41823562055035,
            'scale': 0.813,
            'heading': 85.82279039426824
        },
        {
            'lat': 38.89216241645259,
            'lon': -77.41908856720646,
            'scale': 0.84,
            'heading': 129.47736237956963
        },
        {
            'lat': 38.8901372887183,
            'lon': -77.41796165026672,
            'scale': 0.917,
            'heading': 266.5602447788685
        },
        {
            'lat': 38.89221787997234,
            'lon': -77.41780045712817,
            'scale': 0.815,
            'heading': 188.28083682713176
        },
        {
            'lat': 38.89107066273787,
            'lon': -77.41897621220069,
            'scale': 1.087,
            'heading': 125.28584745053118
        },
        {
            'lat': 38.89185152947864,
            'lon': -77.41829558496293,
            'scale': 0.958,
            'heading': 165.934028323604
        },
        {
            'lat': 38.89094642456509,
            'lon': -77.41892476144857,
            'scale': 0.821,
            'heading': 336.2530115413516
        },
        {
            'lat': 38.88956224799044,
            'lon': -77.41793792455054,
            'scale': 1.071,
            'heading': 274.0231681256157
        },
        {
            'lat': 38.891875482727876,
            'lon': -77.41846749858986,
            'scale': 0.812,
            'heading': 124.17731771969879
        },
        {
            'lat': 38.892341542189115,
            'lon': -77.41864877414982,
            'scale': 0.849,
            'heading': 205.99065061205437
        },
        {
            'lat': 38.892387274274746,
            'lon': -77.41815185961843,
            'scale': 1.077,
            'heading': 139.0558132938516
        },
        {
            'lat': 38.890495582617284,
            'lon': -77.41839943955061,
            'scale': 1.039,
            'heading': 74.48186303568816
        },
        {
            'lat': 38.89199201766514,
            'lon': -77.41830342033458,
            'scale': 1.018,
            'heading': 52.284488047203965
        },
        {
            'lat': 38.890785756261266,
            'lon': -77.41804271736743,
            'scale': 0.817,
            'heading': 259.338929340102
        },
        {
            'lat': 38.8906892381315,
            'lon': -77.41864751554895,
            'scale': 0.829,
            'heading': 263.90408127818523
        },
        {
            'lat': 38.89139759634846,
            'lon': -77.41823592643408,
            'scale': 1.089,
            'heading': 192.51796114854858
        },
        {
            'lat': 38.88963195603915,
            'lon': -77.41774234835498,
            'scale': 0.805,
            'heading': 341.67363870938465
        },
        {
            'lat': 38.89034742261343,
            'lon': -77.41878696943141,
            'scale': 1.116,
            'heading': 227.4229756766255
        },
        {
            'lat': 38.88834092141228,
            'lon': -77.42134417542695,
            'scale': 1.132,
            'heading': 345.91388832591497
        },
        {
            'lat': 38.891542138982274,
            'lon': -77.41809588179284,
            'scale': 0.923,
            'heading': 208.6562266118605
        },
        {
            'lat': 38.890192982730895,
            'lon': -77.41780759331172,
            'scale': 0.895,
            'heading': 198.27856777667512
        },
        {
            'lat': 38.89149522956295,
            'lon': -77.41893114189276,
            'scale': 0.894,
            'heading': 338.7884154165418
        },
        {
            'lat': 38.888560470337396,
            'lon': -77.42095710656382,
            'scale': 0.927,
            'heading': 48.609735000447884
        },
        {
            'lat': 38.89214935558865,
            'lon': -77.41843831154875,
            'scale': 0.86,
            'heading': 12.473002609187883
        },
        {
            'lat': 38.889618340682105,
            'lon': -77.41773046105433,
            'scale': 1.116,
            'heading': 130.71578944399795
        },
        {
            'lat': 38.89092208166321,
            'lon': -77.41868508329414,
            'scale': 0.996,
            'heading': 339.86851908114426
        },
        {
            'lat': 38.89052948460788,
            'lon': -77.41831478630164,
            'scale': 0.808,
            'heading': 284.4515665576822
        },
        {
            'lat': 38.890411759097894,
            'lon': -77.41834793308236,
            'scale': 1.169,
            'heading': 179.85811470861236
        },
        {
            'lat': 38.88998672950373,
            'lon': -77.41785969151664,
            'scale': 0.901,
            'heading': 178.94782150654265
        },
        {
            'lat': 38.88811142879775,
            'lon': -77.42117738553578,
            'scale': 0.971,
            'heading': 308.431196832365
        },
        {
            'lat': 38.89159850862735,
            'lon': -77.41850146245304,
            'scale': 1.129,
            'heading': 66.88250137498659
        },
        {
            'lat': 38.892272941279494,
            'lon': -77.41815513638676,
            'scale': 0.984,
            'heading': 98.78482909919349
        },
        {
            'lat': 38.89179723837111,
            'lon': -77.41881295682234,
            'scale': 1.014,
            'heading': 251.06948617856213
        },
        {
            'lat': 38.89163881401553,
            'lon': -77.4181251837706,
            'scale': 1.146,
            'heading': 68.25779354007429
        },
        {
            'lat': 38.88955939422472,
            'lon': -77.41827733562957,
            'scale': 0.877,
            'heading': 76.97356190301095
        },
        {
            'lat': 38.89230626816892,
            'lon': -77.4178728035872,
            'scale': 1.024,
            'heading': 69.80476584539757
        },
        {
            'lat': 38.89219605275231,
            'lon': -77.41834040131343,
            'scale': 1.063,
            'heading': 266.1089247815273
        },
        {
            'lat': 38.89008790536539,
            'lon': -77.41871266616296,
            'scale': 1.171,
            'heading': 25.66307421775076
        },
        {
            'lat': 38.89062963414511,
            'lon': -77.41826634987284,
            'scale': 1.162,
            'heading': 296.3638379076266
        },
        {
            'lat': 38.89128076794356,
            'lon': -77.41857202920592,
            'scale': 1.125,
            'heading': 242.27613082239222
        },
        {
            'lat': 38.88853486946448,
            'lon': -77.421070553264,
            'scale': 1.068,
            'heading': 285.6014352620052
        },
        {
            'lat': 38.88816512247768,
            'lon': -77.42081349538891,
            'scale': 1.167,
            'heading': 154.4797278755078
        },
        {
            'lat': 38.890973041462786,
            'lon': -77.41837326748134,
            'scale': 0.827,
            'heading': 355.8341155048563
        },
        {
            'lat': 38.89141468941019,
            'lon': -77.41811198244112,
            'scale': 0.808,
            'heading': 98.01433431733808
        },
        {
            'lat': 38.89136867242088,
            'lon': -77.4181001334837,
            'scale': 1.046,
            'heading': 293.436226250856
        },
        {
            'lat': 38.88990230578347,
            'lon': -77.41772450791618,
            'scale': 0.935,
            'heading': 119.79244685712963
        },
        {
            'lat': 38.88959299645287,
            'lon': -77.41821426255039,
            'scale': 1.067,
            'heading': 117.24658851410696
        },
        {
            'lat': 38.88963571077828,
            'lon': -77.4176815139171,
            'scale': 1.067,
            'heading': 254.59437019174766
        },
        {
            'lat': 38.88989159756982,
            'lon': -77.41783054360008,
            'scale': 0.839,
            'heading': 94.75788063323704
        },
        {
            'lat': 38.88855973813432,
            'lon': -77.4212659807663,
            'scale': 1.158,
            'heading': 177.75050651810187
        },
        {
            'lat': 38.88965136297638,
            'lon': -77.41876213704592,
            'scale': 0.84,
            'heading': 246.78486126291529
        },
        {
            'lat': 38.89101627558576,
            'lon': -77.41877517453615,
            'scale': 0.89,
            'heading': 241.39243371407062
        },
        {
            'lat': 38.89239454455428,
            'lon': -77.41838635421928,
            'scale': 0.973,
            'heading': 3.1313047385775006
        },
        {
            'lat': 38.88957060598561,
            'lon': -77.41876245781029,
            'scale': 0.852,
            'heading': 342.75073747953047
        },
        {
            'lat': 38.88851452399017,
            'lon': -77.42128971700126,
            'scale': 1.045,
            'heading': 323.54889900133315
        },
        {
            'lat': 38.89063931759503,
            'lon': -77.41862951562011,
            'scale': 1.02,
            'heading': 342.38859412557815
        },
        {
            'lat': 38.89237525574541,
            'lon': -77.41785074648415,
            'scale': 1.175,
            'heading': 313.8383170846488
        },
        {
            'lat': 38.8911837066074,
            'lon': -77.4185267331532,
            'scale': 0.893,
            'heading': 350.1094721454315
        },
        {
            'lat': 38.8910877769418,
            'lon': -77.41830762219213,
            'scale': 0.857,
            'heading': 193.4802893833773
        },
        {
            'lat': 38.889521789444615,
            'lon': -77.41932129305927,
            'scale': 1.096,
            'heading': 247.3149923391344
        },
        {
            'lat': 38.889764868928474,
            'lon': -77.41823686965806,
            'scale': 1.076,
            'heading': 166.37986257831943
        },
        {
            'lat': 38.88843446299695,
            'lon': -77.42107320805873,
            'scale': 1.101,
            'heading': 57.507205740729454
        },
        {
            'lat': 38.88980498317793,
            'lon': -77.41854694306915,
            'scale': 0.888,
            'heading': 276.2811968230303
        },
        {
            'lat': 38.88989467774991,
            'lon': -77.41828539324729,
            'scale': 1.075,
            'heading': 212.684510038441
        },
        {
            'lat': 38.89188719123949,
            'lon': -77.41788044018223,
            'scale': 1.052,
            'heading': 213.2585321138827
        },
        {
            'lat': 38.88964529242759,
            'lon': -77.41881419679154,
            'scale': 0.877,
            'heading': 128.11034815459473
        },
        {
            'lat': 38.88975303900245,
            'lon': -77.41820995759412,
            'scale': 1.179,
            'heading': 163.09141309565533
        },
        {
            'lat': 38.889583373281155,
            'lon': -77.4177028424325,
            'scale': 1.175,
            'heading': 118.18813744992313
        },
        {
            'lat': 38.890663127689606,
            'lon': -77.41851960280532,
            'scale': 1.072,
            'heading': 132.44665498175354
        },
        {
            'lat': 38.89198348483264,
            'lon': -77.41776216953242,
            'scale': 0.994,
            'heading': 26.354632117106448
        },
        {
            'lat': 38.89160727010207,
            'lon': -77.41871135405142,
            'scale': 1.061,
            'heading': 247.31234277520952
        },
        {
            'lat': 38.89075253262544,
            'lon': -77.41866996040532,
            'scale': 0.893,
            'heading': 24.543833251135165
        },
        {
            'lat': 38.89187780744787,
            'lon': -77.41820814737497,
            'scale': 0.889,
            'heading': 210.12037796030924
        },
        {
            'lat': 38.89041246855481,
            'lon': -77.41860151854709,
            'scale': 1.011,
            'heading': 78.03004367243811
        },
        {
            'lat': 38.891620750696795,
            'lon': -77.41853393995642,
            'scale': 0.812,
            'heading': 8.597868977273823
        },
        {
            'lat': 38.88996390451073,
            'lon': -77.41796502408089,
            'scale': 0.94,
            'heading': 134.24831095251568
        },
        {
            'lat': 38.88999179195388,
            'lon': -77.41810280463199,
            'scale': 0.869,
            'heading': 124.43362246564666
        },
        {
            'lat': 38.88958037426545,
            'lon': -77.41766264727993,
            'scale': 0.843,
            'heading': 179.45554948294517
        },
        {
            'lat': 38.89049106114213,
            'lon': -77.41802084883504,
            'scale': 1.056,
            'heading': 341.3542532290927
        },
        {
            'lat': 38.891134500071686,
            'lon': -77.41896984291769,
            'scale': 0.998,
            'heading': 235.66401037579936
        },
        {
            'lat': 38.89195788166996,
            'lon': -77.4183577244747,
            'scale': 1.026,
            'heading': 224.29397520368073
        },
        {
            'lat': 38.89179376522607,
            'lon': -77.41844188676383,
            'scale': 1.184,
            'heading': 333.705281918754
        },
        {
            'lat': 38.891747092518266,
            'lon': -77.41782800633717,
            'scale': 0.929,
            'heading': 97.09910897658649
        },
        {
            'lat': 38.889828742632034,
            'lon': -77.4180980202168,
            'scale': 0.92,
            'heading': 81.26521157691153
        },
        {
            'lat': 38.89184686135821,
            'lon': -77.41857157534554,
            'scale': 1.186,
            'heading': 335.61473369403325
        },
        {
            'lat': 38.89238566297441,
            'lon': -77.41925593917189,
            'scale': 0.902,
            'heading': 45.15708395940362
        },
        {
            'lat': 38.890519380609454,
            'lon': -77.41874142013832,
            'scale': 1.15,
            'heading': 295.35312605534085
        },
        {
            'lat': 38.89025942806853,
            'lon': -77.41834842059822,
            'scale': 0.836,
            'heading': 24.7032263045772
        },
        {
            'lat': 38.890887984221834,
            'lon': -77.41877752141966,
            'scale': 1.181,
            'heading': 1.448745875701456
        },
        {
            'lat': 38.89048763803696,
            'lon': -77.41832146271696,
            'scale': 0.918,
            'heading': 85.10005366562022
        },
        {
            'lat': 38.891926616620076,
            'lon': -77.41801413779494,
            'scale': 1.139,
            'heading': 214.70428644467736
        },
        {
            'lat': 38.89208676253322,
            'lon': -77.41908098330656,
            'scale': 0.942,
            'heading': 14.69809871266265
        },
        {
            'lat': 38.88994918787657,
            'lon': -77.41821842979854,
            'scale': 0.836,
            'heading': 57.47863220905604
        },
        {
            'lat': 38.88830608894406,
            'lon': -77.42101272368934,
            'scale': 1.012,
            'heading': 214.5170813015277
        },
        {
            'lat': 38.89013736331058,
            'lon': -77.41799246351928,
            'scale': 0.992,
            'heading': 352.2606717813349
        },
        {
            'lat': 38.88862034166599,
            'lon': -77.42124178043113,
            'scale': 1.139,
            'heading': 197.6967392306536
        },
        {
            'lat': 38.89092480892601,
            'lon': -77.41872027842001,
            'scale': 1.044,
            'heading': 313.07882698569034
        },
        {
            'lat': 38.89190719799382,
            'lon': -77.4188479443586,
            'scale': 0.917,
            'heading': 225.57391977367726
        },
        {
            'lat': 38.891817963152505,
            'lon': -77.41813659613914,
            'scale': 1.138,
            'heading': 42.04233628697303
        },
        {
            'lat': 38.89166807826141,
            'lon': -77.41793937496479,
            'scale': 1.05,
            'heading': 139.98324625530702
        },
        {
            'lat': 38.89036985577534,
            'lon': -77.41865838299256,
            'scale': 1.198,
            'heading': 163.89402645690006
        },
        {
            'lat': 38.89015419398154,
            'lon': -77.4187089992431,
            'scale': 1.119,
            'heading': 233.44733616441587
        },
        {
            'lat': 38.892236894546286,
            'lon': -77.41895529701809,
            'scale': 0.884,
            'heading': 103.12771596322294
        },
        {
            'lat': 38.89081356897929,
            'lon': -77.41889056966129,
            'scale': 1.163,
            'heading': 205.39512997965247
        },
        {
            'lat': 38.89035768294018,
            'lon': -77.418187671613,
            'scale': 1.045,
            'heading': 65.90138465005464
        },
        {
            'lat': 38.89210711527234,
            'lon': -77.41836403001061,
            'scale': 1.159,
            'heading': 239.91500643361047
        },
        {
            'lat': 38.89039337669551,
            'lon': -77.41855985706468,
            'scale': 1.022,
            'heading': 175.08817084487268
        },
        {
            'lat': 38.89072271964846,
            'lon': -77.41891260105128,
            'scale': 1.097,
            'heading': 84.32474107840238
        },
        {
            'lat': 38.890437032833944,
            'lon': -77.41846473474169,
            'scale': 1.156,
            'heading': 314.06213077166444
        },
        {
            'lat': 38.89012608792178,
            'lon': -77.4186639787206,
            'scale': 1.122,
            'heading': 164.45985257717211
        },
        {
            'lat': 38.89065960123456,
            'lon': -77.41828978778852,
            'scale': 0.876,
            'heading': 336.2615607087332
        },
        {
            'lat': 38.891392991104354,
            'lon': -77.41822361276215,
            'scale': 0.895,
            'heading': 327.10389516974953
        },
        {
            'lat': 38.890196860953054,
            'lon': -77.41838846131502,
            'scale': 1.129,
            'heading': 325.2653990721339
        },
        {
            'lat': 38.892213179852035,
            'lon': -77.41775465078655,
            'scale': 0.919,
            'heading': 220.52786135456702
        },
        {
            'lat': 38.8920410984798,
            'lon': -77.41805197958354,
            'scale': 1.056,
            'heading': 141.91707657392723
        },
        {
            'lat': 38.89185783820851,
            'lon': -77.41858638946917,
            'scale': 0.934,
            'heading': 223.74869047654818
        },
        {
            'lat': 38.88986972519912,
            'lon': -77.41871324421382,
            'scale': 0.82,
            'heading': 299.6243629205997
        },
        {
            'lat': 38.8912841007785,
            'lon': -77.41846669997182,
            'scale': 0.942,
            'heading': 145.08212467757613
        },
        {
            'lat': 38.88961948082248,
            'lon': -77.41855473994443,
            'scale': 1.199,
            'heading': 288.11244422061515
        },
        {
            'lat': 38.89231645430376,
            'lon': -77.41848300580948,
            'scale': 0.906,
            'heading': 203.74172152244006
        },
        {
            'lat': 38.892188165827875,
            'lon': -77.41868829773192,
            'scale': 1.038,
            'heading': 36.57352342274717
        },
        {
            'lat': 38.89169427040781,
            'lon': -77.4181694270526,
            'scale': 0.937,
            'heading': 24.914670188585735
        },
        {
            'lat': 38.889794766482986,
            'lon': -77.41801842928895,
            'scale': 0.973,
            'heading': 137.41888498532927
        },
        {
            'lat': 38.89220208388569,
            'lon': -77.41813580388416,
            'scale': 1.18,
            'heading': 72.25558289712511
        },
        {
            'lat': 38.89015354145324,
            'lon': -77.41851281752379,
            'scale': 1.176,
            'heading': 229.85754950133168
        },
        {
            'lat': 38.89177299619309,
            'lon': -77.41843599909929,
            'scale': 1.024,
            'heading': 344.9203899441429
        },
        {
            'lat': 38.89105337584971,
            'lon': -77.41872985996488,
            'scale': 1.129,
            'heading': 301.26065490222845
        },
        {
            'lat': 38.89164793797056,
            'lon': -77.41839477037999,
            'scale': 0.887,
            'heading': 246.7775134986466
        },
        {
            'lat': 38.89138302766573,
            'lon': -77.41813036485685,
            'scale': 0.837,
            'heading': 134.1506745682244
        },
        {
            'lat': 38.889622659332744,
            'lon': -77.41782810063361,
            'scale': 1.001,
            'heading': 149.5642475601207
        },
        {
            'lat': 38.889799514214936,
            'lon': -77.41803779800726,
            'scale': 0.812,
            'heading': 18.232093215860246
        },
        {
            'lat': 38.89071381416372,
            'lon': -77.41879699709486,
            'scale': 0.985,
            'heading': 255.9979293912293
        },
        {
            'lat': 38.89188458135659,
            'lon': -77.41772042839138,
            'scale': 0.906,
            'heading': 157.70915438555818
        },
        {
            'lat': 38.891526201690034,
            'lon': -77.4181745493805,
            'scale': 0.93,
            'heading': 320.57699636008726
        },
        {
            'lat': 38.89177299323606,
            'lon': -77.41829008959442,
            'scale': 1.08,
            'heading': 254.74763959380647
        },
        {
            'lat': 38.8904934652694,
            'lon': -77.41806671431964,
            'scale': 1.15,
            'heading': 347.9280663553892
        },
        {
            'lat': 38.89055922593008,
            'lon': -77.41828522140426,
            'scale': 0.819,
            'heading': 322.4216991838836
        },
        {
            'lat': 38.89090184683094,
            'lon': -77.41891219861256,
            'scale': 1.186,
            'heading': 60.85110201213391
        },
        {
            'lat': 38.89206650645842,
            'lon': -77.41887873414522,
            'scale': 0.82,
            'heading': 48.71632664515549
        },
        {
            'lat': 38.89047905703919,
            'lon': -77.41838694351283,
            'scale': 0.949,
            'heading': 200.45901299138063
        },
        {
            'lat': 38.891515659785014,
            'lon': -77.41890525463799,
            'scale': 0.994,
            'heading': 346.27959685440936
        },
        {
            'lat': 38.8919991303696,
            'lon': -77.41873745348174,
            'scale': 1.131,
            'heading': 240.49111386149312
        },
        {
            'lat': 38.89095943776566,
            'lon': -77.41855875314964,
            'scale': 0.814,
            'heading': 323.638397250526
        },
        {
            'lat': 38.89227797431833,
            'lon': -77.41801900534098,
            'scale': 1.053,
            'heading': 17.09931396445702
        },
        {
            'lat': 38.88829389362917,
            'lon': -77.42086261233061,
            'scale': 0.852,
            'heading': 55.65219487138583
        },
        {
            'lat': 38.89162092499089,
            'lon': -77.41889966800598,
            'scale': 1.111,
            'heading': 301.3595298834717
        },
        {
            'lat': 38.89125383202848,
            'lon': -77.41811458170122,
            'scale': 0.988,
            'heading': 245.119485430271
        },
        {
            'lat': 38.89159174595329,
            'lon': -77.41810556927649,
            'scale': 0.953,
            'heading': 23.044249699595966
        },
        {
            'lat': 38.888561326463055,
            'lon': -77.42116313209023,
            'scale': 1.113,
            'heading': 289.8257239586536
        },
        {
            'lat': 38.891074589791,
            'lon': -77.41864718019211,
            'scale': 0.908,
            'heading': 327.9284502776923
        },
        {
            'lat': 38.88810931094556,
            'lon': -77.42137288105322,
            'scale': 1.085,
            'heading': 168.9346576299694
        },
        {
            'lat': 38.89230856071866,
            'lon': -77.41817226306101,
            'scale': 1.159,
            'heading': 164.84424579486875
        },
        {
            'lat': 38.8920824549174,
            'lon': -77.4188174404181,
            'scale': 0.867,
            'heading': 34.29595925472818
        },
        {
            'lat': 38.89232324355045,
            'lon': -77.41884884601416,
            'scale': 1.105,
            'heading': 200.34742770905788
        },
        {
            'lat': 38.88824484714307,
            'lon': -77.42124098524812,
            'scale': 1.169,
            'heading': 202.90495597801663
        },
        {
            'lat': 38.89235539513601,
            'lon': -77.41884782962659,
            'scale': 1.012,
            'heading': 164.9248651662037
        },
        {
            'lat': 38.891025174750844,
            'lon': -77.4188340228045,
            'scale': 1.042,
            'heading': 308.4683715144464
        },
        {
            'lat': 38.88998410736034,
            'lon': -77.41804366275942,
            'scale': 0.994,
            'heading': 185.75692434184856
        },
        {
            'lat': 38.89077994896736,
            'lon': -77.41827950751842,
            'scale': 1.13,
            'heading': 109.93390810982227
        },
        {
            'lat': 38.88816327973701,
            'lon': -77.4213446524245,
            'scale': 0.853,
            'heading': 358.3966812827638
        },
        {
            'lat': 38.88956585118342,
            'lon': -77.4184683449227,
            'scale': 1.176,
            'heading': 159.80110155469242
        },
        {
            'lat': 38.89211746915894,
            'lon': -77.41818131191484,
            'scale': 1.199,
            'heading': 56.26940310848504
        },
        {
            'lat': 38.89053608856803,
            'lon': -77.4181527908583,
            'scale': 0.916,
            'heading': 217.80813933030882
        },
        {
            'lat': 38.88978711945828,
            'lon': -77.41822655237294,
            'scale': 1.072,
            'heading': 70.87688051994797
        },
        {
            'lat': 38.88990415842366,
            'lon': -77.41835743291306,
            'scale': 0.863,
            'heading': 69.51941582143273
        },
        {
            'lat': 38.890229466515684,
            'lon': -77.41821777718906,
            'scale': 0.961,
            'heading': 337.0691655993383
        },
        {
            'lat': 38.891253298146935,
            'lon': -77.41805657818483,
            'scale': 0.886,
            'heading': 101.83391307549455
        },
        {
            'lat': 38.89163179566078,
            'lon': -77.41809081110401,
            'scale': 1.039,
            'heading': 169.48408898675834
        },
        {
            'lat': 38.890761528198944,
            'lon': -77.4184319832418,
            'scale': 0.917,
            'heading': 269.8494697023772
        },
        {
            'lat': 38.890746493870125,
            'lon': -77.41842094477265,
            'scale': 0.96,
            'heading': 239.84798565712742
        },
        {
            'lat': 38.89030148245887,
            'lon': -77.41831942404774,
            'scale': 1.156,
            'heading': 53.36738020449235
        },
        {
            'lat': 38.890982875387536,
            'lon': -77.41820768098374,
            'scale': 0.847,
            'heading': 24.478175175774695
        },
        {
            'lat': 38.891406568329444,
            'lon': -77.41888537153898,
            'scale': 1.037,
            'heading': 74.88740431997253
        },
        {
            'lat': 38.89039297249139,
            'lon': -77.41863113289358,
            'scale': 0.988,
            'heading': 18.20131629838018
        },
        {
            'lat': 38.89212729892245,
            'lon': -77.41912582797632,
            'scale': 1.094,
            'heading': 209.98306498887578
        },
        {
            'lat': 38.891859701620305,
            'lon': -77.41857455437977,
            'scale': 0.883,
            'heading': 298.3175326840582
        },
        {
            'lat': 38.88812531196739,
            'lon': -77.4211882019595,
            'scale': 1.104,
            'heading': 47.17420230172487
        },
        {
            'lat': 38.89064051500078,
            'lon': -77.41890230908808,
            'scale': 0.945,
            'heading': 1.0700252929826437
        },
        {
            'lat': 38.890076521216145,
            'lon': -77.41827837393198,
            'scale': 1.013,
            'heading': 25.500088356237036
        },
        {
            'lat': 38.889834882180786,
            'lon': -77.41834008803468,
            'scale': 1.025,
            'heading': 269.03382057393526
        },
        {
            'lat': 38.89002375576989,
            'lon': -77.4186056089166,
            'scale': 0.976,
            'heading': 93.53600728174543
        },
        {
            'lat': 38.8904069340307,
            'lon': -77.4186085585627,
            'scale': 0.84,
            'heading': 298.56695300733844
        },
        {
            'lat': 38.89097244270192,
            'lon': -77.41806251161611,
            'scale': 0.856,
            'heading': 133.462888465359
        },
        {
            'lat': 38.89214186777789,
            'lon': -77.41879607329649,
            'scale': 1.128,
            'heading': 84.33959833911682
        },
        {
            'lat': 38.89000900948014,
            'lon': -77.41837498807635,
            'scale': 1.045,
            'heading': 255.99919992396786
        },
        {
            'lat': 38.89022362309052,
            'lon': -77.41890510531158,
            'scale': 1.166,
            'heading': 173.7405125841545
        },
        {
            'lat': 38.88813131785387,
            'lon': -77.42121944335078,
            'scale': 0.991,
            'heading': 138.0972576079069
        },
        {
            'lat': 38.88824287390788,
            'lon': -77.42147145329963,
            'scale': 1.134,
            'heading': 114.36990710924165
        },
        {
            'lat': 38.89004194851465,
            'lon': -77.41835566871991,
            'scale': 0.816,
            'heading': 28.914847212846052
        },
        {
            'lat': 38.89045284536583,
            'lon': -77.41823722529111,
            'scale': 1.04,
            'heading': 340.91609809796836
        },
        {
            'lat': 38.89033840304088,
            'lon': -77.41796558715164,
            'scale': 0.902,
            'heading': 186.01838074884137
        },
        {
            'lat': 38.89195597358524,
            'lon': -77.4186521603654,
            'scale': 0.905,
            'heading': 253.1441328106649
        },
        {
            'lat': 38.892050437519224,
            'lon': -77.41772130017365,
            'scale': 1.14,
            'heading': 89.06189537643428
        },
        {
            'lat': 38.89157228246874,
            'lon': -77.41863945242928,
            'scale': 1.018,
            'heading': 106.6420046022383
        },
        {
            'lat': 38.89195249186526,
            'lon': -77.41844261346762,
            'scale': 1.064,
            'heading': 113.65392654002694
        },
        {
            'lat': 38.892301290146,
            'lon': -77.41912178383392,
            'scale': 1.124,
            'heading': 74.1999257179479
        },
        {
            'lat': 38.89162972786699,
            'lon': -77.41890444136898,
            'scale': 1.026,
            'heading': 280.3421061352805
        },
        {
            'lat': 38.890319692581805,
            'lon': -77.41824529281939,
            'scale': 1.097,
            'heading': 227.68250793555052
        },
        {
            'lat': 38.89190944593944,
            'lon': -77.41850362191653,
            'scale': 1.189,
            'heading': 159.14110753907116
        },
        {
            'lat': 38.892149372609765,
            'lon': -77.41807273166135,
            'scale': 1.106,
            'heading': 111.33999688595848
        },
        {
            'lat': 38.89088456801557,
            'lon': -77.4180824824543,
            'scale': 0.937,
            'heading': 318.40440361599616
        },
        {
            'lat': 38.8916170576443,
            'lon': -77.41869551154066,
            'scale': 1.053,
            'heading': 46.214154772852055
        },
        {
            'lat': 38.888516766304534,
            'lon': -77.42137835480091,
            'scale': 0.865,
            'heading': 202.11840357099925
        },
        {
            'lat': 38.89219081917905,
            'lon': -77.4182172342415,
            'scale': 1.118,
            'heading': 76.16001763062398
        },
        {
            'lat': 38.88837288107253,
            'lon': -77.42117821987887,
            'scale': 0.994,
            'heading': 272.6030055896274
        },
        {
            'lat': 38.89209013090211,
            'lon': -77.41861189132884,
            'scale': 0.926,
            'heading': 227.31054795027742
        },
        {
            'lat': 38.89228495241431,
            'lon': -77.41908388989883,
            'scale': 0.802,
            'heading': 28.29939686074217
        },
        {
            'lat': 38.89082244890708,
            'lon': -77.4180752082789,
            'scale': 0.809,
            'heading': 14.874583805527202
        },
        {
            'lat': 38.891288177714,
            'lon': -77.4181810118877,
            'scale': 1.049,
            'heading': 268.1673399425393
        },
        {
            'lat': 38.88813204169337,
            'lon': -77.42151734369524,
            'scale': 1.028,
            'heading': 157.76092933568324
        },
        {
            'lat': 38.8901890170772,
            'lon': -77.4180809127801,
            'scale': 0.895,
            'heading': 294.1170788957156
        },
        {
            'lat': 38.89203731491011,
            'lon': -77.41813178013244,
            'scale': 0.853,
            'heading': 293.71201410105067
        },
        {
            'lat': 38.888632513661165,
            'lon': -77.42109818626427,
            'scale': 0.857,
            'heading': 351.52097790831175
        },
        {
            'lat': 38.89127018467385,
            'lon': -77.41877812266618,
            'scale': 0.937,
            'heading': 104.48309750241334
        },
        {
            'lat': 38.8909577574268,
            'lon': -77.41817946608556,
            'scale': 0.866,
            'heading': 47.96074530601479
        },
        {
            'lat': 38.89229210182353,
            'lon': -77.41868563887354,
            'scale': 1.131,
            'heading': 58.74429778767423
        },
        {
            'lat': 38.89021441080166,
            'lon': -77.41801492016106,
            'scale': 1.145,
            'heading': 197.16725363162305
        },
        {
            'lat': 38.89233280879603,
            'lon': -77.41842793933682,
            'scale': 1.145,
            'heading': 202.11304020569617
        },
        {
            'lat': 38.89211827435705,
            'lon': -77.4191226813462,
            'scale': 0.967,
            'heading': 165.57736968457945
        },
        {
            'lat': 38.89224578413113,
            'lon': -77.4186391677595,
            'scale': 1.193,
            'heading': 120.71758131756236
        },
        {
            'lat': 38.89026060125026,
            'lon': -77.41805577343393,
            'scale': 1.069,
            'heading': 53.35967185851439
        },
        {
            'lat': 38.89099599602997,
            'lon': -77.41892369468003,
            'scale': 0.999,
            'heading': 229.25937347846303
        },
        {
            'lat': 38.89231656407117,
            'lon': -77.41905938548872,
            'scale': 1.037,
            'heading': 82.71558102053956
        },
        {
            'lat': 38.89000177859889,
            'lon': -77.41772833547826,
            'scale': 1.125,
            'heading': 211.47231630757983
        },
        {
            'lat': 38.88871031347435,
            'lon': -77.4209431137325,
            'scale': 1.001,
            'heading': 200.0516974827958
        },
        {
            'lat': 38.89100262571779,
            'lon': -77.41808637392583,
            'scale': 1.149,
            'heading': 14.564282598780824
        },
        {
            'lat': 38.888204415078995,
            'lon': -77.42113153956865,
            'scale': 0.839,
            'heading': 117.76471933341675
        },
        {
            'lat': 38.88822740918244,
            'lon': -77.42136456818376,
            'scale': 0.92,
            'heading': 211.58250427863675
        },
        {
            'lat': 38.88985871080733,
            'lon': -77.41776473211938,
            'scale': 1.068,
            'heading': 171.99101327244702
        },
        {
            'lat': 38.89210935964796,
            'lon': -77.41879313541845,
            'scale': 1.139,
            'heading': 219.22953911947454
        },
        {
            'lat': 38.89172449240633,
            'lon': -77.41780543134028,
            'scale': 1.089,
            'heading': 289.14702296679627
        },
        {
            'lat': 38.89082150809475,
            'lon': -77.41862015187327,
            'scale': 1.158,
            'heading': 29.35458065865186
        },
        {
            'lat': 38.890157819200574,
            'lon': -77.41888399133586,
            'scale': 0.851,
            'heading': 33.574508534859426
        },
        {
            'lat': 38.892397166487996,
            'lon': -77.41810801668126,
            'scale': 0.875,
            'heading': 142.2250160327114
        },
        {
            'lat': 38.888135337751656,
            'lon': -77.42102513967308,
            'scale': 1.021,
            'heading': 172.9114135492613
        },
        {
            'lat': 38.891657078926876,
            'lon': -77.4187016023926,
            'scale': 0.962,
            'heading': 174.07678061863294
        },
        {
            'lat': 38.89003579605239,
            'lon': -77.41800281215221,
            'scale': 1.154,
            'heading': 51.19481252218626
        },
        {
            'lat': 38.89139444217754,
            'lon': -77.41829766231899,
            'scale': 1.004,
            'heading': 41.88758624695617
        },
        {
            'lat': 38.890244340675046,
            'lon': -77.41812234381479,
            'scale': 1.005,
            'heading': 163.59340421461877
        },
        {
            'lat': 38.892191168400785,
            'lon': -77.41830414935193,
            'scale': 0.942,
            'heading': 100.75767619095352
        },
        {
            'lat': 38.890389023268895,
            'lon': -77.41822563655388,
            'scale': 0.855,
            'heading': 161.19056181765004
        },
        {
            'lat': 38.892234513487566,
            'lon': -77.41857433076089,
            'scale': 1.144,
            'heading': 8.540127367762608
        },
        {
            'lat': 38.89102907595253,
            'lon': -77.41802666370803,
            'scale': 1.179,
            'heading': 283.71899252459156
        },
        {
            'lat': 38.8913228251186,
            'lon': -77.41811865520222,
            'scale': 0.964,
            'heading': 126.9363257076961
        },
        {
            'lat': 38.88817795094873,
            'lon': -77.42120518378627,
            'scale': 1.12,
            'heading': 345.5683837650064
        },
        {
            'lat': 38.89201206758612,
            'lon': -77.41797325066752,
            'scale': 1.094,
            'heading': 69.85948617804134
        },
        {
            'lat': 38.892347680015035,
            'lon': -77.41889219513874,
            'scale': 0.966,
            'heading': 25.879934758181573
        },
        {
            'lat': 38.89151822526952,
            'lon': -77.41826086773035,
            'scale': 1.099,
            'heading': 7.277071437457381
        },
        {
            'lat': 38.88957576564054,
            'lon': -77.41879715774823,
            'scale': 1.098,
            'heading': 233.36669074265927
        },
        {
            'lat': 38.89202850124908,
            'lon': -77.41806874286223,
            'scale': 0.838,
            'heading': 343.8375532756763
        },
        {
            'lat': 38.888302586337815,
            'lon': -77.42108953213048,
            'scale': 0.878,
            'heading': 123.29827623010966
        },
        {
            'lat': 38.890706354556556,
            'lon': -77.41874061861925,
            'scale': 0.938,
            'heading': 193.19990518673407
        },
        {
            'lat': 38.89077714451768,
            'lon': -77.41855308445972,
            'scale': 1.034,
            'heading': 13.02920400744624
        },
        {
            'lat': 38.88959260734341,
            'lon': -77.41826919786425,
            'scale': 1.07,
            'heading': 242.19448176699214
        },
        {
            'lat': 38.89084738054895,
            'lon': -77.41888742114324,
            'scale': 0.831,
            'heading': 18.19293003632495
        },
        {
            'lat': 38.892057755564316,
            'lon': -77.4188846963839,
            'scale': 1.076,
            'heading': 149.93707106975856
        },
        {
            'lat': 38.89172219244955,
            'lon': -77.41803499806848,
            'scale': 0.854,
            'heading': 2.3366823400316328
        },
        {
            'lat': 38.89166287174943,
            'lon': -77.4188309723741,
            'scale': 0.918,
            'heading': 114.39517106223803
        },
        {
            'lat': 38.8920839679487,
            'lon': -77.41839043478002,
            'scale': 0.972,
            'heading': 31.69491549826288
        },
        {
            'lat': 38.89205290167438,
            'lon': -77.41834589561927,
            'scale': 1.175,
            'heading': 200.51331461065774
        },
        {
            'lat': 38.88820467229764,
            'lon': -77.42100697015229,
            'scale': 0.887,
            'heading': 294.0431977098899
        },
        {
            'lat': 38.89039437937587,
            'lon': -77.4187443215886,
            'scale': 1.038,
            'heading': 212.6106747053747
        },
        {
            'lat': 38.89189598620875,
            'lon': -77.41780864480127,
            'scale': 1.115,
            'heading': 240.94555295908995
        },
        {
            'lat': 38.88955922802825,
            'lon': -77.41799089083979,
            'scale': 1.172,
            'heading': 335.44293992209015
        },
        {
            'lat': 38.88989916790148,
            'lon': -77.41874585972297,
            'scale': 0.977,
            'heading': 25.16880707395884
        },
        {
            'lat': 38.89091725362176,
            'lon': -77.41895392809512,
            'scale': 0.984,
            'heading': 91.13388898573426
        },
        {
            'lat': 38.88988861580588,
            'lon': -77.4186057187981,
            'scale': 0.851,
            'heading': 318.527953298865
        },
        {
            'lat': 38.89045721081493,
            'lon': -77.41844255446512,
            'scale': 0.865,
            'heading': 31.830061389810606
        },
        {
            'lat': 38.88831263289784,
            'lon': -77.42143489757045,
            'scale': 1.07,
            'heading': 135.57112482534166
        },
        {
            'lat': 38.890234891941304,
            'lon': -77.41790096343489,
            'scale': 0.936,
            'heading': 221.68048024311267
        },
        {
            'lat': 38.88834515687864,
            'lon': -77.42083396316703,
            'scale': 1.148,
            'heading': 88.94446923545517
        },
        {
            'lat': 38.89007298504597,
            'lon': -77.41766891857844,
            'scale': 1.02,
            'heading': 197.8918926713832
        },
        {
            'lat': 38.89023972196511,
            'lon': -77.41854377987939,
            'scale': 0.869,
            'heading': 179.25245661398208
        },
        {
            'lat': 38.89026928375524,
            'lon': -77.4187018407356,
            'scale': 1.037,
            'heading': 263.9939024772226
        },
        {
            'lat': 38.88849625835143,
            'lon': -77.42097680147974,
            'scale': 1.0,
            'heading': 169.83318797209614
        },
        {
            'lat': 38.88851102209433,
            'lon': -77.42123874155095,
            'scale': 0.891,
            'heading': 317.7942256680481
        },
        {
            'lat': 38.89188267088425,
            'lon': -77.41883084093301,
            'scale': 1.045,
            'heading': 81.0716814755865
        },
        {
            'lat': 38.891756285108656,
            'lon': -77.41797631188376,
            'scale': 0.899,
            'heading': 357.8408842783602
        },
        {
            'lat': 38.892107675646365,
            'lon': -77.4182492111547,
            'scale': 1.183,
            'heading': 16.097699394358568
        },
        {
            'lat': 38.89027777400021,
            'lon': -77.41884512775037,
            'scale': 0.83,
            'heading': 264.77661424613297
        },
        {
            'lat': 38.88961604798415,
            'lon': -77.41767522216509,
            'scale': 0.919,
            'heading': 108.82635236701472
        },
        {
            'lat': 38.89220345155748,
            'lon': -77.4186341681145,
            'scale': 1.02,
            'heading': 55.57040641882074
        },
        {
            'lat': 38.8919836260194,
            'lon': -77.418086983826,
            'scale': 0.862,
            'heading': 171.75365819128248
        },
        {
            'lat': 38.89148251752787,
            'lon': -77.41879592626337,
            'scale': 0.965,
            'heading': 302.0635374755341
        },
        {
            'lat': 38.890851555587574,
            'lon': -77.41842905418808,
            'scale': 1.066,
            'heading': 205.03079646818415
        },
        {
            'lat': 38.891638316338735,
            'lon': -77.41797326346271,
            'scale': 1.074,
            'heading': 99.11955517050528
        },
        {
            'lat': 38.89199166850623,
            'lon': -77.41842744271754,
            'scale': 1.192,
            'heading': 167.59007081791705
        },
        {
            'lat': 38.891947839354266,
            'lon': -77.41806640141982,
            'scale': 0.937,
            'heading': 355.70444732394515
        },
        {
            'lat': 38.89088452627604,
            'lon': -77.41819913475884,
            'scale': 0.869,
            'heading': 212.29253533968173
        },
        {
            'lat': 38.8921518555544,
            'lon': -77.41874524580616,
            'scale': 1.079,
            'heading': 197.9453051695636
        },
        {
            'lat': 38.888466555508415,
            'lon': -77.4214130475159,
            'scale': 0.859,
            'heading': 277.05205723103563
        },
        {
            'lat': 38.89112249567134,
            'lon': -77.4184318011916,
            'scale': 1.095,
            'heading': 89.01465093270363
        },
        {
            'lat': 38.891093091353454,
            'lon': -77.41808201071065,
            'scale': 1.136,
            'heading': 292.7388902911591
        },
        {
            'lat': 38.89127465595697,
            'lon': -77.41845286839475,
            'scale': 0.961,
            'heading': 1.2589754979531032
        },
        {
            'lat': 38.89077132345097,
            'lon': -77.41848288859924,
            'scale': 1.121,
            'heading': 100.59459838106892
        },
        {
            'lat': 38.89160638434465,
            'lon': -77.41865243603961,
            'scale': 0.809,
            'heading': 129.95758225044403
        },
        {
            'lat': 38.89047511959324,
            'lon': -77.41810691468302,
            'scale': 0.865,
            'heading': 265.50841392221827
        },
        {
            'lat': 38.891018531379444,
            'lon': -77.4181246615969,
            'scale': 1.13,
            'heading': 241.45802408859922
        },
        {
            'lat': 38.89233378952295,
            'lon': -77.41865527518839,
            'scale': 0.981,
            'heading': 5.5797366287820305
        },
        {
            'lat': 38.89062695599006,
            'lon': -77.41812770993872,
            'scale': 1.003,
            'heading': 353.8444895416824
        },
        {
            'lat': 38.88841997990975,
            'lon': -77.42094111285648,
            'scale': 1.191,
            'heading': 353.3051469584885
        },
        {
            'lat': 38.89047509395933,
            'lon': -77.41836425001617,
            'scale': 1.11,
            'heading': 131.39090808693192
        },
        {
            'lat': 38.89222360564651,
            'lon': -77.41826261894815,
            'scale': 0.946,
            'heading': 273.3728616467803
        },
        {
            'lat': 38.88951492319474,
            'lon': -77.41902184006987,
            'scale': 0.875,
            'heading': 51.465536510336946
        },
        {
            'lat': 38.89013415162033,
            'lon': -77.41874039195326,
            'scale': 1.18,
            'heading': 216.75424551016093
        },
        {
            'lat': 38.89124870709272,
            'lon': -77.41841058133497,
            'scale': 0.872,
            'heading': 179.94874804214672
        },
        {
            'lat': 38.89107873596529,
            'lon': -77.41857663893337,
            'scale': 1.061,
            'heading': 151.70415098325466
        },
        {
            'lat': 38.89125349861098,
            'lon': -77.41828167495667,
            'scale': 1.111,
            'heading': 338.04306698177703
        },
        {
            'lat': 38.89016170160703,
            'lon': -77.4185668097488,
            'scale': 0.947,
            'heading': 254.47571484419257
        },
        {
            'lat': 38.89138880330409,
            'lon': -77.41817105571938,
            'scale': 0.934,
            'heading': 90.45084989029041
        },
        {
            'lat': 38.888265672312336,
            'lon': -77.4209328586494,
            'scale': 0.871,
            'heading': 119.15165342346718
        },
        {
            'lat': 38.89121886250221,
            'lon': -77.41802903349588,
            'scale': 1.131,
            'heading': 344.0658263456153
        },
        {
            'lat': 38.890049411690505,
            'lon': -77.41855047967186,
            'scale': 0.942,
            'heading': 345.9951419920091
        },
        {
            'lat': 38.890739450548445,
            'lon': -77.41805007587686,
            'scale': 0.929,
            'heading': 116.06311568416461
        },
        {
            'lat': 38.89059848819321,
            'lon': -77.4189272916609,
            'scale': 0.879,
            'heading': 339.00533302838795
        },
        {
            'lat': 38.890971668351035,
            'lon': -77.41832833576755,
            'scale': 1.006,
            'heading': 37.27180921248083
        },
        {
            'lat': 38.89040785810769,
            'lon': -77.4188652782497,
            'scale': 0.835,
            'heading': 215.89862871579732
        },
        {
            'lat': 38.89202307581952,
            'lon': -77.41881823846066,
            'scale': 0.849,
            'heading': 42.702169343781414
        },
        {
            'lat': 38.89108032222321,
            'lon': -77.41883883587734,
            'scale': 0.871,
            'heading': 267.43997685500034
        },
        {
            'lat': 38.89019600074212,
            'lon': -77.4185883582832,
            'scale': 1.133,
            'heading': 19.706937196489974
        },
        {
            'lat': 38.88811686568286,
            'lon': -77.42096551954646,
            'scale': 1.116,
            'heading': 303.8306689895375
        },
        {
            'lat': 38.8885956870715,
            'lon': -77.42112703249238,
            'scale': 1.075,
            'heading': 115.68091423317956
        },
        {
            'lat': 38.8922281578457,
            'lon': -77.41897276649169,
            'scale': 0.802,
            'heading': 121.91510642478883
        },
        {
            'lat': 38.89164493521845,
            'lon': -77.41872484546856,
            'scale': 0.913,
            'heading': 350.19099435686877
        },
        {
            'lat': 38.89232392899653,
            'lon': -77.41805721925184,
            'scale': 1.12,
            'heading': 262.44189133325307
        },
        {
            'lat': 38.892222141829926,
            'lon': -77.41876165955543,
            'scale': 0.941,
            'heading': 134.39943243768045
        },
        {
            'lat': 38.89190628126858,
            'lon': -77.41877114926704,
            'scale': 1.019,
            'heading': 123.10496474899777
        },
        {
            'lat': 38.89120841256824,
            'lon': -77.41863609725871,
            'scale': 1.192,
            'heading': 351.2744694843972
        },
        {
            'lat': 38.89055161527007,
            'lon': -77.41805539176053,
            'scale': 1.058,
            'heading': 179.89858059444538
        },
        {
            'lat': 38.89182655641301,
            'lon': -77.41832028544512,
            'scale': 0.819,
            'heading': 228.08108763377325
        },
        {
            'lat': 38.89048515749496,
            'lon': -77.41828775378058,
            'scale': 1.057,
            'heading': 29.50874380526189
        },
        {
            'lat': 38.89147229483111,
            'lon': -77.41855478347185,
            'scale': 1.162,
            'heading': 59.08246320358518
        },
        {
            'lat': 38.890999017697965,
            'lon': -77.41893891982568,
            'scale': 0.807,
            'heading': 132.5227704505232
        },
        {
            'lat': 38.88964744896858,
            'lon': -77.41908683777825,
            'scale': 1.145,
            'heading': 49.47817639032618
        },
        {
            'lat': 38.89238023476617,
            'lon': -77.41782138474753,
            'scale': 1.155,
            'heading': 106.56600214382242
        },
        {
            'lat': 38.89024759538465,
            'lon': -77.41831110307696,
            'scale': 1.176,
            'heading': 74.45745852959091
        },
        {
            'lat': 38.88830760411308,
            'lon': -77.42104772710293,
            'scale': 1.11,
            'heading': 151.19259170237842
        },
        {
            'lat': 38.89209684800563,
            'lon': -77.41828941999333,
            'scale': 0.978,
            'heading': 359.6043485980709
        },
        {
            'lat': 38.89237026138311,
            'lon': -77.41822063535,
            'scale': 0.888,
            'heading': 280.58339896215205
        },
        {
            'lat': 38.890586316623434,
            'lon': -77.41865511424848,
            'scale': 0.841,
            'heading': 40.80370148589873
        },
        {
            'lat': 38.891803996487674,
            'lon': -77.41843810516967,
            'scale': 1.117,
            'heading': 304.7380546423295
        },
        {
            'lat': 38.890482484283176,
            'lon': -77.41815609091711,
            'scale': 1.112,
            'heading': 118.9892590506982
        },
        {
            'lat': 38.89193805507736,
            'lon': -77.41869011834126,
            'scale': 0.967,
            'heading': 330.23208548064014
        },
        {
            'lat': 38.889569723688695,
            'lon': -77.41798021873348,
            'scale': 0.856,
            'heading': 233.02669590897986
        },
        {
            'lat': 38.891229224765155,
            'lon': -77.41866221377144,
            'scale': 1.122,
            'heading': 12.475990494125991
        },
        {
            'lat': 38.88817460809709,
            'lon': -77.42090533901474,
            'scale': 0.931,
            'heading': 243.7953771163234
        },
        {
            'lat': 38.88836554262481,
            'lon': -77.42116368597404,
            'scale': 1.128,
            'heading': 178.85944413418062
        },
        {
            'lat': 38.88966295029759,
            'lon': -77.41853279739571,
            'scale': 0.995,
            'heading': 140.53831322527023
        },
        {
            'lat': 38.88996057954492,
            'lon': -77.41869559255635,
            'scale': 1.163,
            'heading': 238.4068787932065
        },
        {
            'lat': 38.89114249040232,
            'lon': -77.41835566247786,
            'scale': 0.873,
            'heading': 75.67601494420684
        },
        {
            'lat': 38.892112971735024,
            'lon': -77.41805529931007,
            'scale': 0.992,
            'heading': 113.16712518067492
        },
        {
            'lat': 38.891828001199244,
            'lon': -77.4180262739156,
            'scale': 0.833,
            'heading': 74.69100364295625
        },
        {
            'lat': 38.89183088819618,
            'lon': -77.4183633299191,
            'scale': 1.199,
            'heading': 163.2705598250974
        },
        {
            'lat': 38.889624497501245,
            'lon': -77.41865056778967,
            'scale': 0.928,
            'heading': 296.173659006217
        },
        {
            'lat': 38.891894561349076,
            'lon': -77.41831909767086,
            'scale': 0.822,
            'heading': 29.96228577407297
        },
        {
            'lat': 38.8881668722347,
            'lon': -77.42126536599443,
            'scale': 0.928,
            'heading': 111.6866278546724
        },
        {
            'lat': 38.89200930382614,
            'lon': -77.41900129920944,
            'scale': 1.101,
            'heading': 255.3039194543542
        },
        {
            'lat': 38.89067259046968,
            'lon': -77.41811773793005,
            'scale': 0.86,
            'heading': 324.6759511372239
        },
        {
            'lat': 38.89002367031238,
            'lon': -77.41798388817193,
            'scale': 1.014,
            'heading': 219.6322470396472
        },
        {
            'lat': 38.8902849860628,
            'lon': -77.41877619309548,
            'scale': 1.009,
            'heading': 179.12311649075556
        },
        {
            'lat': 38.891557933005245,
            'lon': -77.41851278470598,
            'scale': 0.91,
            'heading': 283.4821128030089
        },
        {
            'lat': 38.889837827549435,
            'lon': -77.41846392348525,
            'scale': 0.849,
            'heading': 93.78534058700002
        },
        {
            'lat': 38.891877778430846,
            'lon': -77.4186616282376,
            'scale': 1.189,
            'heading': 318.18387368633944
        },
        {
            'lat': 38.89089703540718,
            'lon': -77.41846084967892,
            'scale': 1.009,
            'heading': 179.03707131055802
        },
        {
            'lat': 38.890993519495346,
            'lon': -77.41841407402397,
            'scale': 1.191,
            'heading': 70.79095796470453
        },
        {
            'lat': 38.89171524748708,
            'lon': -77.41855416772674,
            'scale': 0.855,
            'heading': 123.82178758279272
        },
        {
            'lat': 38.890995751236595,
            'lon': -77.41875341809504,
            'scale': 0.819,
            'heading': 113.2553773650277
        },
        {
            'lat': 38.89201607892429,
            'lon': -77.41813992871113,
            'scale': 1.165,
            'heading': 271.2707169867897
        },
        {
            'lat': 38.889969995793834,
            'lon': -77.4186803928941,
            'scale': 0.902,
            'heading': 354.522971654247
        },
        {
            'lat': 38.89170777894647,
            'lon': -77.41889426972874,
            'scale': 0.998,
            'heading': 304.78013024884086
        },
        {
            'lat': 38.89208113650942,
            'lon': -77.41806120534883,
            'scale': 1.192,
            'heading': 353.5846950167049
        },
        {
            'lat': 38.89225053979609,
            'lon': -77.41860608534661,
            'scale': 1.0,
            'heading': 157.92522670166068
        },
        {
            'lat': 38.89228816202129,
            'lon': -77.4177328563238,
            'scale': 0.968,
            'heading': 168.89581184463998
        },
        {
            'lat': 38.89090630340018,
            'lon': -77.41899873588825,
            'scale': 0.922,
            'heading': 291.1499356654722
        },
        {
            'lat': 38.892169475773954,
            'lon': -77.41839509354318,
            'scale': 0.825,
            'heading': 105.55369956406201
        },
        {
            'lat': 38.89147744891436,
            'lon': -77.41829976869847,
            'scale': 1.12,
            'heading': 213.299056774879
        },
        {
            'lat': 38.890759285286165,
            'lon': -77.41800357329674,
            'scale': 1.17,
            'heading': 54.02451304633238
        },
        {
            'lat': 38.89185645642715,
            'lon': -77.41884050650461,
            'scale': 0.912,
            'heading': 344.6682194381095
        },
        {
            'lat': 38.892132407709525,
            'lon': -77.41830591174626,
            'scale': 1.087,
            'heading': 228.21502606440032
        },
        {
            'lat': 38.890423582591005,
            'lon': -77.41875700565257,
            'scale': 1.037,
            'heading': 232.88268872591397
        },
        {
            'lat': 38.89190722299397,
            'lon': -77.41781754117383,
            'scale': 1.14,
            'heading': 259.49075871389414
        },
        {
            'lat': 38.88856569265071,
            'lon': -77.42118185648509,
            'scale': 1.075,
            'heading': 141.14671495060506
        },
        {
            'lat': 38.888154876161515,
            'lon': -77.42142653667582,
            'scale': 1.13,
            'heading': 267.7286818753822
        },
        {
            'lat': 38.88945679834945,
            'lon': -77.41911627486542,
            'scale': 0.851,
            'heading': 51.90526032767621
        },
        {
            'lat': 38.888189406357306,
            'lon': -77.42093060942751,
            'scale': 1.12,
            'heading': 47.21182888194238
        },
        {
            'lat': 38.889570532021644,
            'lon': -77.41864822383025,
            'scale': 0.906,
            'heading': 92.044842517759
        },
        {
            'lat': 38.89206460273333,
            'lon': -77.41885981511138,
            'scale': 0.82,
            'heading': 319.56676885155565
        },
        {
            'lat': 38.88993747471313,
            'lon': -77.41817725110111,
            'scale': 1.048,
            'heading': 5.520392564844583
        },
        {
            'lat': 38.89093176013555,
            'lon': -77.41888994648033,
            'scale': 1.051,
            'heading': 215.02183750072894
        },
        {
            'lat': 38.89201059359448,
            'lon': -77.41823701427283,
            'scale': 1.168,
            'heading': 274.4477839683244
        },
        {
            'lat': 38.889552738013656,
            'lon': -77.4178362328481,
            'scale': 0.866,
            'heading': 274.01588736559586
        },
        {
            'lat': 38.89066511420567,
            'lon': -77.4181000134545,
            'scale': 0.81,
            'heading': 6.051428640873389
        },
        {
            'lat': 38.891623186811465,
            'lon': -77.41813035799359,
            'scale': 1.071,
            'heading': 215.7525758088438
        },
        {
            'lat': 38.88818934044039,
            'lon': -77.42097296895524,
            'scale': 1.124,
            'heading': 4.220813581646641
        },
        {
            'lat': 38.89109406461129,
            'lon': -77.418655937245,
            'scale': 0.993,
            'heading': 244.1514191962129
        },
        {
            'lat': 38.89101653472488,
            'lon': -77.41804211355065,
            'scale': 0.876,
            'heading': 139.07736301890088
        },
        {
            'lat': 38.89182437441104,
            'lon': -77.41824432294008,
            'scale': 1.069,
            'heading': 267.82739950575194
        },
        {
            'lat': 38.88816824588276,
            'lon': -77.42093208387622,
            'scale': 0.885,
            'heading': 292.1417301674338
        },
        {
            'lat': 38.89168816102791,
            'lon': -77.41822431820701,
            'scale': 0.969,
            'heading': 298.06484334883754
        },
        {
            'lat': 38.89207603789552,
            'lon': -77.41909632940273,
            'scale': 1.169,
            'heading': 39.927602862402495
        },
        {
            'lat': 38.89192574591625,
            'lon': -77.41823606874087,
            'scale': 1.177,
            'heading': 300.7657759124959
        },
        {
            'lat': 38.89012616827797,
            'lon': -77.4184522689633,
            'scale': 1.137,
            'heading': 209.70993412040784
        },
        {
            'lat': 38.88986913352671,
            'lon': -77.41768298169823,
            'scale': 0.997,
            'heading': 254.37424659549913
        },
        {
            'lat': 38.89024287369266,
            'lon': -77.41891203043622,
            'scale': 1.138,
            'heading': 187.15688940166032
        },
        {
            'lat': 38.888537582311734,
            'lon': -77.42135904487797,
            'scale': 0.974,
            'heading': 19.65538688875578
        },
        {
            'lat': 38.891381837979154,
            'lon': -77.41835298544825,
            'scale': 0.948,
            'heading': 225.54760043349563
        },
        {
            'lat': 38.88956390913927,
            'lon': -77.41822236072406,
            'scale': 0.87,
            'heading': 161.15643940347982
        },
        {
            'lat': 38.89169665010939,
            'lon': -77.41831968005968,
            'scale': 1.108,
            'heading': 132.7651287258462
        },
        {
            'lat': 38.89239444634716,
            'lon': -77.41770757766936,
            'scale': 0.875,
            'heading': 276.5175289244541
        },
        {
            'lat': 38.89080934725672,
            'lon': -77.4189472124229,
            'scale': 0.858,
            'heading': 315.03043010026676
        },
        {
            'lat': 38.891578317482946,
            'lon': -77.41834428849442,
            'scale': 0.843,
            'heading': 26.903531290508376
        },
        {
            'lat': 38.8919698698516,
            'lon': -77.41827544038966,
            'scale': 1.166,
            'heading': 53.2967587383274
        },
        {
            'lat': 38.88986432747137,
            'lon': -77.41863487366382,
            'scale': 0.808,
            'heading': 210.67500711068365
        },
        {
            'lat': 38.891542842488796,
            'lon': -77.41821255560932,
            'scale': 1.127,
            'heading': 38.684227670942526
        },
        {
            'lat': 38.89135346084671,
            'lon': -77.41826478713423,
            'scale': 0.876,
            'heading': 106.58265891167095
        },
        {
            'lat': 38.88858622301224,
            'lon': -77.4210538868438,
            'scale': 0.859,
            'heading': 121.37068288797353
        },
        {
            'lat': 38.89201001899401,
            'lon': -77.41793693549101,
            'scale': 1.067,
            'heading': 214.81258478260625
        },
        {
            'lat': 38.89020305361185,
            'lon': -77.41776169585754,
            'scale': 1.085,
            'heading': 99.13278940613789
        },
        {
            'lat': 38.8912143546662,
            'lon': -77.41881376753474,
            'scale': 1.073,
            'heading': 17.029593068278857
        },
        {
            'lat': 38.89205452457355,
            'lon': -77.41849995782668,
            'scale': 1.169,
            'heading': 319.05093105399004
        },
        {
            'lat': 38.891788252095665,
            'lon': -77.4183657907204,
            'scale': 0.825,
            'heading': 91.78582996466962
        },
        {
            'lat': 38.888336091806174,
            'lon': -77.4209882627808,
            'scale': 0.806,
            'heading': 101.64772297470846
        },
        {
            'lat': 38.890665838701175,
            'lon': -77.418762520414,
            'scale': 1.003,
            'heading': 248.19677508049367
        },
        {
            'lat': 38.8918534614328,
            'lon': -77.4182834096007,
            'scale': 1.069,
            'heading': 85.91996140328247
        },
        {
            'lat': 38.8887422483335,
            'lon': -77.42091524777916,
            'scale': 0.912,
            'heading': 6.706669330860384
        },
        {
            'lat': 38.89154243177839,
            'lon': -77.41819142528453,
            'scale': 0.825,
            'heading': 156.68479588091873
        },
        {
            'lat': 38.88817990210214,
            'lon': -77.42122120554986,
            'scale': 1.081,
            'heading': 215.88604539096096
        },
        {
            'lat': 38.89060947136535,
            'lon': -77.41836265204924,
            'scale': 0.919,
            'heading': 118.782315708673
        },
        {
            'lat': 38.89088992401524,
            'lon': -77.41866489048888,
            'scale': 0.851,
            'heading': 58.386101022555806
        },
        {
            'lat': 38.891793075922486,
            'lon': -77.41801607716236,
            'scale': 1.174,
            'heading': 180.36077601604416
        },
        {
            'lat': 38.8908405508699,
            'lon': -77.41895851771473,
            'scale': 1.14,
            'heading': 12.376350120623997
        },
        {
            'lat': 38.89175234416682,
            'lon': -77.41835463797078,
            'scale': 0.833,
            'heading': 159.35479895065237
        },
        {
            'lat': 38.892186623140994,
            'lon': -77.41836642679355,
            'scale': 0.86,
            'heading': 142.07988706250111
        },
        {
            'lat': 38.89139422471739,
            'lon': -77.41814400912631,
            'scale': 0.891,
            'heading': 87.41451959658748
        },
        {
            'lat': 38.891810873294126,
            'lon': -77.41839740863378,
            'scale': 0.882,
            'heading': 90.17265636272725
        },
        {
            'lat': 38.88837789611478,
            'lon': -77.42098319505726,
            'scale': 0.984,
            'heading': 212.82880718339607
        },
        {
            'lat': 38.89018273243277,
            'lon': -77.41853159737585,
            'scale': 1.186,
            'heading': 303.76767167752973
        },
        {
            'lat': 38.88983025534552,
            'lon': -77.41869508783542,
            'scale': 0.818,
            'heading': 275.41447481723833
        },
        {
            'lat': 38.891195857737785,
            'lon': -77.41871307120981,
            'scale': 0.832,
            'heading': 40.85450112452905
        },
        {
            'lat': 38.89178109365249,
            'lon': -77.41772060074608,
            'scale': 0.967,
            'heading': 348.13032493438993
        },
        {
            'lat': 38.89218239602143,
            'lon': -77.41802763683522,
            'scale': 1.02,
            'heading': 306.2184550337082
        },
        {
            'lat': 38.89058665969994,
            'lon': -77.41842092153256,
            'scale': 1.19,
            'heading': 14.45993345362995
        },
        {
            'lat': 38.89227026440888,
            'lon': -77.41862430890414,
            'scale': 1.127,
            'heading': 171.72125252353035
        },
        {
            'lat': 38.892072294945535,
            'lon': -77.4181167073859,
            'scale': 0.989,
            'heading': 71.97500296076706
        },
        {
            'lat': 38.890263221641305,
            'lon': -77.41870007667528,
            'scale': 1.108,
            'heading': 296.1302925434392
        },
        {
            'lat': 38.89120364545809,
            'lon': -77.41807691732193,
            'scale': 1.105,
            'heading': 115.8716291257418
        },
        {
            'lat': 38.89210704355555,
            'lon': -77.41900162705925,
            'scale': 0.836,
            'heading': 42.72322355445454
        },
        {
            'lat': 38.89049901319012,
            'lon': -77.41860594412888,
            'scale': 1.091,
            'heading': 263.1742991353973
        },
        {
            'lat': 38.89169999125283,
            'lon': -77.4185318718074,
            'scale': 1.024,
            'heading': 330.61118787319555
        },
        {
            'lat': 38.8923942200351,
            'lon': -77.41910869673221,
            'scale': 1.174,
            'heading': 27.326547980542266
        },
        {
            'lat': 38.89116728581624,
            'lon': -77.41828491972328,
            'scale': 0.99,
            'heading': 234.54639568853634
        },
        {
            'lat': 38.890685817918275,
            'lon': -77.41877166589325,
            'scale': 1.07,
            'heading': 319.45238232387936
        },
        {
            'lat': 38.890715384521634,
            'lon': -77.41817699351962,
            'scale': 1.056,
            'heading': 288.83480528125006
        },
        {
            'lat': 38.891844998719776,
            'lon': -77.4187235557997,
            'scale': 0.84,
            'heading': 202.69199009789128
        },
        {
            'lat': 38.89237393929883,
            'lon': -77.4181001919627,
            'scale': 1.019,
            'heading': 69.13351930434519
        },
        {
            'lat': 38.891907644663775,
            'lon': -77.41862787345956,
            'scale': 1.035,
            'heading': 58.79876517380347
        },
        {
            'lat': 38.8906838743131,
            'lon': -77.41882924679207,
            'scale': 1.165,
            'heading': 116.99791353739421
        },
        {
            'lat': 38.89065986160276,
            'lon': -77.41849767429662,
            'scale': 0.855,
            'heading': 345.74244504416515
        },
        {
            'lat': 38.891710268898386,
            'lon': -77.41787914056867,
            'scale': 0.835,
            'heading': 232.63723086478265
        },
        {
            'lat': 38.89129947385378,
            'lon': -77.41842102563128,
            'scale': 1.096,
            'heading': 46.73272815289885
        },
        {
            'lat': 38.88835902722593,
            'lon': -77.42093474054363,
            'scale': 1.069,
            'heading': 244.74232638284857
        },
        {
            'lat': 38.89239382089979,
            'lon': -77.41887532678076,
            'scale': 1.108,
            'heading': 345.69027039220356
        },
        {
            'lat': 38.89130631268015,
            'lon': -77.41870222856959,
            'scale': 1.193,
            'heading': 224.57583325669353
        },
        {
            'lat': 38.88952954400461,
            'lon': -77.41902787736565,
            'scale': 0.921,
            'heading': 297.53238636408514
        },
        {
            'lat': 38.89184018023807,
            'lon': -77.41870410569935,
            'scale': 1.033,
            'heading': 243.835858524653
        },
        {
            'lat': 38.891243748105865,
            'lon': -77.41816062617492,
            'scale': 0.904,
            'heading': 83.34100274931424
        },
        {
            'lat': 38.89221405769698,
            'lon': -77.41845680905102,
            'scale': 1.183,
            'heading': 128.70407932725377
        },
        {
            'lat': 38.89166871517605,
            'lon': -77.41873901344314,
            'scale': 0.996,
            'heading': 122.44730237747928
        },
        {
            'lat': 38.89138464113265,
            'lon': -77.418598827727,
            'scale': 0.957,
            'heading': 301.885556612138
        },
        {
            'lat': 38.888149264069064,
            'lon': -77.42091560052752,
            'scale': 1.055,
            'heading': 169.8457403284646
        },
        {
            'lat': 38.89071622124921,
            'lon': -77.41896075905412,
            'scale': 0.869,
            'heading': 351.31276699760366
        },
        {
            'lat': 38.889939140820765,
            'lon': -77.41839937929231,
            'scale': 1.06,
            'heading': 220.21764568757845
        },
        {
            'lat': 38.89087191346166,
            'lon': -77.41888401311023,
            'scale': 1.105,
            'heading': 202.1255035238997
        },
        {
            'lat': 38.889643754293964,
            'lon': -77.41844903907652,
            'scale': 1.029,
            'heading': 242.2134142813795
        },
        {
            'lat': 38.891849588544815,
            'lon': -77.41840354098996,
            'scale': 0.99,
            'heading': 18.00894902997819
        },
        {
            'lat': 38.8898409502481,
            'lon': -77.41827545338478,
            'scale': 1.023,
            'heading': 234.46920788811912
        },
        {
            'lat': 38.89170376467561,
            'lon': -77.41845554869619,
            'scale': 1.092,
            'heading': 136.7501868170647
        },
        {
            'lat': 38.89154898670041,
            'lon': -77.41839802281771,
            'scale': 1.128,
            'heading': 66.62741933904721
        },
        {
            'lat': 38.89148686936466,
            'lon': -77.41812347655448,
            'scale': 0.98,
            'heading': 340.945438138375
        },
        {
            'lat': 38.89109030272517,
            'lon': -77.41802100166196,
            'scale': 1.09,
            'heading': 251.76896219218867
        },
        {
            'lat': 38.890504853916056,
            'lon': -77.41871170223125,
            'scale': 0.887,
            'heading': 121.23855756209586
        },
        {
            'lat': 38.891610654919226,
            'lon': -77.41821084605877,
            'scale': 0.843,
            'heading': 276.24473684729764
        },
        {
            'lat': 38.89201211586484,
            'lon': -77.41829435713879,
            'scale': 1.066,
            'heading': 117.52831050088729
        },
        {
            'lat': 38.88970512704189,
            'lon': -77.4187398054607,
            'scale': 1.105,
            'heading': 87.7380427186063
        },
        {
            'lat': 38.891001434781366,
            'lon': -77.41867137669344,
            'scale': 0.804,
            'heading': 58.03302664106568
        },
        {
            'lat': 38.89231231407483,
            'lon': -77.41819305554108,
            'scale': 1.036,
            'heading': 130.89104802748102
        },
        {
            'lat': 38.89167299643451,
            'lon': -77.41881496855288,
            'scale': 0.964,
            'heading': 174.45389018333904
        },
        {
            'lat': 38.89223861883912,
            'lon': -77.41771939455379,
            'scale': 1.051,
            'heading': 252.3305213730384
        },
        {
            'lat': 38.89033878776591,
            'lon': -77.41828480783936,
            'scale': 1.004,
            'heading': 48.90606288590681
        },
        {
            'lat': 38.892031372753166,
            'lon': -77.41784045816773,
            'scale': 0.818,
            'heading': 59.67857193786926
        },
        {
            'lat': 38.89151326285733,
            'lon': -77.41853776722218,
            'scale': 0.968,
            'heading': 64.1281114345221
        },
        {
            'lat': 38.89214848044211,
            'lon': -77.41794113647332,
            'scale': 0.965,
            'heading': 288.2170569554687
        },
        {
            'lat': 38.89000125640074,
            'lon': -77.41817722349191,
            'scale': 1.158,
            'heading': 352.8409092663712
        },
        {
            'lat': 38.890308394673006,
            'lon': -77.41828550296493,
            'scale': 0.916,
            'heading': 45.75977545291678
        },
        {
            'lat': 38.88952327384512,
            'lon': -77.41871934311405,
            'scale': 1.018,
            'heading': 67.22248173133264
        },
        {
            'lat': 38.89198145732293,
            'lon': -77.41851749261062,
            'scale': 1.012,
            'heading': 137.65849162362576
        },
        {
            'lat': 38.88861980752972,
            'lon': -77.4212380769065,
            'scale': 0.804,
            'heading': 352.3334306697303
        },
        {
            'lat': 38.891745985050605,
            'lon': -77.41779807653255,
            'scale': 0.868,
            'heading': 33.222254585378316
        },
        {
            'lat': 38.89008414818116,
            'lon': -77.41799079983393,
            'scale': 1.011,
            'heading': 331.49286251482795
        },
        {
            'lat': 38.89157545687263,
            'lon': -77.41885929713368,
            'scale': 0.917,
            'heading': 301.0189148999724
        },
        {
            'lat': 38.8904302952626,
            'lon': -77.41811490188472,
            'scale': 1.043,
            'heading': 84.96308675463317
        },
        {
            'lat': 38.890992450852835,
            'lon': -77.41838185924867,
            'scale': 1.0,
            'heading': 277.478141608864
        },
        {
            'lat': 38.89145425052949,
            'lon': -77.41811680344962,
            'scale': 1.14,
            'heading': 354.0136558617208
        },
        {
            'lat': 38.88997165871457,
            'lon': -77.41824162615707,
            'scale': 1.041,
            'heading': 259.1540871540874
        },
        {
            'lat': 38.891592209626296,
            'lon': -77.41812318523104,
            'scale': 1.043,
            'heading': 321.02043977341623
        },
        {
            'lat': 38.88870558771208,
            'lon': -77.4208865092033,
            'scale': 0.91,
            'heading': 55.89221672362086
        },
        {
            'lat': 38.891853337214435,
            'lon': -77.41791612416357,
            'scale': 1.06,
            'heading': 190.26777905171218
        },
        {
            'lat': 38.889578025001576,
            'lon': -77.41888174918836,
            'scale': 0.805,
            'heading': 266.23854651257216
        },
        {
            'lat': 38.88829095941179,
            'lon': -77.42099552166047,
            'scale': 1.113,
            'heading': 324.8542051452675
        },
        {
            'lat': 38.89043907068838,
            'lon': -77.41881102959408,
            'scale': 0.941,
            'heading': 94.41864235765831
        },
        {
            'lat': 38.89223924266914,
            'lon': -77.417961952613,
            'scale': 1.096,
            'heading': 21.45309961401525
        },
        {
            'lat': 38.89034976156595,
            'lon': -77.4185346563827,
            'scale': 1.005,
            'heading': 224.13928291419592
        },
        {
            'lat': 38.8883117394391,
            'lon': -77.42094308112803,
            'scale': 1.072,
            'heading': 169.1051162531015
        },
        {
            'lat': 38.891528925305984,
            'lon': -77.418424740736,
            'scale': 0.937,
            'heading': 29.756924150734193
        },
        {
            'lat': 38.89120739929559,
            'lon': -77.41840839514578,
            'scale': 0.946,
            'heading': 293.5452629604899
        },
        {
            'lat': 38.89141232819974,
            'lon': -77.41824847256349,
            'scale': 0.899,
            'heading': 307.3750740094758
        },
        {
            'lat': 38.89034766054956,
            'lon': -77.41887430870294,
            'scale': 0.978,
            'heading': 228.64733346630848
        },
        {
            'lat': 38.89220873387876,
            'lon': -77.41841526907297,
            'scale': 1.077,
            'heading': 218.27831989864052
        },
        {
            'lat': 38.890624315269086,
            'lon': -77.41879075731148,
            'scale': 1.138,
            'heading': 267.49078444644357
        },
        {
            'lat': 38.889642333221374,
            'lon': -77.41867499909472,
            'scale': 1.118,
            'heading': 156.18838703373171
        },
        {
            'lat': 38.89203511294181,
            'lon': -77.41812985599431,
            'scale': 0.984,
            'heading': 118.77319965915245
        },
        {
            'lat': 38.89008647590697,
            'lon': -77.41837584359654,
            'scale': 0.913,
            'heading': 212.2411772421463
        },
        {
            'lat': 38.892271718859426,
            'lon': -77.41808707749507,
            'scale': 0.938,
            'heading': 302.14345899584026
        },
        {
            'lat': 38.890554250410055,
            'lon': -77.4181611923401,
            'scale': 1.132,
            'heading': 59.181003943211216
        },
        {
            'lat': 38.892306960581024,
            'lon': -77.41855994238018,
            'scale': 0.835,
            'heading': 71.99874227442726
        },
        {
            'lat': 38.892239366396296,
            'lon': -77.41778842869736,
            'scale': 0.84,
            'heading': 236.74980993030053
        },
        {
            'lat': 38.89138583571524,
            'lon': -77.41873499155417,
            'scale': 1.111,
            'heading': 59.40318955292187
        },
        {
            'lat': 38.890089700241184,
            'lon': -77.4177615049288,
            'scale': 1.169,
            'heading': 120.33938865696285
        },
        {
            'lat': 38.89021062969256,
            'lon': -77.41843072130683,
            'scale': 0.976,
            'heading': 153.25721924917312
        },
        {
            'lat': 38.89100514004474,
            'lon': -77.41813077598003,
            'scale': 1.096,
            'heading': 330.129302988142
        },
        {
            'lat': 38.8882156680254,
            'lon': -77.42123897887822,
            'scale': 1.167,
            'heading': 81.41796759007327
        },
        {
            'lat': 38.890130763650646,
            'lon': -77.41844301915557,
            'scale': 0.831,
            'heading': 351.93981818924055
        },
        {
            'lat': 38.8917299533114,
            'lon': -77.4179913211511,
            'scale': 0.821,
            'heading': 153.2841887718386
        },
        {
            'lat': 38.89218403998355,
            'lon': -77.41804257738002,
            'scale': 0.984,
            'heading': 189.11861794019183
        },
        {
            'lat': 38.889914000004296,
            'lon': -77.41775694084062,
            'scale': 0.899,
            'heading': 268.35769744200655
        },
        {
            'lat': 38.8918085384456,
            'lon': -77.41782460876405,
            'scale': 1.166,
            'heading': 188.01106075449425
        },
        {
            'lat': 38.89117728446284,
            'lon': -77.41889566715476,
            'scale': 1.001,
            'heading': 137.38529527075195
        },
        {
            'lat': 38.890322969422904,
            'lon': -77.4183879629412,
            'scale': 1.191,
            'heading': 296.4959882045907
        },
        {
            'lat': 38.89236037506036,
            'lon': -77.41787940904202,
            'scale': 0.817,
            'heading': 339.8874537493459
        },
        {
            'lat': 38.891698498200995,
            'lon': -77.41890323083126,
            'scale': 1.085,
            'heading': 159.0110917857965
        },
        {
            'lat': 38.89199460414508,
            'lon': -77.4188816253955,
            'scale': 0.863,
            'heading': 355.2168166174602
        },
        {
            'lat': 38.889937089939856,
            'lon': -77.41784398465414,
            'scale': 0.806,
            'heading': 6.594174450078896
        },
        {
            'lat': 38.892389945294326,
            'lon': -77.41879328445253,
            'scale': 1.072,
            'heading': 307.0922765127258
        },
        {
            'lat': 38.891524872540394,
            'lon': -77.41862329591886,
            'scale': 0.833,
            'heading': 59.73354272337116
        },
        {
            'lat': 38.89131011772741,
            'lon': -77.4186607912581,
            'scale': 1.183,
            'heading': 111.1513538416367
        },
        {
            'lat': 38.888397174132336,
            'lon': -77.42103658643332,
            'scale': 0.876,
            'heading': 266.1546903390122
        },
        {
            'lat': 38.89016022379949,
            'lon': -77.41861556901056,
            'scale': 1.182,
            'heading': 48.05854711264204
        },
        {
            'lat': 38.8904275101762,
            'lon': -77.41832535454664,
            'scale': 0.977,
            'heading': 52.98638921251518
        },
        {
            'lat': 38.89115694068444,
            'lon': -77.41826836331572,
            'scale': 0.909,
            'heading': 125.03608401802664
        },
        {
            'lat': 38.89138245459777,
            'lon': -77.41873345080793,
            'scale': 1.174,
            'heading': 59.31855608005132
        },
        {
            'lat': 38.89037088241286,
            'lon': -77.41871050965096,
            'scale': 0.827,
            'heading': 280.68585227942845
        },
        {
            'lat': 38.888409189896194,
            'lon': -77.42102317370866,
            'scale': 0.816,
            'heading': 208.45913471840095
        },
        {
            'lat': 38.89083126883837,
            'lon': -77.41892502003248,
            'scale': 1.017,
            'heading': 185.03380782802896
        },
        {
            'lat': 38.89210197779999,
            'lon': -77.41848305560966,
            'scale': 0.858,
            'heading': 304.7783170100025
        },
        {
            'lat': 38.889593184752826,
            'lon': -77.41857940949797,
            'scale': 0.857,
            'heading': 117.3896920451683
        },
        {
            'lat': 38.8899650934685,
            'lon': -77.41839522683797,
            'scale': 1.109,
            'heading': 250.67427177980468
        },
        {
            'lat': 38.88987140613266,
            'lon': -77.4182959080731,
            'scale': 0.977,
            'heading': 291.1714264991985
        },
        {
            'lat': 38.890052293439496,
            'lon': -77.41767835355597,
            'scale': 1.093,
            'heading': 216.09000010149654
        },
        {
            'lat': 38.89008369123228,
            'lon': -77.41864445098633,
            'scale': 0.823,
            'heading': 31.68149465748449
        },
        {
            'lat': 38.89022617577222,
            'lon': -77.41816538876775,
            'scale': 0.962,
            'heading': 287.98761911808657
        },
        {
            'lat': 38.89163086885095,
            'lon': -77.41801498283903,
            'scale': 0.815,
            'heading': 8.699126136088529
        },
        {
            'lat': 38.89206062990086,
            'lon': -77.41882143404659,
            'scale': 1.046,
            'heading': 229.87184866245076
        },
        {
            'lat': 38.892221264938215,
            'lon': -77.41836218034723,
            'scale': 1.051,
            'heading': 250.9397864742596
        },
        {
            'lat': 38.89154473089545,
            'lon': -77.41859247253917,
            'scale': 1.139,
            'heading': 324.9791170229898
        },
        {
            'lat': 38.890964613614806,
            'lon': -77.41859498100064,
            'scale': 1.088,
            'heading': 149.02699144339311
        },
        {
            'lat': 38.888591284045205,
            'lon': -77.42114123067039,
            'scale': 1.073,
            'heading': 343.79225415310344
        },
        {
            'lat': 38.89160157702822,
            'lon': -77.41878908070042,
            'scale': 0.804,
            'heading': 275.33850653117435
        },
        {
            'lat': 38.89082558312023,
            'lon': -77.41882686291476,
            'scale': 1.141,
            'heading': 137.07296947844478
        },
        {
            'lat': 38.89132704107162,
            'lon': -77.41871864159191,
            'scale': 0.844,
            'heading': 207.92100648172294
        },
        {
            'lat': 38.89168852270232,
            'lon': -77.41877629077058,
            'scale': 0.967,
            'heading': 255.47097008666606
        },
        {
            'lat': 38.88995898175104,
            'lon': -77.41838998497491,
            'scale': 1.153,
            'heading': 238.5402105377556
        },
        {
            'lat': 38.890833363265585,
            'lon': -77.41863205522118,
            'scale': 0.876,
            'heading': 297.4370299553557
        },
        {
            'lat': 38.8923672269741,
            'lon': -77.41889994200392,
            'scale': 0.94,
            'heading': 100.9941150025192
        },
        {
            'lat': 38.89125519098624,
            'lon': -77.41836864094694,
            'scale': 0.801,
            'heading': 214.91455076093493
        },
        {
            'lat': 38.89065435033859,
            'lon': -77.41881669601547,
            'scale': 1.082,
            'heading': 190.64801904582714
        },
        {
            'lat': 38.89206391516021,
            'lon': -77.41773417029223,
            'scale': 1.085,
            'heading': 114.22478094047247
        },
        {
            'lat': 38.89196572663889,
            'lon': -77.4183408034135,
            'scale': 1.075,
            'heading': 102.18985242657004
        },
        {
            'lat': 38.88981452593319,
            'lon': -77.41813598322787,
            'scale': 0.988,
            'heading': 195.6992626640563
        },
        {
            'lat': 38.891385863991765,
            'lon': -77.41850438963628,
            'scale': 1.008,
            'heading': 276.42752345919615
        },
        {
            'lat': 38.88956564770805,
            'lon': -77.419181082108,
            'scale': 1.008,
            'heading': 91.28480673570778
        },
        {
            'lat': 38.88835799853607,
            'lon': -77.42130306969234,
            'scale': 0.895,
            'heading': 159.34544811496195
        },
        {
            'lat': 38.8886047578712,
            'lon': -77.42122859312713,
            'scale': 1.196,
            'heading': 309.7771978260246
        },
        {
            'lat': 38.89018355657299,
            'lon': -77.41871770272925,
            'scale': 1.176,
            'heading': 199.51329663936494
        },
        {
            'lat': 38.89212579255078,
            'lon': -77.41916529648887,
            'scale': 1.033,
            'heading': 54.27914952919602
        },
        {
            'lat': 38.88832950743433,
            'lon': -77.42083676187322,
            'scale': 0.876,
            'heading': 288.5187593348946
        },
        {
            'lat': 38.89007773365318,
            'lon': -77.4181796501541,
            'scale': 0.823,
            'heading': 286.52669121965204
        },
        {
            'lat': 38.888520076806216,
            'lon': -77.42136139012406,
            'scale': 0.83,
            'heading': 162.98282360138694
        },
        {
            'lat': 38.89206720236828,
            'lon': -77.41822108634726,
            'scale': 1.117,
            'heading': 326.04069468792187
        },
        {
            'lat': 38.89008126181945,
            'lon': -77.41827575895915,
            'scale': 1.017,
            'heading': 136.34001504337633
        },
        {
            'lat': 38.89035928226713,
            'lon': -77.41874000902428,
            'scale': 1.041,
            'heading': 346.96804273371004
        },
        {
            'lat': 38.89201426532474,
            'lon': -77.41789751867111,
            'scale': 0.801,
            'heading': 204.63305864080607
        },
        {
            'lat': 38.889866934142084,
            'lon': -77.4186090057584,
            'scale': 0.858,
            'heading': 13.123222768939215
        },
        {
            'lat': 38.88960523979612,
            'lon': -77.41821256342402,
            'scale': 0.81,
            'heading': 143.27190812244498
        },
        {
            'lat': 38.89009185426,
            'lon': -77.41828330567715,
            'scale': 1.05,
            'heading': 206.60562579038768
        },
        {
            'lat': 38.89142818813492,
            'lon': -77.41829317757275,
            'scale': 1.148,
            'heading': 114.23539522588231
        },
        {
            'lat': 38.89148800521257,
            'lon': -77.41852775808019,
            'scale': 0.974,
            'heading': 298.01880075917126
        },
        {
            'lat': 38.89234023232807,
            'lon': -77.4182381004415,
            'scale': 1.106,
            'heading': 195.86103367613316
        },
        {
            'lat': 38.89118351940702,
            'lon': -77.41857137021482,
            'scale': 0.964,
            'heading': 69.65286074412924
        },
        {
            'lat': 38.890320717496586,
            'lon': -77.41874029504288,
            'scale': 1.075,
            'heading': 268.12365547169605
        },
        {
            'lat': 38.8920011835193,
            'lon': -77.41773631017841,
            'scale': 1.112,
            'heading': 332.1372233325937
        },
        {
            'lat': 38.88948745645797,
            'lon': -77.41931167345274,
            'scale': 0.933,
            'heading': 190.48127663105842
        },
        {
            'lat': 38.89065690085288,
            'lon': -77.41821694521,
            'scale': 0.831,
            'heading': 82.33558703820572
        },
        {
            'lat': 38.89095009105048,
            'lon': -77.41821970863418,
            'scale': 1.136,
            'heading': 257.12792261038607
        },
        {
            'lat': 38.89197937892496,
            'lon': -77.41856548722438,
            'scale': 1.022,
            'heading': 105.7259126592922
        },
        {
            'lat': 38.891416903186965,
            'lon': -77.418506426094,
            'scale': 1.027,
            'heading': 327.0995166361809
        },
        {
            'lat': 38.89102858263081,
            'lon': -77.41851989591804,
            'scale': 0.977,
            'heading': 115.8468035968034
        },
        {
            'lat': 38.89172056335391,
            'lon': -77.41883321270609,
            'scale': 1.108,
            'heading': 39.14248677069654
        },
        {
            'lat': 38.89155066929694,
            'lon': -77.41849220733461,
            'scale': 0.938,
            'heading': 127.10058535095155
        },
        {
            'lat': 38.889863352974956,
            'lon': -77.41862440921291,
            'scale': 0.805,
            'heading': 301.06564605754323
        },
        {
            'lat': 38.890980478006206,
            'lon': -77.41843113539898,
            'scale': 1.091,
            'heading': 49.436254460436444
        },
        {
            'lat': 38.89108832259367,
            'lon': -77.41851642007478,
            'scale': 0.828,
            'heading': 91.84920992127132
        },
        {
            'lat': 38.89160663095795,
            'lon': -77.41795455206427,
            'scale': 0.931,
            'heading': 129.07821334485308
        },
        {
            'lat': 38.89157527414745,
            'lon': -77.41841791418052,
            'scale': 0.901,
            'heading': 55.2890332890485
        },
        {
            'lat': 38.89073709199549,
            'lon': -77.4183283080007,
            'scale': 0.805,
            'heading': 249.66685413989188
        },
        {
            'lat': 38.89160677833511,
            'lon': -77.41889273350915,
            'scale': 1.053,
            'heading': 213.71610173333045
        },
        {
            'lat': 38.89127602677599,
            'lon': -77.41881800628383,
            'scale': 0.857,
            'heading': 156.89856078768034
        },
        {
            'lat': 38.89120482786496,
            'lon': -77.41805457358171,
            'scale': 0.987,
            'heading': 310.25112133782966
        },
        {
            'lat': 38.88996570331052,
            'lon': -77.4176836254518,
            'scale': 1.078,
            'heading': 61.40134268618912
        },
        {
            'lat': 38.89024517809843,
            'lon': -77.41874868365238,
            'scale': 1.183,
            'heading': 205.3953220463452
        },
        {
            'lat': 38.891505798793226,
            'lon': -77.41853270382808,
            'scale': 0.947,
            'heading': 281.20434147011935
        },
        {
            'lat': 38.88815479214947,
            'lon': -77.42152080589153,
            'scale': 0.991,
            'heading': 92.28424851483881
        },
        {
            'lat': 38.89196204924319,
            'lon': -77.41816088167961,
            'scale': 0.954,
            'heading': 202.3854469449453
        },
        {
            'lat': 38.89192692811404,
            'lon': -77.41860196034676,
            'scale': 1.166,
            'heading': 82.53574743951698
        },
        {
            'lat': 38.891224808639485,
            'lon': -77.41818314345556,
            'scale': 0.935,
            'heading': 252.55670132273045
        },
        {
            'lat': 38.89211430701057,
            'lon': -77.41844850949899,
            'scale': 1.175,
            'heading': 44.97815466377932
        },
        {
            'lat': 38.892238326171174,
            'lon': -77.41850816435145,
            'scale': 0.97,
            'heading': 113.94500445408838
        },
        {
            'lat': 38.889993156617486,
            'lon': -77.41810087869943,
            'scale': 1.073,
            'heading': 49.73417200416487
        },
        {
            'lat': 38.89221779210145,
            'lon': -77.4182568279865,
            'scale': 1.194,
            'heading': 213.05237549808876
        },
        {
            'lat': 38.89224013055589,
            'lon': -77.41780517705705,
            'scale': 1.195,
            'heading': 94.55644973980083
        },
        {
            'lat': 38.89097745220599,
            'lon': -77.41846063793234,
            'scale': 1.197,
            'heading': 92.45681243587391
        },
        {
            'lat': 38.892137105434315,
            'lon': -77.41917024171993,
            'scale': 1.144,
            'heading': 72.92261103755382
        },
        {
            'lat': 38.89017144430156,
            'lon': -77.41798492738258,
            'scale': 0.857,
            'heading': 260.6157881716688
        },
        {
            'lat': 38.89221098893302,
            'lon': -77.41856197139418,
            'scale': 0.974,
            'heading': 10.242326037333441
        },
        {
            'lat': 38.89220019050678,
            'lon': -77.41851255062714,
            'scale': 0.982,
            'heading': 147.26834307394708
        },
        {
            'lat': 38.8916342833457,
            'lon': -77.41844432404272,
            'scale': 0.877,
            'heading': 49.30354440427399
        },
        {
            'lat': 38.891372221702916,
            'lon': -77.41873476006165,
            'scale': 1.163,
            'heading': 178.2511111472764
        },
        {
            'lat': 38.8919943242199,
            'lon': -77.41780555301692,
            'scale': 1.194,
            'heading': 5.205969818730649
        },
        {
            'lat': 38.89016566631557,
            'lon': -77.4179053523837,
            'scale': 1.186,
            'heading': 354.74768961308797
        },
        {
            'lat': 38.89177506407173,
            'lon': -77.41870288134098,
            'scale': 1.094,
            'heading': 313.51204486560346
        },
        {
            'lat': 38.891961682295154,
            'lon': -77.41825262435711,
            'scale': 1.194,
            'heading': 64.62675055614778
        },
        {
            'lat': 38.88960769327435,
            'lon': -77.4191771797977,
            'scale': 1.08,
            'heading': 252.65995964632398
        },
        {
            'lat': 38.89140456738945,
            'lon': -77.41833081002248,
            'scale': 1.099,
            'heading': 73.49017895297375
        },
        {
            'lat': 38.891424888449286,
            'lon': -77.41882279757195,
            'scale': 0.992,
            'heading': 72.44105930209388
        },
        {
            'lat': 38.89052999306208,
            'lon': -77.41844082386231,
            'scale': 0.902,
            'heading': 12.132992076138581
        },
        {
            'lat': 38.89099411042582,
            'lon': -77.41823703922279,
            'scale': 1.187,
            'heading': 315.015174605109
        },
        {
            'lat': 38.891419669014304,
            'lon': -77.41889411664431,
            'scale': 1.005,
            'heading': 53.91533485518807
        },
        {
            'lat': 38.89186256588227,
            'lon': -77.41891918683564,
            'scale': 1.058,
            'heading': 335.13434785354985
        },
        {
            'lat': 38.88821144996857,
            'lon': -77.42147233340224,
            'scale': 1.023,
            'heading': 197.21923045716053
        },
        {
            'lat': 38.890852975246105,
            'lon': -77.41799885744382,
            'scale': 0.94,
            'heading': 331.9699750666729
        },
        {
            'lat': 38.89204780225552,
            'lon': -77.4187879300754,
            'scale': 0.925,
            'heading': 65.9831572256245
        },
        {
            'lat': 38.88809579578598,
            'lon': -77.42148645845377,
            'scale': 0.871,
            'heading': 316.168491028761
        },
        {
            'lat': 38.891884478676566,
            'lon': -77.41886604326922,
            'scale': 1.089,
            'heading': 265.33241831801377
        },
        {
            'lat': 38.89054625541071,
            'lon': -77.41862741630528,
            'scale': 1.084,
            'heading': 266.0347717676305
        },
        {
            'lat': 38.890041796999334,
            'lon': -77.41790604944488,
            'scale': 1.151,
            'heading': 164.1977610297651
        },
        {
            'lat': 38.890530621143924,
            'lon': -77.41830422992659,
            'scale': 1.029,
            'heading': 116.70708602863616
        },
        {
            'lat': 38.88815547356192,
            'lon': -77.42115834307634,
            'scale': 1.036,
            'heading': 121.1377750130271
        },
        {
            'lat': 38.892121192479266,
            'lon': -77.41879020538168,
            'scale': 0.884,
            'heading': 201.29440280734113
        },
        {
            'lat': 38.88947938557818,
            'lon': -77.41923990890186,
            'scale': 0.832,
            'heading': 189.50917024315987
        },
        {
            'lat': 38.89022191269656,
            'lon': -77.41852500702167,
            'scale': 1.165,
            'heading': 262.42623551129265
        },
        {
            'lat': 38.891713512145,
            'lon': -77.41790386242444,
            'scale': 1.115,
            'heading': 217.33605784651337
        },
        {
            'lat': 38.89229934976884,
            'lon': -77.41830264344091,
            'scale': 1.169,
            'heading': 235.32196547191518
        },
        {
            'lat': 38.89009198245616,
            'lon': -77.41785265056428,
            'scale': 0.84,
            'heading': 71.88074726076734
        },
        {
            'lat': 38.8905081661483,
            'lon': -77.4184425565263,
            'scale': 0.935,
            'heading': 271.63439529067097
        },
        {
            'lat': 38.89200832063852,
            'lon': -77.41779617012922,
            'scale': 1.042,
            'heading': 138.47599484741292
        },
        {
            'lat': 38.89227800956821,
            'lon': -77.41826927815269,
            'scale': 1.133,
            'heading': 310.3717280857158
        },
        {
            'lat': 38.89051009237186,
            'lon': -77.41843003121458,
            'scale': 1.031,
            'heading': 231.1731090097329
        },
        {
            'lat': 38.888170990435164,
            'lon': -77.42112280270977,
            'scale': 0.95,
            'heading': 7.46209738906134
        },
        {
            'lat': 38.89060021298215,
            'lon': -77.4189598909051,
            'scale': 0.82,
            'heading': 168.66723179276664
        },
        {
            'lat': 38.889566144877314,
            'lon': -77.41778276095076,
            'scale': 1.034,
            'heading': 241.9326796952931
        },
        {
            'lat': 38.89067282383515,
            'lon': -77.41817731288897,
            'scale': 1.016,
            'heading': 262.05581808772973
        },
        {
            'lat': 38.889488192055346,
            'lon': -77.41900901529522,
            'scale': 1.028,
            'heading': 347.4769871819771
        },
        {
            'lat': 38.88822800064677,
            'lon': -77.42118270359991,
            'scale': 0.952,
            'heading': 107.22777917209055
        },
        {
            'lat': 38.892073739799955,
            'lon': -77.4188318063778,
            'scale': 0.83,
            'heading': 40.64308999311747
        },
        {
            'lat': 38.89190813168936,
            'lon': -77.41816986525835,
            'scale': 1.043,
            'heading': 27.65111177550674
        },
        {
            'lat': 38.89006492365475,
            'lon': -77.41789932950151,
            'scale': 1.04,
            'heading': 136.45912088547263
        },
        {
            'lat': 38.888312253941265,
            'lon': -77.42135124548558,
            'scale': 0.879,
            'heading': 120.10946945598145
        },
        {
            'lat': 38.8921963614372,
            'lon': -77.41779963770438,
            'scale': 1.15,
            'heading': 180.1188749139256
        },
        {
            'lat': 38.889639800585854,
            'lon': -77.418813846869,
            'scale': 1.11,
            'heading': 80.7714812851501
        },
        {
            'lat': 38.892032080286924,
            'lon': -77.41833012941555,
            'scale': 0.888,
            'heading': 5.734903015453927
        },
        {
            'lat': 38.88961621046256,
            'lon': -77.41867049929395,
            'scale': 1.131,
            'heading': 334.92166278892574
        },
        {
            'lat': 38.892294638455155,
            'lon': -77.41861879567386,
            'scale': 1.16,
            'heading': 213.3458542527942
        },
        {
            'lat': 38.89059608201824,
            'lon': -77.418270087524,
            'scale': 1.178,
            'heading': 158.0274618196511
        },
        {
            'lat': 38.88996024229487,
            'lon': -77.4181062619846,
            'scale': 0.881,
            'heading': 89.40917615258348
        },
        {
            'lat': 38.89014576778262,
            'lon': -77.41883353418567,
            'scale': 1.117,
            'heading': 246.58141656309496
        },
        {
            'lat': 38.89116874115826,
            'lon': -77.4187577816438,
            'scale': 1.028,
            'heading': 295.56797767650016
        },
        {
            'lat': 38.89181732338871,
            'lon': -77.41868437037071,
            'scale': 1.024,
            'heading': 355.42012936975283
        },
        {
            'lat': 38.89124797172096,
            'lon': -77.41868036022464,
            'scale': 1.039,
            'heading': 61.909065580322554
        },
        {
            'lat': 38.89227675919359,
            'lon': -77.419109729866,
            'scale': 0.917,
            'heading': 209.509524057638
        },
        {
            'lat': 38.89215615739084,
            'lon': -77.41884462034213,
            'scale': 0.939,
            'heading': 200.57335504453573
        },
        {
            'lat': 38.891130169316604,
            'lon': -77.41825231114407,
            'scale': 0.911,
            'heading': 207.05865129205029
        },
        {
            'lat': 38.89080828979558,
            'lon': -77.41805466984773,
            'scale': 1.128,
            'heading': 154.36608727849247
        },
        {
            'lat': 38.889565332934154,
            'lon': -77.41875571328987,
            'scale': 1.155,
            'heading': 283.09274932190505
        },
        {
            'lat': 38.89108149761351,
            'lon': -77.41819143673193,
            'scale': 0.806,
            'heading': 183.98839361556062
        },
        {
            'lat': 38.89198463636512,
            'lon': -77.41872447337398,
            'scale': 0.843,
            'heading': 195.9620294238833
        },
        {
            'lat': 38.89191203736994,
            'lon': -77.41876569658115,
            'scale': 1.069,
            'heading': 7.656270943368537
        },
        {
            'lat': 38.891958108062965,
            'lon': -77.41768297155694,
            'scale': 0.874,
            'heading': 358.7481445541382
        },
        {
            'lat': 38.89090409843388,
            'lon': -77.41851800269856,
            'scale': 1.03,
            'heading': 298.5437884099376
        },
        {
            'lat': 38.89030482193139,
            'lon': -77.41869482537027,
            'scale': 0.997,
            'heading': 45.39272802660761
        },
        {
            'lat': 38.890251581582106,
            'lon': -77.41854776864609,
            'scale': 0.903,
            'heading': 201.06430948019465
        },
        {
            'lat': 38.889858026925964,
            'lon': -77.41820380644374,
            'scale': 1.048,
            'heading': 138.07436781450073
        },
        {
            'lat': 38.89238178666052,
            'lon': -77.41811763672179,
            'scale': 1.045,
            'heading': 82.52705957889502
        },
        {
            'lat': 38.89228612023154,
            'lon': -77.41809732490638,
            'scale': 0.983,
            'heading': 244.8343316107463
        },
        {
            'lat': 38.89065539974366,
            'lon': -77.4184521143078,
            'scale': 0.879,
            'heading': 13.172007074622929
        },
        {
            'lat': 38.89216617762965,
            'lon': -77.41805858883654,
            'scale': 0.984,
            'heading': 5.37429840486789
        },
        {
            'lat': 38.89173628574795,
            'lon': -77.41822096686346,
            'scale': 1.024,
            'heading': 130.7297621815043
        },
        {
            'lat': 38.8884330752281,
            'lon': -77.42131430451902,
            'scale': 1.131,
            'heading': 296.847232928392
        },
        {
            'lat': 38.89219191402226,
            'lon': -77.4177208048376,
            'scale': 0.95,
            'heading': 2.775130997953199
        },
        {
            'lat': 38.88987133099511,
            'lon': -77.41820059038223,
            'scale': 0.82,
            'heading': 294.6906511053392
        },
        {
            'lat': 38.890164503753155,
            'lon': -77.41820906186958,
            'scale': 1.169,
            'heading': 302.88180185529745
        },
        {
            'lat': 38.8923217321763,
            'lon': -77.41911311247166,
            'scale': 0.992,
            'heading': 227.23910294210415
        },
        {
            'lat': 38.89046304659788,
            'lon': -77.41837438117639,
            'scale': 1.135,
            'heading': 210.75941451863605
        },
        {
            'lat': 38.89190644941119,
            'lon': -77.41867869959077,
            'scale': 1.125,
            'heading': 184.6739797287481
        },
        {
            'lat': 38.891852429191005,
            'lon': -77.41840407668901,
            'scale': 0.896,
            'heading': 1.675949247827604
        },
        {
            'lat': 38.891955264697756,
            'lon': -77.41769964983368,
            'scale': 1.066,
            'heading': 341.8085929930326
        },
        {
            'lat': 38.890862892114804,
            'lon': -77.41835815123031,
            'scale': 0.967,
            'heading': 118.02087283645578
        },
        {
            'lat': 38.88836194665415,
            'lon': -77.4209850373194,
            'scale': 1.014,
            'heading': 188.90484255317517
        },
        {
            'lat': 38.88994421693764,
            'lon': -77.41776977900146,
            'scale': 1.144,
            'heading': 188.10358922213925
        },
        {
            'lat': 38.89207123538658,
            'lon': -77.41864877566047,
            'scale': 1.016,
            'heading': 134.86926712936312
        },
        {
            'lat': 38.89103267070572,
            'lon': -77.41807980961902,
            'scale': 1.185,
            'heading': 182.14078693818385
        },
        {
            'lat': 38.89199572212583,
            'lon': -77.4181524560993,
            'scale': 0.929,
            'heading': 72.04150064954459
        },
        {
            'lat': 38.890467845358586,
            'lon': -77.41809777054631,
            'scale': 1.034,
            'heading': 118.09392821998647
        },
        {
            'lat': 38.89091811556498,
            'lon': -77.41857728828971,
            'scale': 1.169,
            'heading': 279.2540954862086
        },
        {
            'lat': 38.890477649134446,
            'lon': -77.41875320806562,
            'scale': 1.119,
            'heading': 187.5001288613477
        },
        {
            'lat': 38.89148221032342,
            'lon': -77.41881376650191,
            'scale': 0.876,
            'heading': 131.44751093188307
        },
        {
            'lat': 38.89010784532463,
            'lon': -77.41880427313262,
            'scale': 0.931,
            'heading': 198.07744579835062
        },
        {
            'lat': 38.89042724931832,
            'lon': -77.41862100601718,
            'scale': 1.072,
            'heading': 142.28482844057794
        },
        {
            'lat': 38.892053055468224,
            'lon': -77.4183059912913,
            'scale': 1.103,
            'heading': 237.2954696520771
        },
        {
            'lat': 38.89141934856447,
            'lon': -77.41887609148993,
            'scale': 1.096,
            'heading': 163.51578480240218
        },
        {
            'lat': 38.888515476630346,
            'lon': -77.42129337990755,
            'scale': 1.19,
            'heading': 282.2984485490872
        },
        {
            'lat': 38.891492491154175,
            'lon': -77.41895261467594,
            'scale': 0.94,
            'heading': 155.5973485797849
        },
        {
            'lat': 38.8895833338305,
            'lon': -77.41919403806935,
            'scale': 1.164,
            'heading': 117.6199565852202
        },
        {
            'lat': 38.89218281351861,
            'lon': -77.41787454812486,
            'scale': 1.161,
            'heading': 45.22822345015176
        },
        {
            'lat': 38.8885529658545,
            'lon': -77.42127016593633,
            'scale': 1.17,
            'heading': 221.27677082369019
        },
        {
            'lat': 38.890123402933256,
            'lon': -77.41847075573587,
            'scale': 0.961,
            'heading': 0.1081823878343835
        },
        {
            'lat': 38.890488178295335,
            'lon': -77.41843542867892,
            'scale': 1.091,
            'heading': 22.82197734305719
        },
        {
            'lat': 38.89238754330679,
            'lon': -77.41820623945479,
            'scale': 1.117,
            'heading': 83.17984851349907
        },
        {
            'lat': 38.88984920882581,
            'lon': -77.41814952151823,
            'scale': 1.138,
            'heading': 66.25505670708726
        },
        {
            'lat': 38.89068765217681,
            'lon': -77.41876189011032,
            'scale': 1.039,
            'heading': 294.8035309869387
        },
        {
            'lat': 38.888175489673515,
            'lon': -77.42099935971686,
            'scale': 1.157,
            'heading': 285.84154457925
        },
        {
            'lat': 38.8895073982813,
            'lon': -77.41876634304658,
            'scale': 0.948,
            'heading': 357.9014117607322
        },
        {
            'lat': 38.89227638957399,
            'lon': -77.41873293120761,
            'scale': 0.813,
            'heading': 227.5606121773339
        },
        {
            'lat': 38.89069161291625,
            'lon': -77.41826540160454,
            'scale': 0.893,
            'heading': 180.1088303317059
        },
        {
            'lat': 38.88862771675333,
            'lon': -77.42102840313524,
            'scale': 0.989,
            'heading': 48.40219152904905
        },
        {
            'lat': 38.891437022658955,
            'lon': -77.41875021768948,
            'scale': 1.076,
            'heading': 300.6874937943737
        },
        {
            'lat': 38.89142689217755,
            'lon': -77.41887001787302,
            'scale': 0.986,
            'heading': 38.07334682441157
        },
        {
            'lat': 38.89125575935172,
            'lon': -77.4189319876799,
            'scale': 1.071,
            'heading': 344.16141548298407
        },
        {
            'lat': 38.890074621220606,
            'lon': -77.41801335541885,
            'scale': 1.022,
            'heading': 340.43700347613577
        },
        {
            'lat': 38.89226523567603,
            'lon': -77.41891194282154,
            'scale': 1.05,
            'heading': 141.7626281441344
        },
        {
            'lat': 38.89179076495051,
            'lon': -77.41833757559144,
            'scale': 0.817,
            'heading': 71.48725579864477
        },
        {
            'lat': 38.89080169738896,
            'lon': -77.41862464253445,
            'scale': 1.065,
            'heading': 340.4317878281372
        },
        {
            'lat': 38.88842106889847,
            'lon': -77.42140401222551,
            'scale': 0.946,
            'heading': 345.9181978361706
        },
        {
            'lat': 38.88812150272616,
            'lon': -77.42148514824173,
            'scale': 0.807,
            'heading': 174.73168891914003
        },
        {
            'lat': 38.89212602864719,
            'lon': -77.41831823543882,
            'scale': 1.154,
            'heading': 226.23007571508893
        },
        {
            'lat': 38.88987147069283,
            'lon': -77.41854914190239,
            'scale': 0.857,
            'heading': 251.22101701132104
        },
        {
            'lat': 38.89052173497484,
            'lon': -77.41871324139336,
            'scale': 0.821,
            'heading': 174.3273540306695
        },
        {
            'lat': 38.89123763383176,
            'lon': -77.41816765665442,
            'scale': 1.07,
            'heading': 97.16537208458787
        },
        {
            'lat': 38.89063208510437,
            'lon': -77.41813325630201,
            'scale': 1.151,
            'heading': 258.5918096568485
        },
        {
            'lat': 38.89183144282704,
            'lon': -77.41807588239936,
            'scale': 0.887,
            'heading': 171.89431299996988
        },
        {
            'lat': 38.890038907619314,
            'lon': -77.41840636045336,
            'scale': 0.851,
            'heading': 80.80351303323543
        },
        {
            'lat': 38.891769105920886,
            'lon': -77.41884182356667,
            'scale': 0.837,
            'heading': 56.33966981493738
        },
        {
            'lat': 38.88811638842505,
            'lon': -77.42138186035271,
            'scale': 1.162,
            'heading': 329.22360599478725
        },
        {
            'lat': 38.89179775684255,
            'lon': -77.41855879281005,
            'scale': 0.873,
            'heading': 339.405501772291
        },
        {
            'lat': 38.89139442595029,
            'lon': -77.41836149232026,
            'scale': 0.961,
            'heading': 135.3075871252674
        },
        {
            'lat': 38.89227261988008,
            'lon': -77.41836475641622,
            'scale': 1.194,
            'heading': 209.07853488520715
        },
        {
            'lat': 38.891103277646955,
            'lon': -77.41834332917908,
            'scale': 1.147,
            'heading': 149.5089652366927
        },
        {
            'lat': 38.889615523817305,
            'lon': -77.41829547471852,
            'scale': 1.198,
            'heading': 321.4047243375305
        },
        {
            'lat': 38.890928798033094,
            'lon': -77.4188937857458,
            'scale': 0.898,
            'heading': 68.8196581829083
        },
        {
            'lat': 38.8911044013454,
            'lon': -77.41874540826242,
            'scale': 0.84,
            'heading': 92.72898957759307
        },
        {
            'lat': 38.88817066148343,
            'lon': -77.42113227977568,
            'scale': 0.943,
            'heading': 249.4321311987255
        },
        {
            'lat': 38.891939415499344,
            'lon': -77.41882972844137,
            'scale': 0.881,
            'heading': 11.380399872989692
        },
        {
            'lat': 38.89007013766862,
            'lon': -77.41775157515471,
            'scale': 1.027,
            'heading': 186.21042726810566
        },
        {
            'lat': 38.88847477920219,
            'lon': -77.421355260698,
            'scale': 0.824,
            'heading': 277.14570973673955
        },
        {
            'lat': 38.8917263150416,
            'lon': -77.41847674528661,
            'scale': 0.974,
            'heading': 96.50774585090223
        },
        {
            'lat': 38.889992795593535,
            'lon': -77.41867543728927,
            'scale': 1.132,
            'heading': 194.43908020770922
        },
        {
            'lat': 38.891764081538426,
            'lon': -77.41846918949528,
            'scale': 1.0,
            'heading': 12.659103961100007
        },
        {
            'lat': 38.88981371718139,
            'lon': -77.41804486182865,
            'scale': 1.08,
            'heading': 22.193943358110015
        },
        {
            'lat': 38.89103480682991,
            'lon': -77.41855971309828,
            'scale': 0.918,
            'heading': 211.43981304322895
        },
        {
            'lat': 38.89179996779433,
            'lon': -77.4181426736019,
            'scale': 1.011,
            'heading': 126.82101630102179
        },
        {
            'lat': 38.88812481800088,
            'lon': -77.42089485287039,
            'scale': 1.167,
            'heading': 189.51104304488658
        },
        {
            'lat': 38.88954734032897,
            'lon': -77.41820718897335,
            'scale': 0.914,
            'heading': 216.06319801930923
        },
        {
            'lat': 38.89013339433946,
            'lon': -77.41868740515183,
            'scale': 1.003,
            'heading': 255.78052668847036
        },
        {
            'lat': 38.892312609217036,
            'lon': -77.41808803418287,
            'scale': 0.91,
            'heading': 278.72945525261366
        },
        {
            'lat': 38.891994047720715,
            'lon': -77.41870558701083,
            'scale': 0.854,
            'heading': 211.25116819635082
        },
        {
            'lat': 38.88963041498581,
            'lon': -77.41771445001356,
            'scale': 1.063,
            'heading': 125.97022320024445
        },
        {
            'lat': 38.89019554813912,
            'lon': -77.41877795107507,
            'scale': 1.022,
            'heading': 189.7065800103259
        },
        {
            'lat': 38.89077200814738,
            'lon': -77.41870175081013,
            'scale': 1.069,
            'heading': 52.78943552548139
        },
        {
            'lat': 38.8895399268768,
            'lon': -77.41906950584948,
            'scale': 1.022,
            'heading': 336.60722863569083
        },
        {
            'lat': 38.88835808872991,
            'lon': -77.42106391073125,
            'scale': 0.839,
            'heading': 157.37840281206834
        },
        {
            'lat': 38.890677037883854,
            'lon': -77.41841041316212,
            'scale': 1.038,
            'heading': 315.067687601506
        },
        {
            'lat': 38.8918171218393,
            'lon': -77.41849322303672,
            'scale': 0.933,
            'heading': 327.90865492429856
        },
        {
            'lat': 38.89069195560285,
            'lon': -77.41829684676365,
            'scale': 0.905,
            'heading': 162.12875044592985
        },
        {
            'lat': 38.89099448431189,
            'lon': -77.41836506025727,
            'scale': 0.853,
            'heading': 126.76523685896186
        },
        {
            'lat': 38.88949030131356,
            'lon': -77.41890558761453,
            'scale': 1.088,
            'heading': 199.26102238717587
        },
        {
            'lat': 38.888092670358354,
            'lon': -77.42083918885795,
            'scale': 1.025,
            'heading': 307.6370755455087
        },
        {
            'lat': 38.888398438410476,
            'lon': -77.42101819878202,
            'scale': 1.15,
            'heading': 286.01940121528554
        },
        {
            'lat': 38.892178223050315,
            'lon': -77.41804127733441,
            'scale': 0.834,
            'heading': 291.5785014009091
        },
        {
            'lat': 38.89087818114616,
            'lon': -77.41849294138603,
            'scale': 0.951,
            'heading': 105.25670144795039
        },
        {
            'lat': 38.89207427883406,
            'lon': -77.41868262960678,
            'scale': 1.003,
            'heading': 287.41966222685744
        },
        {
            'lat': 38.889613532419844,
            'lon': -77.41836886103998,
            'scale': 0.924,
            'heading': 141.93058104319894
        },
        {
            'lat': 38.88986462738745,
            'lon': -77.418193397478,
            'scale': 0.978,
            'heading': 180.8994246108017
        },
        {
            'lat': 38.891379628086845,
            'lon': -77.41810883660695,
            'scale': 1.051,
            'heading': 260.81418563378594
        },
        {
            'lat': 38.88844177586139,
            'lon': -77.42134601279223,
            'scale': 1.056,
            'heading': 290.26377908744473
        },
        {
            'lat': 38.88957291975838,
            'lon': -77.41836473551926,
            'scale': 0.854,
            'heading': 277.0331045357113
        },
        {
            'lat': 38.89226985303114,
            'lon': -77.4183419030947,
            'scale': 1.003,
            'heading': 77.99952688533088
        },
        {
            'lat': 38.88952597885411,
            'lon': -77.41910135531941,
            'scale': 0.878,
            'heading': 199.21915894487555
        },
        {
            'lat': 38.891796306407045,
            'lon': -77.4181611403773,
            'scale': 1.106,
            'heading': 319.13421431258564
        },
        {
            'lat': 38.891255134741286,
            'lon': -77.4188127002351,
            'scale': 1.137,
            'heading': 207.0011079684409
        },
        {
            'lat': 38.891480638600356,
            'lon': -77.41838516022739,
            'scale': 1.149,
            'heading': 70.07068017845485
        },
        {
            'lat': 38.88993455065837,
            'lon': -77.41795452252522,
            'scale': 1.193,
            'heading': 193.68306137104105
        },
        {
            'lat': 38.88997185202916,
            'lon': -77.41775836645284,
            'scale': 0.805,
            'heading': 275.48461101819885
        },
        {
            'lat': 38.888261166788496,
            'lon': -77.421417609749,
            'scale': 1.04,
            'heading': 45.27285412228572
        },
        {
            'lat': 38.892215304713666,
            'lon': -77.41830112755181,
            'scale': 0.912,
            'heading': 217.09563732873738
        },
        {
            'lat': 38.88958933037702,
            'lon': -77.4185025107776,
            'scale': 0.825,
            'heading': 185.81581447878997
        },
        {
            'lat': 38.889845648168105,
            'lon': -77.4176695487825,
            'scale': 0.803,
            'heading': 166.29680705714458
        },
        {
            'lat': 38.8913674457547,
            'lon': -77.4182604182305,
            'scale': 0.966,
            'heading': 349.2236845758301
        },
        {
            'lat': 38.89222598761052,
            'lon': -77.41849723904382,
            'scale': 1.087,
            'heading': 147.76059723920105
        },
        {
            'lat': 38.88985515836497,
            'lon': -77.41813238573806,
            'scale': 0.873,
            'heading': 91.75148911695986
        },
        {
            'lat': 38.8910425788927,
            'lon': -77.4182789158652,
            'scale': 0.825,
            'heading': 332.57277619736647
        },
        {
            'lat': 38.89052237114624,
            'lon': -77.41851486257562,
            'scale': 0.982,
            'heading': 206.0142832884542
        },
        {
            'lat': 38.89188430312108,
            'lon': -77.41837728584724,
            'scale': 1.063,
            'heading': 35.277967314312704
        },
        {
            'lat': 38.88822000940269,
            'lon': -77.42090534059564,
            'scale': 1.173,
            'heading': 317.21314624883826
        },
        {
            'lat': 38.892098323744186,
            'lon': -77.41869910532722,
            'scale': 1.052,
            'heading': 14.0505446696023
        },
        {
            'lat': 38.89187269947844,
            'lon': -77.4182272029538,
            'scale': 0.867,
            'heading': 22.08514926893837
        },
        {
            'lat': 38.89108935766884,
            'lon': -77.41831795352485,
            'scale': 0.843,
            'heading': 151.78950458205918
        },
        {
            'lat': 38.88998287443983,
            'lon': -77.41769979656716,
            'scale': 1.064,
            'heading': 2.4564983629071646
        },
        {
            'lat': 38.891700115254,
            'lon': -77.41881056884621,
            'scale': 0.898,
            'heading': 145.52182567734363
        },
        {
            'lat': 38.89093419673207,
            'lon': -77.41828015154253,
            'scale': 1.111,
            'heading': 166.4962489206348
        },
        {
            'lat': 38.8908423503623,
            'lon': -77.41855082395058,
            'scale': 1.082,
            'heading': 201.6397115567095
        },
        {
            'lat': 38.88808338890358,
            'lon': -77.42151283882632,
            'scale': 1.157,
            'heading': 304.91037547650876
        },
        {
            'lat': 38.88987305338528,
            'lon': -77.41771766039956,
            'scale': 0.882,
            'heading': 43.45177013533203
        },
        {
            'lat': 38.89084729855385,
            'lon': -77.41823584763856,
            'scale': 1.052,
            'heading': 136.0004447077838
        },
        {
            'lat': 38.89167183838833,
            'lon': -77.41827745906072,
            'scale': 0.817,
            'heading': 59.67148264776219
        },
        {
            'lat': 38.89187890212477,
            'lon': -77.41825452587324,
            'scale': 1.174,
            'heading': 231.61416186500006
        },
        {
            'lat': 38.888443078986896,
            'lon': -77.42117234981414,
            'scale': 0.97,
            'heading': 308.25320112350744
        },
        {
            'lat': 38.888192434592575,
            'lon': -77.42148796392168,
            'scale': 1.195,
            'heading': 130.43947469634742
        },
        {
            'lat': 38.89169758396177,
            'lon': -77.41823115281292,
            'scale': 0.919,
            'heading': 180.89554521554768
        },
        {
            'lat': 38.8920337355111,
            'lon': -77.41788861144062,
            'scale': 1.032,
            'heading': 24.61461585910929
        },
        {
            'lat': 38.890572567734445,
            'lon': -77.41852741694626,
            'scale': 1.094,
            'heading': 96.2145211004516
        },
        {
            'lat': 38.89224917635582,
            'lon': -77.41904713263135,
            'scale': 0.901,
            'heading': 353.25585001580106
        },
        {
            'lat': 38.89199969058144,
            'lon': -77.41884219345633,
            'scale': 0.986,
            'heading': 117.88923081177683
        },
        {
            'lat': 38.89149257873702,
            'lon': -77.41859425283943,
            'scale': 0.822,
            'heading': 238.69361757954852
        },
        {
            'lat': 38.89030613030945,
            'lon': -77.41804431330733,
            'scale': 1.018,
            'heading': 218.42337152958356
        },
        {
            'lat': 38.89106499254614,
            'lon': -77.418025084562,
            'scale': 1.08,
            'heading': 15.90932190779009
        },
        {
            'lat': 38.892109799952124,
            'lon': -77.41863113228752,
            'scale': 0.854,
            'heading': 93.16367243901868
        },
        {
            'lat': 38.89143818774087,
            'lon': -77.4183057760311,
            'scale': 0.973,
            'heading': 96.0603972898974
        },
        {
            'lat': 38.891590580213595,
            'lon': -77.41878815216,
            'scale': 1.116,
            'heading': 67.76830596574753
        },
        {
            'lat': 38.89199804311669,
            'lon': -77.41902035690062,
            'scale': 0.938,
            'heading': 242.78622143356347
        },
        {
            'lat': 38.89063095042054,
            'lon': -77.41814339210829,
            'scale': 0.951,
            'heading': 97.84015991199094
        },
        {
            'lat': 38.89096683606339,
            'lon': -77.41852808213389,
            'scale': 1.038,
            'heading': 87.04373316239361
        },
        {
            'lat': 38.88829001660897,
            'lon': -77.42088542080057,
            'scale': 0.818,
            'heading': 238.15640158735482
        },
        {
            'lat': 38.89059792488751,
            'lon': -77.41859459815798,
            'scale': 0.884,
            'heading': 331.2103349260613
        },
        {
            'lat': 38.892193716332685,
            'lon': -77.4191145501093,
            'scale': 1.075,
            'heading': 96.08676510744387
        },
        {
            'lat': 38.89154731284414,
            'lon': -77.41882955191375,
            'scale': 0.849,
            'heading': 42.18135402968876
        },
        {
            'lat': 38.89052735476112,
            'lon': -77.41816957722592,
            'scale': 0.94,
            'heading': 136.03344833915565
        },
        {
            'lat': 38.89124406267455,
            'lon': -77.41881347993646,
            'scale': 1.174,
            'heading': 218.31826866703585
        },
        {
            'lat': 38.89215392809638,
            'lon': -77.41799002861293,
            'scale': 1.063,
            'heading': 178.25567550306997
        },
        {
            'lat': 38.88992108102069,
            'lon': -77.41802737651219,
            'scale': 0.837,
            'heading': 153.44591234061886
        },
        {
            'lat': 38.89158229653758,
            'lon': -77.41861715948066,
            'scale': 0.926,
            'heading': 63.97648756070414
        },
        {
            'lat': 38.8905150735282,
            'lon': -77.4187495715679,
            'scale': 1.17,
            'heading': 172.6290730169207
        },
        {
            'lat': 38.890201148383106,
            'lon': -77.41775035971149,
            'scale': 0.844,
            'heading': 213.21365958686528
        },
        {
            'lat': 38.89130102449156,
            'lon': -77.41846217101843,
            'scale': 1.08,
            'heading': 62.56156847112875
        },
        {
            'lat': 38.891972012241375,
            'lon': -77.41821630869302,
            'scale': 1.133,
            'heading': 114.17625614065103
        },
        {
            'lat': 38.89050343467052,
            'lon': -77.41814058585298,
            'scale': 1.074,
            'heading': 266.72332229968424
        },
        {
            'lat': 38.89150716443491,
            'lon': -77.41864610653452,
            'scale': 0.998,
            'heading': 125.46696703561663
        },
        {
            'lat': 38.89204150280453,
            'lon': -77.41788413460239,
            'scale': 1.079,
            'heading': 232.67498874001294
        },
        {
            'lat': 38.892100528174716,
            'lon': -77.41815518532266,
            'scale': 0.847,
            'heading': 359.4599350991207
        }
    ]
};
